/**
 *
 * Schema
 *
 */

 import React from "react"
 import { Badge } from "reactstrap"
 import moment from "moment"
 import { isEmpty } from "lodash"
 import EmployeeHeader from "pages/ViewEmployee/EmployeeHeader"
 import { useHistory } from "react-router-dom"
 import de23df0b from "store/de23df0b"
 import TWFuYWdlRWM from "store/TWFuYWdlRWM"
 import e420b937 from "store/e420b937"
 import ac9d12c2 from "store/ac9d12c2"
 import c291cmNl from "store/c291cmNl"
 import c3RhdHVz from "store/c3RhdHVz"
 import c3Vic291 from "store/c3Vic291"
 import cHJpb3Jp from "store/cHJpb3Jp"
 import c2Vydmlj from "store/c2Vydmlj"
 import y3VzdG9t from "store/y3VzdG9t"
 import zXZlbnQq from "store/zXZlbnQq"
 import bXVodXJ0 from "store/bXVodXJ0"
 import ZmFtaWx5 from "store/ZmFtaWx5"
 import ZW1wbG95 from "store/ZW1wbG95"
 import d29ya2V4 from "store/d29ya2V4"
 import YmFuaw from "store/YmFuaw"
 import a3lj from "store/a3lj"
 import cmVjZWl2 from "store/cmVjZWl2"
 import cmVwb3J0 from "store/cmVwb3J0"
 import cXVlc3Rp from "store/cXVlc3Rp"
 import api from '../helpers/Api'
 import cmVmZXJl from 'store/cmVmZXJl'
 import { Label } from 'reactstrap'
 import OtpForm from './../components/OtpForm'
 import aGlrZQ from 'store/aGlrZQ'
 import dmlld2Vt from 'store/dmlld2Vt'
 import b3RoZXJf from 'store/b3RoZXJf'
 import RW1wbG95 from 'store/RW1wbG95'
 import ZXF1aXBtZ from 'store/ZXF1aXBtZ'
 import ZXF1aXBtZW50X2 from 'store/ZXF1aXBtZW50X2'
 import cHJvZHVjdCB2 from 'store/cHJvZHVjdCB2'
 import ZXF1aXBtZW50 from 'store/ZXF1aXBtZW50'
 import bXlCb29raW5nQ29tcGxldGU from 'store/bXlCb29raW5nQ29tcGxldGU'
 
 //SL CL Based employee record
 import ZW1wbG95ZWUtcmVjb3Jk from 'store/ZW1wbG95ZWUtcmVjb3Jk'
 import bXljbGllbnRlYw from 'store/bXljbGllbnRlYw'
 
 //Clearance Level
 import Y2xlYXJhbmNlTGV2ZWwx from 'store/Y2xlYXJhbmNlTGV2ZWwx'
 import Y2xlYXJhbmNl from 'store/Y2xlYXJhbmNl'
 import c2F2ZXRoZXBob3Rv from 'store/c2F2ZXRoZXBob3Rv'
 import c2F2ZXRoZXZpZGVv from 'store/c2F2ZXRoZXZpZGVv'
 import c2F2ZXRoZXBvc3Q from 'store/c2F2ZXRoZXBvc3Q'
 
 //Equipment mapping
 import RXF1aXBtZW50TWFwcGluZw from 'store/RXF1aXBtZW50TWFwcGluZw'
 import ZXF1aXBtZW50VW5NYXBw from 'store/ZXF1aXBtZW50VW5NYXBw'
 import c3ViZnJlZWxhbmNlcg from 'store/c3ViZnJlZWxhbmNlcg'
 
 //Report
 import b2ZmZXJSZXBvcnQ from 'store/b2ZmZXJSZXBvcnQ'
 import c291cmNlUmVwb3J0 from 'store/c291cmNlUmVwb3J0'
 import Zm9sbG93dXBGZWVkYmFjaw from 'store/Zm9sbG93dXBGZWVkYmFjaw'
 import ZXZlbnRDYWxlbmRhcg from 'store/ZXZlbnRDYWxlbmRhcg'
 import ZXF1aXBtZW50YXVkaXRyZXBvcnQ from 'store/ZXF1aXBtZW50YXVkaXRyZXBvcnQ'
 import ZG93bmxvYWRxcg from 'store/ZG93bmxvYWRxcg'
 
 import ZW1wbG95ZWVFcXVpcG1lbnQ from 'store/ZW1wbG95ZWVFcXVpcG1lbnQ'
 //Equipment Mapped List
 import ZXF1aXBtZW50TWFwcGVkSHI from 'store/ZXF1aXBtZW50TWFwcGVkSHI'
 import ZXF1aXBtZW50QWRtaW4 from 'store/ZXF1aXBtZW50QWRtaW4'
 import ZXF1aXBtZW50UGhvdG9ncm from 'store/ZXF1aXBtZW50UGhvdG9ncm'
 import ZXF1aXBtZW50SXQ from 'store/ZXF1aXBtZW50SXQ'
 import ZXF1aXBtZW50VmVybWlsaW9u from 'store/ZXF1aXBtZW50VmVybWlsaW9u'
 import ZXF1aXBtZW50RGl2aW5l from 'store/ZXF1aXBtZW50RGl2aW5l'
 import ZXF1aXBtZW50U2VydmljZQ from 'store/ZXF1aXBtZW50U2VydmljZQ'
 import Y2hlY2tsaX from 'store/Y2hlY2tsaX'
 import ZWNzZXJ2aWNl from 'store/ZWNzZXJ2aWNl'
 import aW52ZW50b3J5TGlzdA from 'store/aW52ZW50b3J5TGlzdA'
 import emdPcGVyYXRpb25z from 'store/emdPcGVyYXRpb25z'
 import bXlXb3Jrc1FjQ29t from 'store/bXlXb3Jrc1FjQ29t'
//  import bXl3b3Jrc3Bob3Rv from 'store/bXl3b3Jrc3Bob3Rv'
 
 //Operations
 import cG9zdHZpZGVv from 'store/cG9zdHZpZGVv'
 import cG9zdGFsYnVt from 'store/cG9zdGFsYnVt'
 import bXl3b3Jrc3Bob3Rv from 'store/bXl3b3Jrc3Bob3Rv'
 import bXl3b3Jrc3JldG91Y2g from 'store/bXl3b3Jrc3JldG91Y2g'
 import bXl3b3Jrc2FsYnVt from 'store/bXl3b3Jrc2FsYnVt'
 import bXlUZWFtU2NoZWR1bGU from 'store/bXlUZWFtU2NoZWR1bGU'
 import bXlFcXVpcG1lbnRTY2hlZHVsZQ from 'store/bXlFcXVpcG1lbnRTY2hlZHVsZQ'
 import bXljbGllbnRzYXZldGhlcGh from 'store/bXljbGllbnRzYXZldGhlcGh'
 import bXljbGllbnRzYXZldGhldm from 'store/bXljbGllbnRzYXZldGhldm'
 import bXljbGllbnRhbGJ1 from 'store/bXljbGllbnRhbGJ1'
 import bXljbGllbnR2aWRl from 'store/bXljbGllbnR2aWRl'
 import bXljbGllbnRyZX from 'store/bXljbGllbnRyZX'
 import cG9zdGNybWZyYW1l from 'store/cG9zdGNybWZyYW1l'
 import cG9zdGNybW1hZ2F6aW5l from 'store/cG9zdGNybW1hZ2F6aW5l'
 import Y3JtTWFuYWdlQ2xpZW50 from 'store/Y3JtTWFuYWdlQ2xpZW50'
 import Y3JtVW5Bc3NpZ25lZA from 'store/Y3JtVW5Bc3NpZ25lZA'
 import Y3JtTXlDbGllbnQ from 'store/Y3JtTXlDbGllbnQ'
 import bXlDbGllbnRDaGFuZ from 'store/bXlDbGllbnRDaGFuZ'
 import bXlDbGllbnRSZXdvcmt from 'store/bXlDbGllbnRSZXdvcmt'
 import bXlDbGllbnRNYWdhem from 'store/bXlDbGllbnRNYWdhem'
 import bXlDbGllbnRPZ from 'store/bXlDbGllbnRPZ'
 import bXlDbGllbnRGcm from 'store/bXlDbGllbnRGcm'
 import bXlDbGllbnRDYW5k from 'store/bXlDbGllbnRDYW5k'
 import bXlDbGllbnRDb2 from 'store/bXlDbGllbnRDb2'
 import bXlXb3Jrc1BlbmRpbmdD from 'store/bXlXb3Jrc1BlbmRpbmdD'
 import bXlXb3Jrc1BlbmRpbmdSZX from 'store/bXlXb3Jrc1BlbmRpbmdSZX'
 import cG9zdENybUNh from 'store/cG9zdENybUNh'
 import cG9zdENybUNvbG9 from 'store/cG9zdENybUNvbG9'
 import cG9zdENybU9 from 'store/cG9zdENybU9'
 import cHJlQ2hhbmdlc0l from 'store/cHJlQ2hhbmdlc0l'
 import cHJlUWNQZW5kaW5n from 'store/cHJlUWNQZW5kaW5n'
 import cHJlUmV3b3JrSW5Q from 'store/cHJlUmV3b3JrSW5Q'
 import cG9zdFFjUGVuZG from 'store/cG9zdFFjUGVuZG'
 import cG9zdENoYW5nZXN from 'store/cG9zdENoYW5nZXN'
 import cG9zdFJld29ya0l from 'store/cG9zdFJld29ya0l'

 //Tickets
 import cmFpc2VUaWNrZXQ from 'store/cmFpc2VUaWNrZXQ'
 import bWFuYWdlSW5wcm9ncmVzcw from 'store/bWFuYWdlSW5wcm9ncmVzcw'
 
 //High value lead
 import bWFuYWdlSGlnaFZhbHV from 'store/bWFuYWdlSGlnaFZhbHV'
 import aGlnaFZhbHVlU3VtbWFyeQ from 'store/aGlnaFZhbHVlU3VtbWFyeQ'
 import bXlIaWdoVmFsdWVMZWFk from 'store/bXlIaWdoVmFsdWVMZWFk'
 import bXlDbGllbnRRY1B from 'store/bXlDbGllbnRRY1B'
 
 //Year wise Employee Record
 import eWVhckVtcGxveWVlUmVjb3Jk from 'store/eWVhckVtcGxveWVlUmVjb3Jk'
 import d29ya2Zyb21ob21l from 'store/d29ya2Zyb21ob21l'

 //Event co ordinations
 import c3BlY2lhbGlu from 'store/c3BlY2lhbGlu'
 import ZXF1aXBtZW50X from 'store/ZXF1aXBtZW50X'
 import ZWNDbGllbnRDaGVja2xpc3Q from 'store/ZWNDbGllbnRDaGVja2xpc3Q'
 import ZWNUZWFtU2NoZWR1bGl from 'store/ZWNUZWFtU2NoZWR1bGl'
 import ZWNGb2xsb3d1cA from 'store/ZWNGb2xsb3d1cA'
 import bXl3b3Jrcw from 'store/bXl3b3Jrcw'
 import ZXZlbnRDb21wbGV0ZWQ from "store/ZXZlbnRDb21wbGV0ZWQ"
 import eWVhcldpc2VFdmVudHM from "store/eWVhcldpc2VFdmVudHM"
 import ZnJlZWxhbmNlclJlcG9ydA from "store/ZnJlZWxhbmNlclJlcG9ydA"

 //OBS Details
 import bWFuYWdlLW9icw from 'store/bWFuYWdlLW9icw'
 import bXlvYnM from 'store/bXlvYnM'
 import bGVhZG9jY3VycmVk from 'store/bGVhZG9jY3VycmVk'
 import cmVqZWN0ZWRsZWFk from 'store/cmVqZWN0ZWRsZWFk'
 import bWFuYWdlb2JzbGVhZA from 'store/bWFuYWdlb2JzbGVhZA'
 import bXlvYnNsZWFk from 'store/bXlvYnNsZWFk'

 
 import ZXF1aXBtZW50VHJhc2g from 'store/ZXF1aXBtZW50VHJhc2g'
 import cHJvZHVjdF9jYX from 'store/cHJvZHVjdF9jYX'

 //Equipment Audit
 import ZXF1aXBtZW50QXVkaXQ from 'store/ZXF1aXBtZW50QXVkaXQ'

 //General 
 import c21zVGVtcGxhdGUK from 'store/c21zVGVtcGxhdGUK'
 import ZW1haWxfdGVtcGxhdghj from 'store/ZW1haWxfdGVtcGxhdghj'
 //import b3BlcmF0aW9uc01hbmFnZUZvbGx from "store/b3BlcmF0aW9uc01hbmFnZUZvbGx"
 import "../schema/styles.scss"

 const schemaExt = [
   // Document
   {
     schemaId: "e420b937",
     name: "Document",
     title: "Document List",
     formTitle: "Document List",
     path: "/document",
     visible: true,
     ...e420b937,
     page: "Document",
     exact: true,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Action",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "documentName",
         label: "Document Name",
         placeholder: "Enter Document Name",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         formatter: (cellContent, row)=> {
            return <>
             <span style={{textTransform: "uppercase"}}>{row.documentName}</span>
            </>
         },
         type: "textOnly",
        validations: "textOnly"
       },
       {
         id: "5",
         value: "description",
         label: "Description",
         placeholder: "Enter Description ",
         sort: true,
         editRecord: true,
         viewRecord: true,
         formatter: (cellContent, row)=> {
          return <>
           <span style={{textTransform: "uppercase"}}>{row.description}</span>
          </>
       },
         type: "text",
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={
                `font-size-12 badge rounded-pill ${
                  row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                }`
               }
               color={row.badgeclass}
               pill
             >
               {row.status === 1 ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   {
     schemaId: "TWFuYWdlRWM",
     name: "manageEc",
     title: "Manage Ec",
     formTitle: "Manage Ec",
     path: "/manage-ec",
     visible: true,
     ...TWFuYWdlRWM,
     page: "ManageEc",
     exact: true,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Action",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "documentName",
         label: "Document Name",
         placeholder: "Enter Document Name",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         formatter: (cellContent, row)=> {
            return <>
             <span style={{textTransform: "uppercase"}}>{row.documentName}</span>
            </>
         },
         type: "textOnly",
        validations: "textOnly"
       },
       {
         id: "5",
         value: "description",
         label: "Description",
         placeholder: "Enter Description ",
         sort: true,
         editRecord: true,
         viewRecord: true,
         formatter: (cellContent, row)=> {
          return <>
           <span style={{textTransform: "uppercase"}}>{row.description}</span>
          </>
       },
         type: "text",
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={
                `font-size-12 badge rounded-pill ${
                  row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                }`
               }
               color={row.badgeclass}
               pill
             >
               {row.status === 1 ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   {
    schemaId: "ZXZlbnRDb21wbGV0ZWQ",
    name: "eventCompleted",
    title: "Event Completed",
    formTitle: "Event Completed",
    path: "/event-completed-list",
    visible: true,
    ...ZXZlbnRDb21wbGV0ZWQ,
    page: "EventCompleted",
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "documentName",
        label: "Document Name",
        placeholder: "Enter Document Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row)=> {
           return <>
            <span style={{textTransform: "uppercase"}}>{row.documentName}</span>
           </>
        },
        type: "textOnly",
       validations: "textOnly"
      },
      {
        id: "5",
        value: "description",
        label: "Description",
        placeholder: "Enter Description ",
        sort: true,
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent, row)=> {
         return <>
          <span style={{textTransform: "uppercase"}}>{row.description}</span>
         </>
      },
        type: "text",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={
               `font-size-12 badge rounded-pill ${
                 row.status === 1
                   ? "bg-success badge-soft-success"
                   : "bg-danger badge-soft-danger"
               }`
              }
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
   {
    schemaId: "eWVhcldpc2VFdmVudHM",
    name: "yearWiseEvents",
    title: "Year Wise Events Record",
    formTitle: "Year Wise Events Record",
    path: "/year-event-record",
    visible: true,
    ...eWVhcldpc2VFdmVudHM,
    page: "YearWiseEventsRecord",
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "documentName",
        label: "Document Name",
        placeholder: "Enter Document Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row)=> {
           return <>
            <span style={{textTransform: "uppercase"}}>{row.documentName}</span>
           </>
        },
        type: "textOnly",
       validations: "textOnly"
      },
      {
        id: "5",
        value: "description",
        label: "Description",
        placeholder: "Enter Description ",
        sort: true,
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent, row)=> {
         return <>
          <span style={{textTransform: "uppercase"}}>{row.description}</span>
         </>
      },
        type: "text",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={
               `font-size-12 badge rounded-pill ${
                 row.status === 1
                   ? "bg-success badge-soft-success"
                   : "bg-danger badge-soft-danger"
               }`
              }
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
   {
     schemaId: "bXlUZWFtU2NoZWR1bGU",
     name: "myTeamSchedule",
     title: "My Team Schedule",
     formTitle: "My Team Schedule",
     path: "/my-team-schedule",
     visible: true,
     ...bXlUZWFtU2NoZWR1bGU,
     page: "MyTeamSchedule",
     exact: true,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Action",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "documentName",
         label: "Document Name",
         placeholder: "Enter Document Name",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         formatter: (cellContent, row)=> {
            return <>
             <span style={{textTransform: "uppercase"}}>{row.documentName}</span>
            </>
         },
         type: "textOnly",
        validations: "textOnly"
       },
       {
         id: "5",
         value: "description",
         label: "Description",
         placeholder: "Enter Description ",
         sort: true,
         editRecord: true,
         viewRecord: true,
         formatter: (cellContent, row)=> {
          return <>
           <span style={{textTransform: "uppercase"}}>{row.description}</span>
          </>
       },
         type: "text",
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={
                `font-size-12 badge rounded-pill ${
                  row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                }`
               }
               color={row.badgeclass}
               pill
             >
               {row.status === 1 ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   {
     schemaId: "bXlFcXVpcG1lbnRTY2hlZHVsZQ",
     name: "myEquipmentSchedule",
     title: "My equipment Schedule",
     formTitle: "My equipment Schedule",
     path: "/my-equipment-schedule",
     visible: true,
     ...bXlFcXVpcG1lbnRTY2hlZHVsZQ,
     page: "MyEquipmentSchedule",
     exact: true,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Action",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "documentName",
         label: "Document Name",
         placeholder: "Enter Document Name",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         formatter: (cellContent, row)=> {
            return <>
             <span style={{textTransform: "uppercase"}}>{row.documentName}</span>
            </>
         },
         type: "textOnly",
        validations: "textOnly"
       },
       {
         id: "5",
         value: "description",
         label: "Description",
         placeholder: "Enter Description ",
         sort: true,
         editRecord: true,
         viewRecord: true,
         formatter: (cellContent, row)=> {
          return <>
           <span style={{textTransform: "uppercase"}}>{row.description}</span>
          </>
       },
         type: "text",
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={
                `font-size-12 badge rounded-pill ${
                  row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                }`
               }
               color={row.badgeclass}
               pill
             >
               {row.status === 1 ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   {
     schemaId: "bXljbGllbnRlYw",
     name: "myClientEc",
     title: "My Client Ec",
     formTitle: "My Client Ec",
     path: "/my-client",
     visible: true,
     ...bXljbGllbnRlYw,
     page: "MyClientEc",
     exact: true,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Action",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "documentName",
         label: "Document Name",
         placeholder: "Enter Document Name",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         formatter: (cellContent, row)=> {
            return <>
             <span style={{textTransform: "uppercase"}}>{row.documentName}</span>
            </>
         },
         type: "textOnly",
        validations: "textOnly"
       },
       {
         id: "5",
         value: "description",
         label: "Description",
         placeholder: "Enter Description ",
         sort: true,
         editRecord: true,
         viewRecord: true,
         formatter: (cellContent, row)=> {
          return <>
           <span style={{textTransform: "uppercase"}}>{row.description}</span>
          </>
       },
         type: "text",
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={
                `font-size-12 badge rounded-pill ${
                  row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                }`
               }
               color={row.badgeclass}
               pill
             >
               {row.status === 1 ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
  //  Question
  {
    schemaId: "ac9d12c2",
    name: 'Question',
    title: 'Question List',
    formTitle: 'Question List',
    path: '/questionslist',

    visible: true,
    ...ac9d12c2,
    page: 'Questionnaire',
    exact: true,
    columns: () => [
        {
            id: "1",
            value: '_id',
            label: 'Id',
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: 'text'
        },
        {
            id: "2",
            value: 'sno',
            label: 'S.No',
            sort: false,
            editRecord: false,
            viewRecord: true,
            formatter: (cellContent, row, rowIndex) => row.loading ? (
                <p className="card-text placeholder-glow">
                    <span className="placeholder col-7"></span>
                </p>
            ) : rowIndex + 1,
            type: 'text'
        },
        {
            id: "3",
            value: 'actions',
            label: 'Action',
            sort: false,
            editRecord: false,
            viewRecord: true,
            editFormatter: 'actions',
            type: 'text'
        },
        {
            id: "4",
            value: 'question',
            label: 'Question',
            placeholder: 'Enter question',
            sort: true,
            editRecord: true,
            viewRecord: true,
            required: true,
            formatter: (cellContent, row) => {
             return <span style={{textTransform: "uppercase"}}>{row.question} </span>
             },
            type: 'text'
        },
        {
            id: "5",
            value: 'option1',
            label: 'Option 1',
            sort: true,
            editRecord: true,
            viewRecord: true,
            formatter: (cellContent, row) => row.loading ? (
                <p className="card-text placeholder-glow">
                    <span className="placeholder col-7"></span>
                </p>
            ) : (
                <p>
                    <span style={{textTransform: "uppercase"}}>{row.option1}</span>
                </p>

            ),
            type: 'text'
        },
        {
            id: "6",
            value: 'option2',
            label: 'Option 2',
            sort: true,
            editRecord: true,
            viewRecord: true,
            formatter: (cellContent, row) => row.loading ? (
                <p className="card-text placeholder-glow">
                    <span className="placeholder col-7"></span>
                </p>
            ) : (
                <p>
                   <span style={{textTransform: "uppercase"}}>{row.option2}</span>
                </p>

            ),
            type: 'text'
        },
        {
            id: "5",
            value: 'option3',
            label: 'Option 3',
            sort: true,
            editRecord: true,
            viewRecord: true,
            formatter: (cellContent, row) => row.loading ? (
                <p className="card-text placeholder-glow">
                    <span className="placeholder col-7"></span>
                </p>
            ) : (
                <p>
                    <span style={{textTransform: "uppercase"}}>{row.option3}</span>
                </p>

            ),
            type: 'text'
        },
        {
            id: "5",
            value: 'option4',
            label: 'Option 4',
            sort: true,
            editRecord: true,
            viewRecord: true,
            formatter: (cellContent, row) => row.loading ? (
                <p className="card-text placeholder-glow">
                    <span className="placeholder col-7"></span>
                </p>
            ) : (
                <p>
                    <span style={{textTransform: "uppercase"}}>{row.option4}</span>
                </p>

            ),
            type: 'text'
        },
        {
            id: "6",
            value: 'answer',
            label: 'Answer',
            sort: true,
            editRecord: false,
            viewRecord: false,
            formatter: (cellContent, row) => row.loading ? (
                <p className="card-text placeholder-glow">
                    <span className="placeholder col-7"></span>
                </p>
            ) : (
                <p>
                    <span style={{textTransform: "uppercase"}}>{row.answer}</span>
                </p>

            ),
            type: 'text'
        },
        {
            id: "7",
            value: 'status',
            label: 'Status',
            sort: false,
            editRecord: false,
            viewRecord: true,
            formatter: (cellContent, row) => row.loading ? (
                <p className="card-text placeholder-glow">
                    <span className="placeholder col-7"></span>
                </p>
            ) : (
             <Badge
             className={`font-size-12 badge rounded-pill ${row.status === 1
               ? "bg-success badge-soft-success"
               : "bg-danger badge-soft-danger"
               }`}
             color={row.badgeclass}
             pill
           >
             {row.status === 1 ? "Active" : "Inactive"}
           </Badge>
            ),
            type: 'text'
        },
        {
            id: "8",
            value: 'branches',
            label: 'Branches',
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: 'text'
        },
        {
            id: "9",
            value: 'insertedBy',
            label: 'Inserted By',
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: 'text'
        },
        {
            id: "10",
            value: 'updatedBy',
            label: 'Updated By',
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: 'text'
        },
        {
            id: "11",
            value: 'createdAt',
            label: 'Created Date',
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: 'text'
        },
        {
            id: "12",
            value: 'updatedAt',
            label: 'Updated Date',
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: 'text'
        }
    ]
},
   // Factor
   {
     schemaId: "de23df0b",
     name: "Factor",
     title: "Two Factor Authentication",
     formTitle: "Two Factor Authentication",
     path: "/twofactorautentication",
     visible: true,
     ...de23df0b,
     page: "Factor",
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Action",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "factorName",
         label: "Factor Name",
         placeholder: "Enter Factor Name",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
            <span style={{textTransform: "uppercase"}} > {row.factorName}</span>
           ),
           type: "textOnly",
           validations: "textOnly",
       },
       {
         id: "5",
         value: "description",
         label: "Description",
         placeholder: "Enter Description",
         sort: true,
         editRecord: true,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <span style={{textTransform: "uppercase"}} >{row.description}</span>
           ),
           
         type: "text",
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${row.status === 1
                 ? "bg-success badge-soft-success"
                 : "bg-danger badge-soft-danger"
                 }`}
               color={row.badgeclass}
               pill
             >
               {row.status === 1 ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   //question_list
   {
    schemaId: "cXVlc3Rp",
    name: 'question_list',
    title: 'Question List',
    path: '/question_list',
    visible: true,
    formTitle: 'Question List',
    page: "Question",
    ...cXVlc3Rp,
    columns: (record = {}) => {
        return [
            {
                id: "1",
                value: '_id',
                label: 'Id',
                sort: false,
                editRecord: false,
                viewRecord: false,
                type: 'text'
            },
            {
                id: "2",
                value: 'sno',
                label: 'S.No',
                sort: false,
                editRecord: false,
                viewRecord: true,
                formatter: (cellContent, row, rowIndex) => row.loading ? (
                    <p className="card-text placeholder-glow">
                        <span className="placeholder col-7"></span>
                    </p>
                ) : rowIndex + 1,
                type: 'text'
            },
            {
                id: "3",
                value: 'actions',
                label: 'Actions',
                sort: false,
                editRecord: false,
                viewRecord: true,
                editFormatter: 'actions',
                type: 'text'
            },
            {
                id: "4",
                value: 'type',
                label: 'Type',
                placeholder: 'Select Type',
                sort: true,
                editRecord: true,
                viewRecord: true,
                required: true,
                validationType: 'Question',
                type: 'select',
                colProps: {
                    lg: "12",
                    md: "12",
                    style: { paddingRight: '15px' }
                },
                formatter: (cellContent) => {
                    const options = [
                        {
                            label: 'QUESTION',
                            value: 'description'
                        },
                        {
                            label: 'FILL UP',
                            value: 'fillup'
                        },
                        {
                            label: 'CHOOSE THE BEST',
                            value: 'choose'
                        },
                    ]
                    return cellContent && options.find(_ => _.value.toString() === cellContent.toString()) && options.find(_ => _.value === cellContent).label || ''
                },
                options: [
                    {
                        label: 'QUESTION',
                        value: 'description'
                    },
                    {
                        label: 'FILL UP',
                        value: 'fillup'
                    },
                    {
                        label: 'CHOOSE THE BEST',
                        value: 'choose'
                    },
                ]
            }, 
            {
                id: "4",
                value: 'question',
                label: 'Question',
                placeholder: 'Enter Question',
                sort: true,
                editRecord: true,
                viewRecord: true,
                required: true,
                type: 'textarea',
                colProps: {
                    lg: "12",
                    md: "12",
                    style: { paddingRight: '15px' }
                },
            },
            {
                id: "4",
                value: 'choose',
                label: 'Choose Option',
                placeholder: 'Enter Choose Option',
                sort: true,
                editRecord: record.type === 'choose' ? true : false,
                viewRecord: true,
                type: 'chooseOption',
                colProps: {
                    lg: "12",
                    md: "12",
                    style: { paddingRight: '15px' }
                },
                formatter: (cellContent) => {
                    // console.log(cellContent[0], cellContent[0]?.option, row)
                    return (cellContent && cellContent[0] ?
                        <p>
                            <span>{cellContent[0]?.option}, {cellContent[1]?.option}, {cellContent[2]?.option}, {cellContent[3]?.option}, {cellContent[4]?.option}, {cellContent[5]?.option}</span>
                        </p>
                        :
                        <p>-</p>
                    )
                }
            },

            {
                id: "4",
                value: 'mandatory',
                label: 'Mandatory',
                placeholder: 'Select Mandatory',
                 sort: true,
                editRecord: true,
                viewRecord: true,
                // required: true,
                type: 'checkbox',
                colProps: {
                    lg: "3",
                    md: "3",
                    style: { paddingRight: '15px', marginTop: "26px" }
                },
                formatter: (cellContent, row) => {
                 return (
                   <span style={{ textTransform: "uppercase" }}>
                     {row.mandatory === 1 ? "YES" : "NO"}
                   </span>)
               },
            },
            {
              id: "4",
              value: 'module',
              label: 'Module',
              placeholder: 'Select Module',
               sort: true,
              editRecord: true,
              viewRecord: true,
              required: true,
              type: 'select',
              formatter: (cellContent, row) => {
               return (
                 <span style={{ textTransform: "uppercase" }}>
                   {row.module}
                 </span>)
             },
             options: [
              {
              label: "Sales",
              value: "sales"
             },
              {
              label: "EC",
              value: "ec"
             },
              {
              label: "HRMS",
              value: "hrms"
             },
            ]
          },
            {
                id: "4",
                value: 'mode',
                label: 'Mode',
                placeholder: 'Select Mode',
                sort: true,
                editRecord: record.type === 'choose' ? true : false,
                viewRecord: true,
                // required: true,
                type: 'radio',
                colProps: {
                    lg: "9",
                    md: "9",
                    style: { paddingRight: '15px', marginTop: "" }
                },
                options: [

                    {
                        label: 'SINGLE',
                        value: 'single'
                    },
                    {
                        label: 'MULTIPLE',
                        value: 'multiple'
                    }
                ],
                formatter: (cellContent) => {
                    // console.log(cellContent, row)
                    return (cellContent&&cellContent === 'single' ?
                        <p>SINGLE</p>
                        :
                        (cellContent&&cellContent === 'multiple' ? <p>MULTIPLE</p> : <p>-</p>)
                    )
                }
            },
            {
                id: "14",
                value: 'status',
                label: 'Status',
                sort: false,
                editRecord: false,
                viewRecord: true,
                formatter: (cellContent, row) => row.loading ? (
                    <p className="card-text placeholder-glow">
                        <span className="placeholder col-7"></span>
                    </p>
                ) : (
                    <Badge
                        className={`font-size-12 badge rounded-pill ${row?.status === 1 ? 'bg-success badge-soft-success' : 'bg-danger badge-soft-danger'}`}
                        color={row?.badgeclass}
                        pill>
                        {row.status === 1 ? 'Active' : 'Inactive'}
                    </Badge>
                ),
                type: 'text'
            },
            {
                id: "15",
                value: 'insertedBy',
                label: 'Inserted By',
                sort: false,
                editRecord: false,
                viewRecord: false,
                type: 'text'
            },
            {
                id: "16",
                value: 'updatedBy',
                label: 'Updated By',
                sort: false,
                editRecord: false,
                viewRecord: false,
                type: 'text'
            },
            {
                id: "17",
                value: 'createdAt',
                label: 'Created Date',
                sort: false,
                editRecord: false,
                viewRecord: false,
                type: 'text'
            },
            {
                id: "18",
                value: 'updatedAt',
                label: 'Updated Date',
                sort: false,
                editRecord: false,
                viewRecord: false,
                type: 'text'
            }
        ]
    }
},
    // source
    {
      schemaId: "c291cmNl",
      name: "source",
      title: "Source List",
      formTitle: "Source List",
      path: "/source",
      visible:  true,
      ...c291cmNl,
      page: "Source",
      exact: true,
      columns: (records = [], metaData) => {
  
        console.log(records, "record from api")
        
        const codeValueMetaData = metaData && metaData.codeOptions
        
     console.log(codeValueMetaData, "codeValueMetaData")
      
        return[
      
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          label: "Source Code",
          autofillValue: codeValueMetaData,
          placeholder: "Enter Source Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "code",
        },
        {
          id: "5",
          value: "sourceName",
          label: "Source Name",
          placeholder: "Enter Source Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          
          type: "text",
          formatter: (cellContent, row) => {
            console.log(row, "row from api")
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
              </>
            )},},
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]},
    },
  // process_status
  {
    schemaId: "c3RhdHVz",
    name: "process_status",
    title: "Process Status",
    formTitle: "Process Status",
    path: "/processstatus",
    visible: true,
    ...c3RhdHVz,
    page: "ProcessStatus",
    exact: true,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")
      
      const codeValueMetaData = metaData && metaData.codeOptions
      
   console.log(codeValueMetaData, "codeValueMetaData")
    

      return[
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "processStatus",
        label: "Process Status",
        placeholder: "Enter Process Status",
        required: true,
        sort: true,
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.processStatus}</p>
            </>
          )},
        type: "text",
      },
      {
        id: "5",
        value: "shortCode",
        label: "Short Code ",
        autofillValue: codeValueMetaData,
        placeholder: "Enter Short Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
       // required: true,
        type: "code",
      },
      {
        id: "6",
        value: "description",
        label: "Description",
        placeholder: "Enter Description",
        required:true,
        sort: true,
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.description}</p>
            </>
          )},
        type: "text",
      },
     
      {
        id: "7",
        value: "colorCode",
        label: "Color Code ",
        placeholder: "Enter Color Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.colorCode}</p>
            </>
          )},
        type: "text",
      },
      {
        id: "14",
        value: "processStatusId",
        label: "Unique Code ",
        placeholder: "Enter Unique Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.processStatusId}</p>
            </>
          )},
        type: "text",
      },
      {
        id: "15",
        value: "mode",
        label: "Mode",
        placeholder: "Enter Mode",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.mode}</p>
            </>
          )},
        type: "text",
      },
      {
        id: "8",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status===1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status===1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "9",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "12",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "13",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
     
    ]},
  },
  // sub_source
// sub_source
{
  schemaId: "c3Vic291",
  name: "sub_source",
  title: "Sub Source List",
  formTitle: "Sub Source List",
  path: "/subsource",
  visible: true,
  ...c3Vic291,
  page: "SubSource",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        label: "Sub Source Code",
        autofillValue: codeValueMetaData,
        placeholder: "Enter Sub Source Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "code",
      },
      {
        id: "5",
        value: "subSourceName",
        label: " Sub Source Name",
       
        placeholder: "Enter Sub Source Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.subSourceName}</p>
            </>
          )},
        type: "text",
      },
      {
        id: "5",
        value: "sourceId",
        label: "Source Name",
        placeholder: "Enter Source Id Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
             
              <span style={{ textTransform: "uppercase" }}>{metaData &&
                metaData.sourceOptions &&
                metaData.sourceOptions.length > 0 &&
                metaData.sourceOptions.find(
                  (_) => _.value.toString() === cellContent.toString()
                ) &&
                metaData.sourceOptions.find((_) => _.value === cellContent)
                  .label || ""}
              </span>

            
          )
        },
        type: "select",
        options: "sourceOptions",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]},
  },
   //Priority
   {
    schemaId: "cHJpb3Jp",
    name: "priority",
    title: "Priority List",
    formTitle: "Priority List",
    path: "/priority",
    visible: true,
    ...cHJpb3Jp,
    page: "Priority",
    exact: true,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")
      
      const codeValueMetaData = metaData && metaData.codeOptions
      
   console.log(codeValueMetaData, "codeValueMetaData")
    

      return[
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shortCode",
        label: "Short Code",
        placeholder: "Enter short Code",
        autofillValue: codeValueMetaData,
        sort: true,
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.shortCode}</p>
            </>
          )},
        type: "code",
      },
      {
        id: "5",
        value: "priority",
        label: "Priority Name",
        placeholder: "Enter priority Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.priority}</p>
            </>
          )},
        type: "text",
      },
      {
        id: "5",
        value: "colorCode",
        label: "Color Code",
        placeholder: "Enter Color Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.colorCode}</p>
            </>
          )},
        type: "text",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]},
  },
   // lead_service
   {
    schemaId: "c2Vydmlj",
    name: 'lead_service',
    title: 'Service List',
    formTitle: 'Service List',
    path: '/service',
    visible: true,
    ...c2Vydmlj,
    page: 'Service',
    exact: true,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")
      
      const codeValueMetaData = metaData && metaData.codeOptions
      
   console.log(codeValueMetaData, "codeValueMetaData")
    
     return[
      {
        id: "1",
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "2",
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) => row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : rowIndex + 1,
        type: 'text'
      },
      {
        id: "3",
         value: "actions",
         label: "Action",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
      },

      {
        id: "4",
        value: 'companyId',
        label: 'Company',
        placeholder: 'Enter Company',
        sort: true,
        required:true,
        editRecord: true,
        viewRecord: true,
        type: 'select',
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.companyOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        options: 'companyOptions'
      },
      {
        id: "5",
        value: 'service',
        label: 'Service',
        placeholder: 'Enter Service',
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: 'text',
        required:true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.service} </span>
          },
      },
      {
        id: "6",
        value: 'shortCode',
        label: 'Short Code ',
        autofillValue: codeValueMetaData,
        placeholder: 'Enter Short Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        //required: false,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.shortCode} </span>
          },
        type: 'code'
      },
      {
        // Non Wedding
        id: "6",
        value: 'type',
        label: 'Type',
        placeholder: 'Enter Type',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'radio',
        options: [

          {
            label: 'Wedding',
            value: 'wedding'
          },
          {
            label: 'Non Wedding',
            value: 'nonWedding'
          }
        ],
        formatter: (cellContent) => {
          const data = [

            {
              label: 'WEDDING',
              value: 'wedding'
            },
            {
              label: 'NON WEDDING',
              value: 'nonWedding'
            }
          ]
          return cellContent && data.find(_ => _.value === cellContent).label || ''
        },
      },
      {
        id: "7",
        value: 'description',
        label: 'Description',
        sort: true,
        editRecord: true,
        viewRecord: true,
        placeholder: 'Enter The Description',
        type: 'textarea',
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.description} </span>
          },
        required:true,
      },
      // {
      //   id: "8",
      //   value: 'isSpecialService',
      //   label: 'Is Special Service',
      //   sort: true,
      //   editRecord: true,
      //   viewRecord: true,
      //   type: "checkbox",
      //   labelStyle: {
      //     fontSize: "12px",
      //     fontWeight: 600
      //   },
      //   formatter: (cellContent, row) => {
      //     return (
      //       <Badge style={{padding: "6px", fontSize: "12px"}} color={row.isSpecialService == true ? "success" : "danger"}>
      //         {row.isSpecialService == true ? "Yes" : "No"}
      //       </Badge>
      //     )
      //     },
      //   required:false,
      // },

      {
        id: "8",
        value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${row.status === 1
                 ? "bg-success badge-soft-success"
                 : "bg-danger badge-soft-danger"
                 }`}
               color={row.badgeclass}
               pill
             >
               {row.status === 1 ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
      },
      {
        id: "9",
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "10",
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false    ,
        type: 'text'
      },
      {
        id: "11",
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "12",
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      }
    ]},
  },
  // custom_field
  {
    schemaId: "y3VzdG9t",
    name: "custom_field",
    title: "Custom Field",
    formTitle: "CustomField",
    path: "/customfields",
    visible: true,
    ...y3VzdG9t,
    page: "CustomField",
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "serviceId",
        label: "Service",
        placeholder: "Enter Service Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>{row.serviceName}</span>
          )
        },
        options: "serviceOptions",
      },
      {
        id: "5",
        value: "labelName",
        label: "Label Name",
        placeholder: "Enter Label Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
        colProps: {
          lg: "6",
          md: "6",
        },
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row.labelName} </span>
        },
      },
      {
        id: "6",
        value: "datatype",
        label: "Data Type",
        placeholder: "Enter Data Type",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        options: [
          {
            label: "TEXT",
            value: "text",
          },
          {
            label: "NUMBER",
            value: "number",
          },
        ],
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row.datatype} </span>
        },
      },
      {
        id: "7",
        value: "helptext",
        label: "Help Text",
        placeholder: "Enter Help Text",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
        colProps: {
          lg: "6",
          md: "6",
        },
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.helptext}</p>
            </>
          )
        },
      },
      {
        id: "8",
        value: "defaultValue",
        label: "Default Value",
        sort: true,
        placeholder: "Enter Default Value",
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row.defaultValue} </span>
        },
      },
      {
        id: "9",
        value: "isMandatory",
        label: "Is Mandatory",
        placeholder: "Is Mandatory",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required:true,
        type: "checkbox",
        colProps: {
          lg: "6",
          md: "6",
          style: { marginTop: "33px" },
        },
        formatter: (cellContent, row) => {
          return (<><span >{row.isMandatory === true ? "YES" : "NO"}</span> </>)

        },
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "10",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "12",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "13",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
   // muhurtham
   {
    schemaId: "bXVodXJ0",
    name: "muhurtham",
    title: "Muhurtham",
    formTitle: "Muhurtham",
    path: "/muhurtham",
    visible: true,
    ...bXVodXJ0,
    page: "Muhurtham",
    exact: true,
    columns: (record = [], metaData) => {
     console.log(record, "record from api")
     console.log(metaData, "record from api")
     const codeValueMetaData = metaData && metaData.codeOptions
     console.log(codeValueMetaData, "record from api")
      
     var branchOptionDropdown = []
      if(metaData &&  metaData.branchOptions){
        var loopBranchOptions = metaData.branchOptions
        console.log("branchOptionDropdown 2", record.companyId)
        for (let i = 0; i < loopBranchOptions.length; i++) {
        if(record.companyId == loopBranchOptions[i].companyId){
          branchOptionDropdown.push(loopBranchOptions[i])
        }
      }
      }
     return[
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "companyId",
        label: "Company",
        placeholder: "Enter Company Name",
        sort: true,
        editRecord: true,
        viewRecord: false,
        required: true,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        options: "companyOptions",
      },
      {
        id: "4",
        value: "companyName",
        label: "Company",
        placeholder: "Enter Company Name",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) => {
          return (
           <span style={{textTransform: "uppercase"}}>{row.companyName}</span>
          )
        },
        required: true,
      },
      {
        id: "4",
        value: "branchId",
        label: "Branch",
        placeholder: "Enter Branch Name",
        sort: true,
        editRecord: record.companyId ? true : false,
        viewRecord: true,
        required: true,
        type: "multiSelect",
        validations: "arrayField",
        formatter: (cellContent, row) => {
        //   var branchList = row.branchName
        //  const branchId = row.branchName.map(branch=> branch)
         // return <span>{row.branchId}</span>
        //  return <span>{branchList.length > 1 ? branchId.join(",") : branchId}</span>
         return <span>{row.branchId.length > 1 ? row.branchName && row.branchName.join(",") : row.branchName}</span>
       },
        colProps: {
          lg: "6",
          md: "6",
        },
        // options:  record.companyId?branch:'branchOptions',
        options: branchOptionDropdown,
      },
      {
        id: "4",
        value: "branchName",
        label: "Branch",
        placeholder: "Enter Branch Name",
        sort: true,
        editRecord:  false,
        viewRecord: false,
        
      },
      {
        id: "6",
        value: "muhurthanCode",
        autofillValue: codeValueMetaData,
        label: "Muhurtham Code",
        placeholder: "Enter Muhurtham Code",
        sort: true,
       // required:true,
        editRecord: true,
        viewRecord: true,
        type: "code",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row) => {
         return <span style={{textTransform: "uppercase"}}>{row.muhurthanCode} </span>
         },
      },
      {
        id: "6",
        value: "muhurthan",
        label: "Muhurtham",
        placeholder: "Enter Muhurtham",
        sort: true,
        required:true,
        editRecord: true,
        viewRecord: true,
        type: "text",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row) => {
         console.log(row, "row from api")
         return (
           <>
             <p style={{ textTransform: "uppercase" }}>{row.muhurthan}</p>
           </>
         )},
      },
      {
        id: "5",
        value: "date",
        label: "Date",
        placeholder: "Enter Date",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
       //  disabled: false,
        type: "date",
        formatter: (cellContent, row)=> {
         const date = moment(row.date).format("DD-MM-YYYY")
         return (<>
             <span style={{textTransform: "uppercase"}}>{date}</span>
         </>)
        },
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
      },
      {
        id: "4",
        value: "priorityStatusId",
        label: "Priority Status",
        placeholder: "Enter Priority Status",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },

       formatter: (cellContent, row) => {
         return (
          <span style={{textTransform: "uppercase"}}>{row.priorityStatusName}</span> 
        )
       },
        options: "priorityStatusOptions",
      },

      {
        id: "5",
        value: "description",
        label: "Description",
        placeholder: "Enter Description ",
        sort: true,
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
         return <span style={{textTransform: "uppercase"}}>{row.description} </span>
         },
        type: "textarea",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "10",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "12",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "13",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]},
  },

   // Event
   {
     schemaId: "zXZlbnQq",
     name: "Event",
     title: "Event Details",
     formTitle: "Event Details",
     path: "/event",
     visible: true,
     ...zXZlbnQq,
     page: "Event",
     exact: true,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Action",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "eventCode",
         label: "Event Code",
         placeholder: "Enter Event Code",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         type: "text",
         colProps: {
           lg: "6",
           md: "6",
           style: { paddingRight: "15px" },
         },
         formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.eventCode} </span>
          },
       },
       {
         id: "4",
         value: "eventName",
         label: "Event Name",
         placeholder: "Enter Event Name",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         type: "text",
 
         colProps: {
           lg: "6",
           md: "6",
           style: { paddingRight: "15px" },
         },
         formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.eventName} </span>
          },
       },
       {
         id: "5",
         value: "description",
         label: "Description",
         placeholder: "Enter Description ",
         sort: true,
         editRecord: true,
         viewRecord: true,
         formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.description} </span>
          },
         type: "textarea",
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading  ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
            <Badge
            className={`font-size-12 badge rounded-pill ${row.status ===1 
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   // employee
{
  schemaId: "ZW1wbG95",
  name: "employee",
  title: "Employee",
  formTitle: "Employee",
  path: "/create-employee",
  visible: true,
  ...ZW1wbG95,
  page: "EmployeeDetail",
  exact: true,
  columns: (record = {}, metaData) => {
    console.log(metaData,"my metadata")
    const addressFalg = !record.SameAddress
    const branchOptions =
      record &&
      record.companyId &&
      metaData &&
      Object.keys(metaData).length > 0 &&
      metaData.branchOptions &&
      metaData.branchOptions.length > 0
        ? metaData.branchOptions.filter(
            (_) => _.companyId.toString() === record.companyId.toString()
          )
        : metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.branchOptions &&
          metaData.branchOptions.length > 0
        ? metaData.branchOptions
        : []
    const attendanceeoption = [
      {
        label: "Time Shift",
        value: "2",
      },
      {
        label: "Working Duration",
        value: "1",
      },
    ]
    return [
      {
        id: "1",
        value: "name",
        label: "Name",
        placeholder: "Enter Name",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "textOnly",
        validations: "textOnly"
      },
      {
        id: "2",
        value: "dob",
        label: "DOB",
        placeholder: "Select DOB",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "cls-date",
        },
        type: "date",
      },
      {
        id: "3",
        value: "gender",
        label: "Gender",
        placeholder: "Enter Gender",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        options: [
          {
            label: "Male",
            value: "male",
          },
          {
            label: "Female",
            value: "female",
          },
        ],
      },
      {
        id: "4",
        value: "maritalStatus",
        label: "Marital Status",
        placeholder: "Enter Marital Status",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "radio",
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        options: [
          {
            label: "Single",
            value: "single",
          },
          {
            label: "Married",
            value: "married",
          },
        ],
      },
      {
        id: "5",
        value: "mobileNo",
        label: "Mobile Number",
        placeholder: "Enter Mobile Number",
        sort: true,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "employee-input"
        },
        type: "mobile",
        validations: "mobile"
        // type: "number",
      },
      {
        id: "6",
        value: "alterMobileNo",
        label: "Alternative Mobile Number",
        placeholder: "Enter Alternative Mobile Number",
        sort: true,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "employee-input"
        },
       type: "mobile",
       validations: "mobile"
      },
      {
        id: "7",
        value: "email",
        label: "Email Id",
        placeholder: "Enter Email Id",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "email",
      },
      {
        id: "8",
        value: "homeTown",
        label: "Home Town",
        placeholder: "Enter Home Town",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "textOnly",
        validations: "textOnly"
      },
      {
        id: "9",
        value: "settledIn",
        label: "Settled In",
        placeholder: "Enter Settled In",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "textOnly",
        validations: "textOnly"
      },
      {
        id: "11",
        value: "cityId",
        label: "City",
        sort: false,
        placeholder: "Enter City",
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "select",
        options: "cityOptions",
      },

      {
        id: "10",
        value: "area",
        label: "Area",
        sort: false,
        placeholder: "Enter Area",
        editRecord: true,
        required: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "textOnly",
        validations: "textOnly"
      },
      {
        id: "12",
        value: "profileImage",
        label: "Profile Image",
        placeholder: "Upload Profile Image",
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: {
            padding: "0px",
          },
          className: "cls-profileimage",
        },
        type: "upload",
      },
      {
        id: "13",
        value: "pAddress",
        label: "Permenant Address",
        placeholder: "Enter Permenant Address",
        sort: false,
        editRecord: true,
        // disabled: true,
        required: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "textarea",
      },
      {
        id: "14",
        value: addressFalg ? "tAddress" : "pAddress",
        label: "Temporary Address",
        placeholder: "Enter Temporary Address",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        // {record.SameAddress?record.tAddress=record.pAddress:''}
        // formatter: () => {
        //     record.SameAddress ?  record.tAddress=record.pAddress : null
        //     return record.SameAddress ?  record.pAddress : record.tAddress
        // },
        type: "textarea",
      },
      {
        id: "15",
        value: "bloodGroup",
        label: "Blood Group",
        sort: false,
        placeholder: "Select Blood Group",
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "select",
        options: [
          {
          label: "A +",
          value: "aPositive"
          },
          {
          label: "A -",
          value: "aNegative"
          },
          {
          label: "B +",
          value: "bPositive"
          },
          {
          label: "B -",
          value: "bNegative"
          },
          {
          label: "AB +",
          value: "abPositive"
          },
          {
          label: "AB -",
          value: "abNegative"
          },
          {
          label: "O +",
          value: "oPositive"
          },
          {
          label: "O -",
          value: "oNegative"
          },
      ],
      },
      {
        id: "6",
        value: "SameAddress",
        label: "Temporary Address Same as Permenant Address",
        editRecord: true,
        viewRecord: true,
        colProps: {
          style: {},
        },
        type: "checkbox",
      },
      {
        id: "15",
        value: "companyId",
        label: "Company Name",
        placeholder: "Enter Company Name",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px", marginRight: "1px" },
          className: "cls-hrEntry-title",
        },
        type: "select",

        formatter: (cellContent, metaData) => {
          return (
            (metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.find((_) => _.value === cellContent) &&
              metaData.companyOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "companyOptions",
      },
      {
        id: "16",
        value: "branchId",
        label: "Branch",
        placeholder: "Enter Branch",
        sort: false,
        editRecord: true,
        required: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "cls-hrEntry-title cls-clr-wt",
        },
        type: "select",

        formatter: (cellContent) => {
          return (
            (branchOptions &&
              branchOptions.length > 0 &&
              branchOptions.find((_) => _.value === cellContent) &&
              branchOptions.find((_) => _.value === cellContent).label) ||
            ""
          )
        },
        options: branchOptions,
      },
      {
        id: "17",
        value: "departmentId",
        label: "Department",
        required: true,
        placeholder: "Enter Department",
        sort: false,
        editRecord: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px", marginLeft: "-1px" },
          className: "cls-hrEntry-title cls-clr-wt",
        },
        type: "select",
        options: "departmentOptions",
      },
      {
        id: "18",
        value: "designationId",
        label: "Designation",
        required: true,
        placeholder: "Enter Designation",
        sort: false,
        editRecord: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "select",
        options: "designationOptions",
      },
      {
        id: "19",
        value: "roleId",
        label: "Role",
        placeholder: "Enter Role",
        sort: false,
        required: true,
        editRecord: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "select",
        options: "roleoptions",
      },
      // company mail id
      {
        id: "7",
        value: "companyEmail",
        label: "Company Email Id",
        placeholder: "Enter Company Email Id",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "email",
      },
      {
        id: "20",
        value: "empCode",
        label: "Employee Code",
        placeholder: "Enter Employee Code",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "employee-input",
        },
        type: "number",
      },
      {
        id: "21",
        value: "biometricAccess",
        label: "Biometric Code",
        placeholder: "Enter Biometric Code",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "employee-input",
        },
        type: "number",
      },
      {
        id: "22",
        value: "trainingBranch",
        label: "Training Branch",
        placeholder: "Enter Training Branch",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "select",
        options: branchOptions,
      },
      {
        id: "23",
        value: "doj",
        label: "DOJ",
        placeholder: "Enter DOJ",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "cls-date",
        },
        type: "date",
      },
      {
        id: "25",
        value: "grossSalary",
        label: "Gross Salary",
        placeholder: "Enter Gross Salary",
        sort: false,
        editRecord: true,
        Validate: "number",
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "employee-input",
        },
        type: "number",
      },
      {
        id: "26",
        value: "attendanceType",
        label: "Attendance Type",
        placeholder: "Enter Attendance Type",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "select",
        formatter: (cellContent) => {
          return attendanceeoption.find((_) => _.value === cellContent).label
        },
        options: [
          {
            label: "Time Shift",
            value: "2",
          },
          {
            label: "Working Duration",
            value: "1",
          },
        ],
      },
      {
        id: "27",
        value: "shiftId",
        label: "Time Shift",
        placeholder: "Enter Time Shift",
        sort: false,
        required: true,
        editRecord: record.attendanceType === "1" ? false : true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent) => {
          return (
            (metaData &&
              metaData.shiftoptions &&
              metaData.shiftoptions.length > 0 &&
              metaData.shiftoptions.find((_) => _.value === cellContent) &&
              metaData.shiftoptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        type: "select",
        options: "shiftoptions",
      },
      {
        id: "28",
        value: "workingDuration",
        label: "Duration",
        placeholder: "Enter Duration",
        sort: false,
        editRecord: record.attendanceType === "1" ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      {
        id: "28",
        value: "callVerify",
        label: "Call Verification",
        placeholder: "Enter Call Verification",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px", marginRight: "" },
        },
        type: "select",
        options: [
          {
            label: "Verified",
            value: "verified",
          },
        ],
      },

      {
        id: "29",
        value: "nextHikeTenure",
        label: "Hike Tenure",
        placeholder: "Select Hike Tenure",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px", marginRight: "0px" },
        },
        type: "select",
        options: [
          {
            label: "3 Month",
            value: "3",
          },
          {
            label: "6 Month",
            value: "6",
          },
          {
            label: "12 Month",
            value: "12",
          },
        ],
      },
      {
        id: "30",
        value: "nextHikeRemarks",
        label: "Hike Remark",
        placeholder: "Enter Hike Remark",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "textarea",
      },
      {
        id: "31",
        value: "employeeType",
        label: "Employee Type",
        placeholder: "Select Employee Type",
        sort: false,
        editRecord: true,
        required: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px"},
        },
        formatter: (cellContent) => {
          console.log(metaData.employeeTypeOptions, "EmployeeTypeOptions")
          return (
            (metaData &&
              metaData.employeeTypeOptions &&
              metaData.employeeTypeOptions.length > 0 &&
              metaData.employeeTypeOptions.find(
                (_) => _.value === cellContent
              ) &&
              metaData.employeeTypeOptions.find((_) => _.value === cellContent)
              .label) ||
              ""
              )
            },
        type: "select",
        options: "employeeTypeOptions",
      },
      {
        id: "32",
        value: "policySettingId",
        label: "Policy Type",
        placeholder: "Select Policy Type",
        sort: false,
        editRecord: true,
        required: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent) => {
          return (
            (metaData &&
              metaData.policyOptions &&
              metaData.policyOptions.length > 0 &&
              metaData.policyOptions.find(
                (_) => _.value === cellContent
              ) &&
              metaData.policyOptions.find((_) => _.value === cellContent)
                .label) ||
                ""
                )
          },
        type: "select",
        options: "policyOptions",
      },
      {
        id: "33",
        value: "empCode",
        label: "User Name",
        placeholder: "Enter User Name",
        sort: false,
        editRecord: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px", marginRight: "1px" },
          className: "Cls-loginCre-title",
        },
        type: "text",
      },
      {
        id: "34",
        value: "password",
        label: "Password",
        placeholder: "Enter Password",
        sort: false,
        viewRecord: false,
        editRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "Cls-loginCre-title cls-clr-wt cls-password",
        },
        type: "password",
      },
      {
        id: "35",
        value: "confirmPassword",
        label: "Confirm Password",
        placeholder: "Enter Confirm Password",
        sort: false,
        editRecord: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px", marginLeft: "-1px" },
          className: "Cls-loginCre-title cls-clr-wt cls-password",
        },
        type: "password",
      },

      // shared document
      {
        id: "36",
        value: "sharedCompanyId",
        label: "Company Name",
        placeholder: "select Company Name",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px", marginRight: "1px", marginBottom: "35px" },
          className: "Cls-shareddoc-title",
        },
        //type: "multiSelect",
        type: "filterMultiSelect",
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.filter((_) =>
                cellContent.includes(_.value.toString())
              ) &&
              metaData.companyOptions
                .filter((_) => cellContent.includes(_.value.toString()))
                .map((_) => _.label)
                .join(",")) ||
            ""
          )
        },
        // type: 'select',
        options: "companyOptions",
      },
      {
        id: "37",
        value: "sharedBranchId",
        label: "Branch Name",
        placeholder: "select Branch Name",
        sort: false,
        editRecord: true,
        required: false,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px", marginBottom: "35px" },
          className: "Cls-shareddoc-title cls-clr-wt filter-field",
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.branchOptions &&
              metaData.branchOptions.length > 0 &&
              metaData.branchOptions.filter((_) =>
                cellContent.includes(_.value.toString())
              ) &&
              metaData.branchOptions
                .filter((_) => cellContent.includes(_.value.toString()))
                .map((_) => _.label)
                .join(",")) ||
            ""
          )
        },
      //  type: "multiSelect",
      //  type: "selectAll",
      type: "filterMultiSelect",
        options: "branchOptions",
      },
    ]
  },
},

 // viewEmploye
 {
  schemaId: "dmlld2Vt",
  name: "viewEmployee",
  title: "ManageEmployee",
  formTitle: "ViewEmployee",
  path: "/viewEmployee",
  visible: true,
  ...dmlld2Vt,
  page: "ViewEmployee",
  exact: true,
  editButton: ({ record = {}, access }) => {
    const history = useHistory()
    console.log(record, "record from view employee")
    return (
      <button
        type="button"
        onClick={() => {
          history.push({
            pathname: "/create-employee",
            state: { detail: record, access },
          })
        }}
        style={{ marginRight: "8px" }}
        className="btn btn-success edit-table-btn"
      >
        <i className="mdi mdi-pencil d-block font-size-16"></i>
      </button>
    )
  },
  className: "lead-counter",
  enableTableFilter: true,
  importTableColumns: [
    { dataField: "0", text: "S.No" },
    { dataField: "1", text: "COMPANY" },
    { dataField: "2", text: "BRANCH" },
    { dataField: "3", text: "DEPARTMENT" },
    { dataField: "4", text: "DESIGNATION" },
    { dataField: "5", text: "EMP CODE" },
    {
      dataField: "6",
      text: "NAME (1st Name and Last Name 'As per PAN/Adhar'):",
    },
    { dataField: "7", text: "Personal NUMBER (Mobile)" },
    { dataField: "8", text: "Role" },
    { dataField: "9", text: "Email (Personal)" },
    { dataField: "10", text: "Date of Birth" },
    { dataField: "11", text: "Date of Joining" },
    { dataField: "12", text: "Biometric_Id" },
    { dataField: "13", text: "Gender" },
    { dataField: "17", text: "Hometown" },
    { dataField: "18", text: "SettledIN" },
    { dataField: "19", text: "City" },
    { dataField: "20", text: "Area" },
    { dataField: "21", text: "Marital" },
    { dataField: "22", text: "Email (Official)" },
    { dataField: "23", text: "Shift" },
    { dataField: "24", text: "Duration" },
    { dataField: "25", text: "Monthly - Gross_Salary" },
    { dataField: "26", text: "Address" },
    { dataField: "31", text: "Employee Type" },
    { dataField: "30", text: "Policy Type" },
    { dataField: "28", text: "Username" },
    { dataField: "29", text: "Password" },
    { dataField: "34", text: "NextHikeDate" },
    { dataField: "35", text: "CurrentSalary" },
    { dataField: "36", text: "FatherName" },
    { dataField: "37", text: "FatherContactNo" },
    { dataField: "38", text: "FatherAddress" },
    { dataField: "39", text: "MotherName" },
    { dataField: "40", text: "MotherContactNo" },
    { dataField: "41", text: "MotherAddress" },
    { dataField: "42", text: "Spouse/CloseRelativeName" },
    { dataField: "43", text: "Spouse/CloseRelativeContactNo" },
    { dataField: "44", text: "Spouse/CloseRelativeAddress" },
    { dataField: "45", text: "ExpCompanyName" },
    { dataField: "46", text: "ExpDesignation" },
    { dataField: "47", text: "ExpYear" },
    { dataField: "48", text: "ExpFromDate" },
    { dataField: "49", text: "ExpToDate" },
    { dataField: "50", text: "AccountHolder" },
    { dataField: "51", text: "AccountNo" },
    { dataField: "52", text: "IFSC" },
    { dataField: "53", text: "BankName" },
    { dataField: "54", text: "PANNo" },
    { dataField: "55", text: "AadharNo" },
  ],
  grid: [
    {
      id: 1,
      component: EmployeeHeader,

      flagAddBtn: false,
    },
    {
      id: 2,
      component: "WidgetCounter",

      flagHeight: "190px",
      onLoad: async () => {
        const data = await api
          .post("/get_employee_count")
          .then((response) => response.data && response.data.data)
          .catch((error) => Promise.reject(error))

        return await data
      },
      columns: () => [
        {
          id: "1",
          value: "todayEmployeeCount",
          label: "Total Employees",
          editRecord: false,
          viewRecord: true,
          cardStyle: {
            backgroundColor: "#0D70E2",
            marginBottom: "15px",
            display: "inline-block",
            width: "100%",
            height: "80%",
          },
          type: "text",
        },
        {
          id: "2",
          value: "totalPendingEmployeeCount",
          label: "PENDING EMPLOYEE CREATION",
          editRecord: false,
          viewRecord: true,
          cardStyle: {
            backgroundColor: "#F1B54C",
            marginBottom: "15px",
            display: "inline-block",
            width: "100%",
            height: "80%",
          },
          type: "text",
        },
        {
          id: "3",
          value: "totalLeaveOfTheDay",
          label: "LEAVES OF THE DAY",
          editRecord: false,
          viewRecord: true,
          cardStyle: {
            backgroundColor: "#34C28F",
            marginBottom: "15px",
            display: "inline-block",
            width: "100%",
            height: "80%",
          },
          type: "text",
        },
        {
          id: "4",
          value: "totalPermissionOfTheDay",
          label: "PERMISSIONS OF THE DAY",
          editRecord: false,
          viewRecord: true,
          cardStyle: {
            backgroundColor: "#F46969",
            marginBottom: "15px",
            display: "inline-block",
            width: "100%",
            height: "80%",
          },
          type: "text",
        },
        {
          id: "1",
          value: "todayEmployeeBirthday",
          label: "EMPLOYEE BIRTHDAY",
          editRecord: false,
          viewRecord: true,
          cardStyle: {
            backgroundColor: "#0D70E2",
            marginBottom: "15px",
            display: "inline-block",
            width: "100%",
            height: "80%",
          },
          type: "text",
        },
        {
          id: "2",
          value: "todayEmployeeWorkAnniversary",
          label: "EMPLOYEE WORK ANNIVERSARY",
          editRecord: false,
          viewRecord: true,
          cardStyle: {
            backgroundColor: "#F1B54C",
            marginBottom: "15px",
            display: "inline-block",
            width: "100%",
            height: "80%",
          },
          type: "text",
        },
      ],
    },
    {
      id: 3,
      component: "DynamicFilter",
      EmployeeFilter: true,
      onSubmit: ({ dispatch, actions, submitData, setSubmitting }) => {

        console.log(submitData, "submitData")
        //  const status = submitData.status === true ? 2 : 1
        //  console.log(status, "status")
        if (submitData.status == true) {
          submitData.status = "inActive"
          submitData.isManageHRMS = true
          dispatch(
            actions.loadRecords(
              Object.assign({}, submitData),
              true
            )
          )
        }
        if (submitData.fromDate && submitData.toDate) {
          submitData.fromDate = moment(submitData.fromDate).format("YYYY-MM-DD")
          submitData.toDate = moment(submitData.toDate).format("YYYY-MM-DD")
        }
        submitData.isManageHRMS = true
        submitData.status = "active"
        dispatch(
          actions.loadRecords(
            Object.assign({}, submitData),
            true
          )
        )


        setTimeout(() => {
          setSubmitting(false)
        }, 3000)
      },
      initialValues: {},
      columns: (record = {}, metaData) => {
        const branchOptions =
          record &&
            !isEmpty(record.companyId) &&
            record.companyId &&
            metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.branchOptions &&
            metaData.branchOptions.length > 0
            ? metaData.branchOptions.filter(
              (_) => _.companyId.toString() === record.companyId.toString()
            )
            : metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.branchOptions &&
              metaData.branchOptions.length > 0
              ? metaData.branchOptions
              : []

        console.log(branchOptions, "branchOptions")
        console.log(metaData, "metaData")

        return [
          {
            id: "1",
            value: "_id",
            label: "Id",
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "2",
            value: "companyId",
            label: "Company",
            editRecord: true,
            viewRecord: false,
            colProps: {
              lg: "3",
              md: "6",
              className: "filter-field",
            },
            type: "employeeMultiSelect",
            options: "companyOptions",
          },
          {
            id: "3",
            value: "branchId",
            label: "Branch",
            editRecord: true,
            viewRecord: false,
            colProps: {
              lg: "3",
              md: "6",
              className: "filter-field",
            },
            type: "employeeMultiSelect",
            options: !isEmpty(record.companyId) ? branchOptions : [],
          },
          {
            id: "4",
            value: "departmentId",
            label: "Department",
            editRecord: true,
            viewRecord: false,
            colProps: {
              lg: "3",
              md: "6",
              className: "filter-field",
            },
            type: "employeeMultiSelect",
            options: "departmentOptions",
          },
          {
            id: "4",
            value: "designationId",
            label: "Designation",
            editRecord: true,
            viewRecord: false,
            colProps: {
              lg: "3",
              md: "6",
              className: "filter-field",
            },
            type: "employeeMultiSelect",
            options: "designationOptions",
          },

          // LOCATION – CITY

          {
            id: "11",
            value: "cityId",
            label: "City",
            sort: false,
            placeholder: "Enter City",
            editRecord: true,
            viewRecord: false,
            required: false,
            colProps: {
              lg: "3",
              md: "6",
              className: "filter-field",
            },
            type: "employeeMultiSelect",
            options: "cityOptions",
          },


          {
            id: "4",
            value: "fromDate",
            label: "Join From Date",
            placeholder: "Enter Join From date",
            sort: true,
            required: false,
            colProps: {
              lg: "3",
              md: "6",
              className: "filter-field",
            },
            editRecord: true,
            viewRecord: true,
            type: "date",
            // formatter: (cellContent) => {
            //   return (
            //     (cellContent && moment(cellContent).format("MM-DD-YYYY")) ||
            //     ""
            //   )
            // },
          },
          {
            id: "4",
            value: "toDate",
            label: "Join To Date",
            placeholder: "Enter Join To date",
            sort: true,
            required: false,
            colProps: {
              lg: "3",
              md: "6",
              className: "filter-field",
            },
            editRecord: true,
            viewRecord: true,
            type: "date",
            // formatter: (cellContent) => {
            //   return (
            //     (cellContent && moment(cellContent).format("MM-DD-YYYY")) ||
            //     ""
            //   )
            // },
          },

          // {
          //   id: "27",
          //   value: "shiftId",
          //   label: "Time Shift",
          //   placeholder: "Enter Time Shift",
          //   sort: false,
          //   // required: true,
          //   editRecord: true,
          //   viewRecord: false,
          //   required: false,
          //   colProps: {
          //     lg: "3",
          //     md: "6",
          //     className: "filter-field",
          //   },
          //   formatter: (cellContent) => {
          //     return (
          //       (metaData &&
          //         metaData.shiftoptions &&
          //         metaData.shiftoptions.length > 0 &&
          //         metaData.shiftoptions.find(
          //           (_) => _.value === cellContent
          //         ) &&
          //         metaData.shiftoptions.find((_) => _.value === cellContent)
          //           .label) ||
          //       ""
          //     )
          //   },
          //   type: "select",
          //   options: "shiftoptions",
          // },
          // {
          //   id: "28",
          //   value: "isWorkStatus",
          //   label: "",
          //   placeholder: "Enter Work Status",
          //   sort: false,
          //   editRecord: true,
          //   viewRecord: false,
          //   required: false,
          //   colProps: {
          //     lg: "3",
          //     md: "3",
          //     className: "pt-3",
          //   },
          //   type: "radio",
          //   options: [
          //     {
          //       label: "WFH",
          //       value: "WFH",
          //     },
          //     {
          //       label: "WFO",
          //       value: "WFO",
          //     },
          //   ],
          // },
          {
            id: "28",
            value: "status",
            label: "Inactive Employees",
            placeholder: "Enter Work Status",
            sort: false,
            editRecord: true,
            viewRecord: false,
            required: false,
            checked: record.status == true ? true : false,
            colProps: {
              lg: "3",
              md: "6",
              className: "mt-2",
              style: {
                paddingTop: "25px"
              }
            },
            type: "hrmsCheckbox",

          },
          // {
          //   id: "28",
          //   value: "commutation",
          //   label: "Commutation",
          //   placeholder: "Enter Commutation",
          //   sort: false,
          //   editRecord: true,
          //   viewRecord: true,
          //   required: false,
          //   colProps: {
          //     lg: "3",
          //     md: "6",
          //     className: "filter-field mt-2",
          //   },
          //   type: "checkbox",
          //   options: [
          //     {
          //       label: "Yes",
          //       value: "yes",
          //     },
          //     {
          //       label: "NO",
          //       value: "no",
          //     },
          //   ],
          // },
          // {
          //   id: "28",
          //   value: "isNotice",
          //   label: "On Notice",
          //   placeholder: "Enter On Notice",
          //   sort: false,
          //   editRecord: true,
          //   viewRecord: false,
          //   required: false,
          //   colProps: {
          //     lg: "3",
          //     md: "6",
          //     className: "filter-field mt-2",
          //   },
          //   type: "checkbox",
          //   options: [
          //     {
          //       label: "Yes",
          //       value: "true",
          //     },
          //     {
          //       label: "NO",
          //       value: "false",
          //     },
          //   ],
          // },
          // {
          //   id: "28",
          //   value: "isIncentive",
          //   label: "Incentive",
          //   placeholder: "Enter Incentive",
          //   sort: false,
          //   editRecord: true,
          //   viewRecord: false,
          //   required: false,
          //   colProps: {
          //     lg: "3",
          //     md: "6",
          //     className: "filter-field mt-2",
          //     style: { marginTop: "20px" },
          //   },
          //   type: "checkbox",
          //   options: [
          //     {
          //       label: "Yes",
          //       value: "true",
          //     },
          //     {
          //       label: "NO",
          //       value: "false",
          //     },
          //   ],
          // },
        ]
      },
    },
  ],
  columns: (record = {}, metaData) => {
    const branchOptions =
      record &&
        record.companyId &&
        metaData &&
        Object.keys(metaData).length > 0 &&
        metaData.branchOptions &&
        metaData.branchOptions.length > 0
        ? metaData.branchOptions.filter(
          (_) => _.companyId.toString() === record.companyId.toString()
        )
        : metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.branchOptions &&
          metaData.branchOptions.length > 0
          ? metaData.branchOptions
          : []

    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "3",
        value: "isWebAccess",
        label: "Access",
        sort: false,
        editRecord: true,
        viewRecord: true,
        editFormatter: "access",
        type: "text",
        customAccessBtn: ({ openDialog, record = {} }) => {
          const access = record &&
            record.isWebAccess

          console.log(access, "access")
          if (access === false) {
            return (
              <button
                onClick={openDialog}
                // disabled={access && access === true ? true : false }
                type="button"
                className="btn btn-danger"
                style={{ padding: "4px 7.5px" }}
              >
                <i className="fa fa-globe font-size-14"></i>
              </button>
            )
          } else {
            return ""
          }
        },
        customWebAccessBtn: ({ openDialog, record = {} }) => {
          const access = record &&
            record.isWebAccess

          // console.log(record, access, "record, access")
          if (access && access === true) {
            return (
              <button
                onClick={openDialog}
                // disabled={access && access === true ? false : true }
                type="button"
                className="btn btn-success"
                style={{ padding: "4px 7.5px" }}
              >
                <i className="fa fa-globe font-size-14"></i>
              </button>

            )
          } else {
            return ""
          }
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "cls-hrEntry-title cls-clr-wt",
        },
        formatter: (cellContent, row) => {
          //return (<><span >{row.isWebAccess === false ? "YES" : "NO"}</span> </>)
          return (<><h>{ }</h><span >{row.isWebAccess}</span> </>)
        },
      },
      {
        id: "3",
        value: "activeStatus",
        label: "Active Status",
        sort: false,
        editRecord: true,
        viewRecord: true,
        headerStyle: {
          minWidth: "114px"
        },
        editFormatter: "accessStatus",
        type: "text",
        customAccessActiveStatusBtn: ({ openModal, record = {} }) => {
          const status = record &&
            record.status
          if (status && status === 2) {
            return (
              <button
                onClick={openModal}
                disabled={status && status === 2 ? false : true}
                type="button"
                className="btn btn-danger"
                style={{ padding: "4px 7.5px" }}
              >
                <i className="fas fa-lock-open font-size-14"></i>
              </button>
            )
          } else {
            return ""
          }
        },
        customAccessStatusBtn: ({ openModal, record = {} }) => {
          const status = record &&
            record.status

          // console.log(record, status, "record, status")
          if (status && status === 1) {
            return (
              <button
                onClick={openModal}
                disabled={status && status === 1 ? false : true}
                type="button"
                style={{ padding: "4px 7.5px" }}
                className="btn btn-success"
              >
                <i className="fas fa-lock font-size-14"></i>
              </button>

            )
          } else {
            return ""
          }
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "cls-hrEntry-title cls-clr-wt",
        },
        formatter: (cellContent, row) => {
          //return (<><span >{row.isWebAccess === false ? "YES" : "NO"}</span> </>)
          return (<><span >{row.isWebAccess}</span> </>)
        },
      },
      {
        id: "5",
        value: "shared",
        label: "Shared Employee",
        placeholder: "Enter Employee Code",
        // sort: true,
        editRecord: true,
        viewRecord: true,
        headerStyle: {
          minWidth: "155px"
        },
        editFormatter: "sharedEmployee",
        customEmployeeBtn: ({ openModal, record = {} }) => {
          // const status = record &&
          // record
          const company = record && record.company ?
            record.company.find(data => { return data.mode !== "default" }) : []
          const branch = record && record.branch ?
            record.branch.find(data => { return data.mode !== "default" }) : []
          console.log(record.company, "record company")
          console.log(record.branch, "record branch")
          console.log(company, "company")
          console.log(branch, "branch")

          return (
            <button
              onClick={openModal}
              // disabled={status && status === 1 ? false : true }
              type="button"
              style={{ padding: "4px 7.5px" }}
              className={company && company.mode === "shared" ||
                branch && branch.mode === "shared" ? "btn btn-success" : "btn btn-info"}
            >
              Shared
            </button>

          )
        },
        sharedEmployeeHistoryBtn: ({ openModal, record = {} }) => {
          // const status = record &&
          // record
          const company = record && record.company ?
            record.company.find(data => { return data.mode !== "default" }) : []
          const branch = record && record.branch ?
            record.branch.find(data => { return data.mode !== "default" }) : []
          console.log(record.company, "record company")
          console.log(record.branch, "record branch")
          console.log(company, "company")
          console.log(branch, "branch")
          console.log(record.company, "record company")

          return (
            <button
              type="button"
              onClick={openModal}
              className={company && company.mode === "shared" ||
                branch && branch.mode === "shared" ? "btn btn-warning" : "disabled-button btn btn-warning"}
              style={{
                marginLeft: "20px",
                marginTop: "5px",
                padding: "0px 5px",
                height: "20px",
              }}
            >
              <i className="fas fa-eye" style={{ fontSize: "12px" }}></i>
            </button>
          )
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      {
        id: "6",
        value: "productCategoryId",
        label: "Product Category",
        placeholder: "Enter Product Category",
        // sort: true,
        editRecord: true,
        viewRecord: true,
        headerStyle: {
          minWidth: "190px"
        },
        editFormatter: "productCategory",
        customProductBtn: ({ openModal, record = {} }) => {
         
         
           console.log(record, "product records")
        
          return (
            <button
              onClick={openModal}
              type="button"
              className="btn btn-info buttons btn-sm"
            >
              <i
                className="fas fa-pencil-alt icon-btn fa-sm"
              ></i>
            </button>
          
          )
        },

        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      {
        id: "20",
        value: "empCode",
        label: "Emp Code",
        placeholder: "Enter Employee Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        headerStyle: {
          minWidth: "114px"
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      {
        id: "1",
        value: "name",
        label: "Emp Name",
        placeholder: "Enter Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        headerStyle: {
          minWidth: "150px"
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      {
        id: "15",
        value: "companyId",
        label: "Company",
        placeholder: "Enter Company Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        headerStyle: {
          minWidth: "125px"
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px", "margin-right": "1px" },
          className: "cls-hrEntry-title",
        },
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row && row.companyName}</span>
        },

        // formatter: (cellContent, row, rowIndex, metaData) => {
        //   return (
        //     (cellContent &&
        //       metaData &&
        //       metaData.companyOptions &&
        //       metaData.companyOptions.length > 0 &&
        //       metaData.companyOptions.filter((_) =>
        //         cellContent.includes(_.value.toString())
        //       ) &&
        //       metaData.companyOptions
        //         .filter((_) => cellContent.includes(_.value.toString()))
        //         .map((_) => _.label)
        //         .join(",")) ||
        //     ""
        //   )
        // },
        type: "select",
        options: "companyOptions",
      },
      {
        id: "16",
        value: "branchId",
        label: "Branch",
        placeholder: "Enter Branch",
        sort: true,
        editRecord: true,
        viewRecord: true,
        headerStyle: {
          minWidth: "150px"
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "cls-hrEntry-title cls-clr-wt",
        },
        type: "select",
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row && row.branchName}</span>
        },
        options: branchOptions,
      },
      {
        id: "17",
        value: "departmentId",
        label: "Department",
        placeholder: "Enter Department",
        sort: true,
        editRecord: true,
        viewRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px", "margin-left": "-1px" },
          className: "cls-hrEntry-title cls-clr-wt",
        },
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row && row.departmentName}</span>
        },
        type: "select",
        options: "departmentOptions",
      },
      {
        id: "18",
        value: "designationId",
        label: "Designation",
        placeholder: "Enter Designaton",
        sort: true,
        editRecord: true,
        viewRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row && row.designationName}</span>
        },
        type: "select",
        options: "designationOptions",
      },
      {
        id: "18",
        value: "roleId",
        label: "Role Name",
        placeholder: "Enter Role",
        sort: true,
        editRecord: false,
        viewRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          // console.log(cellContent, "roleId")
          const roleName =
          row &&
          row.roleId &&
          metaData &&
        
        metaData.roleoptions &&
        metaData.roleoptions.length > 0
        ? metaData.roleoptions.find(
          (_) => _.value.toString() == row.roleId.toString()
        )
        : ""
        console.log(roleName, "roleName")
          return <span style={{ textTransform: "uppercase" }}>{!isEmpty(roleName) ? roleName.label : ""}</span>
        },
        type: "select",
        options: "roleOptions",
      },

      // companyEmail

      {
        id: "5",
        value: "companyEmail",
        label: "Company Email",
        placeholder: "Enter Company Email",
        sort: false,
        // Validate: "number",
        editRecord: false,
        viewRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      {
        id: "5",
        value: "doj",
        label: "Date of Join",
        sort: true,
        editRecord: false,
        viewRecord: true,
        headerStyle: {
          minWidth: "130px"
        },
        formatter: (cellContent, row) => {
          const doj = !isEmpty(row.doj) && row.doj ? moment(row.doj).format("DD-MM-YYYY") : ""
          return !isEmpty(doj) ? doj : "--"
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      // cityId

      {
        id: "5",
        value: "cityId",
        label: "City",
        placeholder: "Enter City",
        sort: true,
        editRecord: false,
        viewRecord: true,
        headerStyle: {
          minWidth: "114px"
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          // console.log(metaData)
          return (
            (cellContent &&
              metaData &&
              metaData.cityOptions &&
              metaData.cityOptions.length > 0 &&
              metaData.cityOptions.filter((_) =>
                cellContent.includes(_.value.toString())
              ) &&
              metaData.cityOptions
                .filter((_) => cellContent.includes(_.value.toString()))
                .map((_) => _.label)
                .join(",")) ||
            ""
          )
        },
        type: "text",
      },

      {
        id: "5",
        value: "mobileNo",
        label: "Mobile No",
        placeholder: "Enter Mobile Number",
        sort: true,
        // Validate: "number",
        editRecord: false,
        viewRecord: true,
        headerStyle: {
          minWidth: "120px"
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      {
        id: "6",
        value: "family_details",
        label: "Family Detail",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row && row.family_details && row.family_details.length === 0
                  ? "bg-danger badge-soft-danger"
                  : "bg-success badge-soft-success"
                }`}
              pill
            >
              {row && row.family_details && row.family_details.length === 0
                ? "Pending"
                : "Completed"}
            </Badge>
          ),

        type: "text",
        headerStyle: {
          minWidth: "138px"
        },
      },

      //  workExp
      {
        id: "6",
        value: "workExp",
        label: "Work Exp",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row && row.workExp && row.workExp.length === 0
                  ? "bg-danger badge-soft-danger"
                  : "bg-success badge-soft-success"
                }`}
              pill
            >
              {row && row.workExp && row.workExp.length === 0
                ? "Pending"
                : "Completed"}
            </Badge>
          ),
        type: "text",
        headerStyle: {
          minWidth: "138px"
        },
      },

      // bank
      {
        id: "6",
        value: "bank",
        label: "Bank",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row && row.bank && row.bank.length === 0
                  ? "bg-danger badge-soft-danger"
                  : "bg-success badge-soft-success"
                }`}
              pill
            >
              {row && row.bank && row.bank.length === 0
                ? "Pending"
                : "Completed"}
            </Badge>
          ),
        type: "text",
        headerStyle: {
          minWidth: "138px"
        },
      },
      {
        id: "6",
        value: "kyc_received_documents",
        label: "Received Doc",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row &&
                  row.kyc_received_documents &&
                  row.kyc_received_documents.length === 0
                  ? "bg-danger badge-soft-danger"
                  : "bg-success badge-soft-success"
                }`}
              pill
            >
              {row &&
                row.kyc_received_documents &&
                row.kyc_received_documents.length === 0
                ? "Pending"
                : "Completed"}
            </Badge>
          ),
        type: "text",
        headerStyle: {
          minWidth: "138px"
        },
      },
      // reportingTo
      {
        id: "6",
        value: "reportingTo",
        label: "Reporting To",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row && row.reportingTo && row.reportingTo.length === 0
                  ? "bg-danger badge-soft-danger"
                  : "bg-success badge-soft-success"
                }`}
              pill
            >
              {row && row.reportingTo && row.reportingTo.length === 0
                ? "Pending"
                : "Completed"}
            </Badge>
          ),
        type: "text",
        headerStyle: {
          minWidth: "138px"
        },
      },

      // reference
      {
        id: "6",
        value: "reference",
        label: "Reference",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row && row.reference && row.reference.length === 0
                  ? "bg-danger badge-soft-danger"
                  : "bg-success badge-soft-success"
                }`}
              pill
            >
              {row && row.reference && row.reference.length === 0
                ? "Pending"
                : "Completed"}
            </Badge>
          ),
        type: "text",
        headerStyle: {
          minWidth: "138px"
        },
      },
      {
        id: "6",
        value: "webAccess",
        label: "Is Web Access",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) => {
          // console.log(row)
          return (<span>{row && row.isWebAccess === true ? "YES" : "NO"}</span>)
        },
        type: "text",
        headerStyle: {
          minWidth: "140px"
        },
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) => {
          // console.log(row)
          return (<Badge
            className={`font-size-12 badge rounded-pill ${row && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row && row.status === 1 ? "Active" : "Inactive"}
          </Badge>)
        },
        headerStyle: {
          minWidth: "120px"
        },
        type: "text",
      },
      //
    ]
  },
},
//rejected lead obs

{
  schemaId: "cmVqZWN0ZWRsZWFk",
  name: "rejectedlead",
  title: "Rejected Lead",
  formTitle: "Rejected Lead",
  path: "/rejected-lead",
  visible:  true,
  ...cmVqZWN0ZWRsZWFk,
  page: "Rejected Lead",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},
//equipment audit report
{
  schemaId: "ZXF1aXBtZW50YXVkaXRyZXBvcnQ",
  name: "equipmentAuditReport",
  title: "Equipment Audit Report",
  path: "/equipment-audit-report",
  visible: true,
  formTitle: "Equipment Audit Report",
  page: "EquipmentAuditReport",
  ...ZXF1aXBtZW50YXVkaXRyZXBvcnQ,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
{
  schemaId: "bGVhZG9jY3VycmVk",
  name: "leadoccurred",
  title: "Lead Occurred",
  formTitle: "Lead Occurred",
  path: "/lead-acquired",
  visible:  true,
  ...bGVhZG9jY3VycmVk,
  page: "Lead Occurred",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},
 //EquipmentBrand
 {
  schemaId: "ZW1wbG95ZWUtcmVjb3Jk",
  name: "employeeRecord",
  title: "Employee Record",
  formTitle: "Employee Record",
  path: "/employee-record",
  visible: true,
  ...ZW1wbG95ZWUtcmVjb3Jk,
  page: "EmployeeRecord",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")

    return [

      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shortCode",
        label: "Short Code",
        autofillValue: codeValueMetaData,
        placeholder: "Enter Short Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "code",
      },
      {
        id: "5",
        value: "equipmentBrand",
        label: "Equipment Brand",
        placeholder: "Enter Equipment Brand",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,

        type: "text",
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.equipmentBrand}</p>
            </>
          )
        },
      },
      {
        id: "6",
        value: "description",
        label: "Description",
        sort: true,
        required: true,
        placeholder: "Enter Description",
        editRecord: true,
        viewRecord: true,
        type: "text",
        formatter: (cellContent, row) => {
          return <>
            <span style={{ textTransform: "uppercase" }}>{row.description}</span>
          </>
        },
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },



    ]
  },
},
//Year wise employee record
 {
  schemaId: "eWVhckVtcGxveWVlUmVjb3Jk",
  name: "yearEmployeeRecord",
  title: "Year Wise Employee Record",
  formTitle: "Year Wise Employee Record",
  path: "/year-employee-record",
  visible: true,
  ...eWVhckVtcGxveWVlUmVjb3Jk,
  page: "yearEmployeeRecord",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")

    return [

      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shortCode",
        label: "Short Code",
        autofillValue: codeValueMetaData,
        placeholder: "Enter Short Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "code",
      },
      {
        id: "5",
        value: "equipmentBrand",
        label: "Equipment Brand",
        placeholder: "Enter Equipment Brand",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,

        type: "text",
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.equipmentBrand}</p>
            </>
          )
        },
      },
      {
        id: "6",
        value: "description",
        label: "Description",
        sort: true,
        required: true,
        placeholder: "Enter Description",
        editRecord: true,
        viewRecord: true,
        type: "text",
        formatter: (cellContent, row) => {
          return <>
            <span style={{ textTransform: "uppercase" }}>{row.description}</span>
          </>
        },
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },



    ]
  },
},

  {
    schemaId: "RXF1aXBtZW50TWFwcGluZw",
    name: "EquipmentMapping",
    title: "Equipment Mapping",
    path: "/equipment-mapping",
    visible: true,
    formTitle: "Equipment Mapping",
    page: "ManageVendor",
    ...RXF1aXBtZW50TWFwcGluZw,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //Equipment Unmapping
  {
    schemaId: "ZXF1aXBtZW50VW5NYXBw",
    name: "equipmentMappedList",
    title: "Equipment MappedList",
    path: "/equipment-mapped-list",
    visible: true,
    formTitle: "Equipment MappedList",
    page: "EquipmentMappedList",
    ...ZXF1aXBtZW50VW5NYXBw,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //download qr
{
  schemaId: "ZG93bmxvYWRxcg",
  name: "downloadqr",
  title: "Download Qr",
  path: "/download-qr",
  visible: true,
  formTitle: "Equipment Audit",
  page: "Download Qr",
  ...ZG93bmxvYWRxcg,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
  //Offer Report
  {
    schemaId: "b2ZmZXJSZXBvcnQ",
    name: "offerReport",
    title: "Offer Report",
    path: "/offer-report",
    visible: true,
    formTitle: "Offer Report",
    page: "OfferReport",
    ...b2ZmZXJSZXBvcnQ,
    columns: (records = []) => {

      console.log(records, "record from api")

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //Source Report
  {
    schemaId: "c291cmNlUmVwb3J0",
    name: "sourceReport",
    title: "Source Report",
    path: "/source-report",
    visible: true,
    formTitle: "Source Report",
    page: "SourceReport",
    ...c291cmNlUmVwb3J0,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },


 //my works
   //my works pending
   {
    schemaId: "bXl3b3Jrcw",
    name: "myWorksPending",
    title: "My Works Pending",
    path: "/myworks-pending",
    visible: true,
    formTitle: "My Works Pending",
    page: "MyWorksPending",
    ...bXl3b3Jrcw,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
    //my works rework
    {
      schemaId: "bXl3b3Jrc2FsYnVt",
      name: "myWorksRework",
      title: "My Works Rework",
      path: "/myworks-rework",
      visible: true,
      formTitle: "MyWorksRework",
      page: "MyWorksRework",
      ... bXl3b3Jrc2FsYnVt,
      columns: (records = [], metaData) => {
    
        console.log(records, "record from api")
    
        const codeValueMetaData = metaData && metaData.codeOptions
    
        console.log(codeValueMetaData, "codeValueMetaData")
        return [
          {
            id: "1",
            value: "_id",
            label: "Id",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "2",
            value: "sno",
            label: "S.No",
            sort: false,
            editRecord: false,
            viewRecord: true,
            formatter: (cellContent, row, rowIndex) =>
              row.loading ? (
                <p className="card-text placeholder-glow">
                  <span className="placeholder col-7"></span>
                </p>
              ) : (
                rowIndex + 1
              ),
            type: "text",
          },
          {
            id: "3",
            value: "actions",
            label: "Actions",
            sort: false,
            editRecord: false,
            viewRecord: true,
            editFormatter: "actions",
            type: "text",
          },
          {
            id: "4",
            value: "code",
            autofillValue: codeValueMetaData,
            label: "Department Code",
            placeholder: "Enter Department Code",
            sort: true,
            editRecord: true,
            viewRecord: true,
            // required: true,
            formatter: (cellContent, row) => {
              return (
                <span style={{ textTransform: "uppercase" }}>
                  {row.code}
                </span>)
            },
            type: "code",
          },
          {
            id: "5",
            value: "name",
            label: "Department Name",
            placeholder: "Enter Department Name",
            sort: true,
            editRecord: true,
            viewRecord: true,
            required: true,
            formatter: (cellContent, row) => {
              return (
                <span style={{ textTransform: "uppercase" }}>
                  {row.name}
                </span>)
            },
            type: "textOnly",
            validations: "textOnly",
          },
          {
            id: "6",
            value: "status",
            label: "Status",
            sort: false,
            editRecord: false,
            viewRecord: true,
            formatter: (cellContent, row) =>
              row.loading ? (
                <p className="card-text placeholder-glow">
                  <span className="placeholder col-7"></span>
                </p>
              ) : (
                <Badge
                  className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                    }`}
                  color={row.badgeclass}
                  pill
                >
                  {row.status && row.status === 1 ? "Active" : "Inactive"}
                </Badge>
              ),
            type: "text",
          },
          {
            id: "7",
            value: "branches",
            label: "Branches",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "8",
            value: "insertedBy",
            label: "Inserted By",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "9",
            value: "updatedBy",
            label: "Updated By",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "10",
            value: "createdAt",
            label: "Created Date",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "11",
            value: "updatedAt",
            label: "Updated Date",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
        ]
      }
    },

  //my works qc pending
  {
    schemaId: "bXl3b3Jrc3JldG91Y2g",
    name: "myWorksQcPending",
    title: "MyWorks Qc Pending",
    path: "/myworks-qc-pending",
    visible: true,
    formTitle: "MyWorks Qc Pending",
    page: "MyWorksQcPending",
    ...bXl3b3Jrc3JldG91Y2g,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //my works photo
  // {
  //   schemaId: "bXl3b3Jrc3Bob3Rv",
  //   name: "myworksphoto",
  //   title: "MyWorksVideo",
  //   path: "/myworks-video",
  //   visible: true,
  //   formTitle: "MyWorksVideo",
  //   page: "MyWorksVideo",
  //   ...bXl3b3Jrc3Bob3Rv,
  //   columns: (records = [], metaData) => {
  
  //     console.log(records, "record from api")
  
  //     const codeValueMetaData = metaData && metaData.codeOptions
  
  //     console.log(codeValueMetaData, "codeValueMetaData")
  //     return [
  //       {
  //         id: "1",
  //         value: "_id",
  //         label: "Id",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //       {
  //         id: "2",
  //         value: "sno",
  //         label: "S.No",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: true,
  //         formatter: (cellContent, row, rowIndex) =>
  //           row.loading ? (
  //             <p className="card-text placeholder-glow">
  //               <span className="placeholder col-7"></span>
  //             </p>
  //           ) : (
  //             rowIndex + 1
  //           ),
  //         type: "text",
  //       },
  //       {
  //         id: "3",
  //         value: "actions",
  //         label: "Actions",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: true,
  //         editFormatter: "actions",
  //         type: "text",
  //       },
  //       {
  //         id: "4",
  //         value: "code",
  //         autofillValue: codeValueMetaData,
  //         label: "Department Code",
  //         placeholder: "Enter Department Code",
  //         sort: true,
  //         editRecord: true,
  //         viewRecord: true,
  //         // required: true,
  //         formatter: (cellContent, row) => {
  //           return (
  //             <span style={{ textTransform: "uppercase" }}>
  //               {row.code}
  //             </span>)
  //         },
  //         type: "code",
  //       },
  //       {
  //         id: "5",
  //         value: "name",
  //         label: "Department Name",
  //         placeholder: "Enter Department Name",
  //         sort: true,
  //         editRecord: true,
  //         viewRecord: true,
  //         required: true,
  //         formatter: (cellContent, row) => {
  //           return (
  //             <span style={{ textTransform: "uppercase" }}>
  //               {row.name}
  //             </span>)
  //         },
  //         type: "textOnly",
  //         validations: "textOnly",
  //       },
  //       {
  //         id: "6",
  //         value: "status",
  //         label: "Status",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: true,
  //         formatter: (cellContent, row) =>
  //           row.loading ? (
  //             <p className="card-text placeholder-glow">
  //               <span className="placeholder col-7"></span>
  //             </p>
  //           ) : (
  //             <Badge
  //               className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
  //                 ? "bg-success badge-soft-success"
  //                 : "bg-danger badge-soft-danger"
  //                 }`}
  //               color={row.badgeclass}
  //               pill
  //             >
  //               {row.status && row.status === 1 ? "Active" : "Inactive"}
  //             </Badge>
  //           ),
  //         type: "text",
  //       },
  //       {
  //         id: "7",
  //         value: "branches",
  //         label: "Branches",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //       {
  //         id: "8",
  //         value: "insertedBy",
  //         label: "Inserted By",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //       {
  //         id: "9",
  //         value: "updatedBy",
  //         label: "Updated By",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //       {
  //         id: "10",
  //         value: "createdAt",
  //         label: "Created Date",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //       {
  //         id: "11",
  //         value: "updatedAt",
  //         label: "Updated Date",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //     ]
  //   }
  // },
   //myclient save the photo
    
{
  schemaId: "bXljbGllbnRzYXZldGhlcGh",
  name: "myclientsavethephoto",
  title: "MyClientSaveThePhoto",
  path: "/client-save-photo",
  visible: true,
  formTitle: "MyClientSaveThePhoto",
  page: "MyClientSaveThePhoto",
  ...bXljbGllbnRzYXZldGhlcGh,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
     //my client save the video
     {
      schemaId: "bXljbGllbnRzYXZldGhldm",
      name: "myclientsavethevideo",
      title: "MyClientSaveTheVideo",
      path: "/client-save-video",
      visible: true,
      formTitle: "MyClientSaveTheVideo",
      page: "MyClientSaveTheVideo",
      ...bXljbGllbnRzYXZldGhldm,
      columns: (records = [], metaData) => {
    
        console.log(records, "record from api")
    
        const codeValueMetaData = metaData && metaData.codeOptions
    
        console.log(codeValueMetaData, "codeValueMetaData")
        return [
          {
            id: "1",
            value: "_id",
            label: "Id",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "2",
            value: "sno",
            label: "S.No",
            sort: false,
            editRecord: false,
            viewRecord: true,
            formatter: (cellContent, row, rowIndex) =>
              row.loading ? (
                <p className="card-text placeholder-glow">
                  <span className="placeholder col-7"></span>
                </p>
              ) : (
                rowIndex + 1
              ),
            type: "text",
          },
          {
            id: "3",
            value: "actions",
            label: "Actions",
            sort: false,
            editRecord: false,
            viewRecord: true,
            editFormatter: "actions",
            type: "text",
          },
          {
            id: "4",
            value: "code",
            autofillValue: codeValueMetaData,
            label: "Department Code",
            placeholder: "Enter Department Code",
            sort: true,
            editRecord: true,
            viewRecord: true,
            // required: true,
            formatter: (cellContent, row) => {
              return (
                <span style={{ textTransform: "uppercase" }}>
                  {row.code}
                </span>)
            },
            type: "code",
          },
          {
            id: "5",
            value: "name",
            label: "Department Name",
            placeholder: "Enter Department Name",
            sort: true,
            editRecord: true,
            viewRecord: true,
            required: true,
            formatter: (cellContent, row) => {
              return (
                <span style={{ textTransform: "uppercase" }}>
                  {row.name}
                </span>)
            },
            type: "textOnly",
            validations: "textOnly",
          },
          {
            id: "6",
            value: "status",
            label: "Status",
            sort: false,
            editRecord: false,
            viewRecord: true,
            formatter: (cellContent, row) =>
              row.loading ? (
                <p className="card-text placeholder-glow">
                  <span className="placeholder col-7"></span>
                </p>
              ) : (
                <Badge
                  className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                    }`}
                  color={row.badgeclass}
                  pill
                >
                  {row.status && row.status === 1 ? "Active" : "Inactive"}
                </Badge>
              ),
            type: "text",
          },
          {
            id: "7",
            value: "branches",
            label: "Branches",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "8",
            value: "insertedBy",
            label: "Inserted By",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "9",
            value: "updatedBy",
            label: "Updated By",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "10",
            value: "createdAt",
            label: "Created Date",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "11",
            value: "updatedAt",
            label: "Updated Date",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
        ]
      }
    },
    // //my client album

{
  schemaId: "bXljbGllbnRhbGJ1",
  name: "myclientalbum",
  title: "MyClientAlbum",
  path: "/client-album",
  visible: true,
  formTitle: "MyClientAlbum",
  page: "MyClientAlbum",
  ...bXljbGllbnRhbGJ1,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
 // my client retouch

 {
  schemaId: "bXljbGllbnRyZX",   
  name: "myclientretouch",
  title: "MyClientRetouch",
  path: "/client-retouch",
  visible: true,
  formTitle: "MyClientretouch",
  page: "MyClientRetouch",
  ...bXljbGllbnRyZX,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},


//my client video

{
  schemaId: "bXljbGllbnR2aWRl",
  name: "myclientvideo",
  title: "MyClientVideo",
  path: "/client-video",
  visible: true,
  formTitle: "MyClientVideo",
  page: "MyClientVideo",
  ...bXljbGllbnR2aWRl,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},

//my client rework inprogress  
{
  schemaId: "bXlDbGllbnRSZXdvcmt",
  name: "myClientReworkInProgress",
  title: "MyClient Rework InProgress",
  path: "/client-rework-inprogress",
  visible: true,
  formTitle:"MyClient Rework InProgress",
  page: "MyClient Rework InProgress",
  ...bXlDbGllbnRSZXdvcmt,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},



//myclient magazine
{
  schemaId: "bXlDbGllbnRNYWdhem",
  name: "myClientMagazine",
  title: "MyClient Magazine",
  path: "/client-magazine",
  visible: true,
  formTitle: "MyClient Magazine",
  page: "MyClient Magazine",
  ...bXlDbGllbnRNYWdhem,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},

//myclient og photos
{
  schemaId: "bXlDbGllbnRPZ",
  name: "myClientOgPhotos",
  title: "MyClient Og Photos",
  path: "/client-og-photos",
  visible: true,
  formTitle: "MyClient Og Photos",
  page: "MyClient Og Photos",
  ...bXlDbGllbnRPZ,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
//myclient Candid video
{
  schemaId: "bXlDbGllbnRDYW5k",
  name: "myClientCandidVideo",
  title: "MyClient Frame",
  path: "/client-candid-video",
  visible: true,
  formTitle: "MyClient Candid Video",
  page: "MyClient Candid Video",
  ...bXlDbGllbnRDYW5k,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},

//myclient color corrected
{
  schemaId: "bXlDbGllbnRDb2",
  name: "myClientColorCorrected",
  title: "MyClient Og Photos",
  path: "/client-color-corrected",
  visible: true,
  formTitle: "MyClient Color corrected",
  page: "MyClient Color Corrected",
  ...bXlDbGllbnRDb2,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
 //post crm candid video
{
  schemaId: "cG9zdENybUNh", 
  name: "postCrmCandidVideo",
  title: "Post CRM Candid Video",
  path: "/post-candid-video",
  visible: true,
  formTitle: "Post Crm Candid Video",
  page: "PostCrmCandidVideo",
  ...cG9zdENybUNh,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
}, 

//post changes inprogress
{
  schemaId: "cG9zdENoYW5nZXN",
  name: "postChangesInProgress",
  title: "Changes InProgress",
  path: "/post-changes-inprogress",
  visible: true,
  formTitle: "Changes InProgress",
  page: "PostChangesInProgress",
  ... cG9zdENoYW5nZXN,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},

{
  schemaId: "cG9zdFJld29ya0l",
  name: "postReworkInProgress",
  title: "Rework InProgress",
  path: "/post-rework-inprogress",
  visible: true,
  formTitle: "Rework InProgress",
  page: "PostReworkInProgress",
  ... cG9zdFJld29ya0l,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},

 //post qc pending
 {
  schemaId: "cG9zdFFjUGVuZG",
  name: "postQcPending",
  title: "Qc Pending",
  path: "/post-qc-pending",
  visible: true,
  formTitle: "Qc Pending",
  page: "PostQcPending",
  ... cG9zdFFjUGVuZG,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
//post changes inprogress
{
  schemaId: "cG9zdENoYW5nZXN",
  name: "postChangesInProgress",
  title: "Changes InProgress",
  path: "/post-changes-inprogress",
  visible: true,
  formTitle: "Changes InProgress",
  page: "PostChangesInProgress",
  ... cG9zdENoYW5nZXN,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
 //my works pending reworks
   {
    schemaId: "bXlXb3Jrc1BlbmRpbmdSZX",
    name: "myWorksPendingReworks",
    title: "MyWorks Pending Reworks",
    path: "/my-works-pending-reworks",
    visible: true,
    formTitle: "MyWorks Pending Reworks",
    page: "MyWorksPendingReworks",
    ...bXlXb3Jrc1BlbmRpbmdSZX,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
//my works pending changes
   {
    schemaId: "bXlXb3Jrc1BlbmRpbmdD",
    name: "myWorksPendingChanges",
    title: "MyWorks Pending Changes",
    path: "/my-works-pending-changes",
    visible: true,
    formTitle: "MyWorks Pending Changes",
    page: "MyWorksPendingChanges",
    ...bXlXb3Jrc1BlbmRpbmdD,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
//myclient Frame
{
  schemaId: "bXlDbGllbnRGcm",
  name: "myClientFrame",
  title: "MyClient Frame",
  path: "/client-frame",
  visible: true,
  formTitle: "MyClient Frame",
  page: "MyClient Frame",
  ...bXlDbGllbnRGcm,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
//myclient changes inprogress
{
  schemaId: "bXlDbGllbnRDaGFuZ",
  name: "myClientChangesInProgress",
  title: "MyClient Changes InProgress",
  path: "/client-changes-inprogress",
  visible: true,
  formTitle: "MyClient Changes InProgress",
  page: "MyClient Changes InProgress",
  ...bXlDbGllbnRDaGFuZ,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
//High value lead
{
  schemaId: "aGlnaFZhbHVlU3VtbWFyeQ",
  name: "highValueSummary",
  title: "High Value Lead Summary",
  path: "/high-value-lead-summary",
  visible: true,
  formTitle: "High Value Lead Summary",
  page: "HighValueLeadSummary",
  ...aGlnaFZhbHVlU3VtbWFyeQ,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
//manage high value lead
{
  schemaId: " bWFuYWdlSGlnaFZhbHV",
  name: "manageHighValueLead",
  title: "Manage High Value Lead",
  path: "/manage-high-value-lead ",
  visible: true,
  formTitle: "Manage High Value Lead",
  page: "ManageHighValueLead",
  ... bWFuYWdlSGlnaFZhbHV,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
//my high value lead
{
  schemaId: "bXlIaWdoVmFsdWVMZWFk",
  name: "myHighValueLead",
  title: "My high Value Lead",
  path: "/my-high-value-lead",
  visible: true,
  formTitle: "My High Value Lead",
  page: "MyHighValueLead",
  ...bXlIaWdoVmFsdWVMZWFk,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
//Freelancer Report

{
  schemaId: "ZnJlZWxhbmNlclJlcG9ydA",
  name: "freelancerReport",
  title: "FreelancerReport",
  path: "/freelancer-report",
  visible: true,
  formTitle: "FreelancerReport",
  page: "FreelancerReport",
  ...ZnJlZWxhbmNlclJlcG9ydA,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
     
  //Team scheduling Report
  // {
  //   schemaId: "dGVhbXNjaGVkd",
  //   name: "teamScheduling",
  //   title: "Team Scheduling",
  //   formTitle: "Team Scheduling",
  //   //path: "/",
  //   visible: true,
  //   ...dGVhbXNjaGVkd,
  //   page: "TeamScheduling",
  //   exact: true,
  //   columns: (records = []) => {

  //     console.log(records, "record from api")

  //     // const codeValueMetaData = metaData && metaData.codeOptions

  //     // console.log(codeValueMetaData, "codeValueMetaData")
  //     return [
  //       {
  //         id: "1",
  //         value: "_id",
  //         label: "Id",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //       {
  //         id: "2",
  //         value: "sno",
  //         label: "S.No",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: true,
  //         formatter: (cellContent, row, rowIndex) =>
  //           row.loading ? (
  //             <p className="card-text placeholder-glow">
  //               <span className="placeholder col-7"></span>
  //             </p>
  //           ) : (
  //             rowIndex + 1
  //           ),
  //         type: "text",
  //       },
  //       {
  //         id: "3",
  //         value: "actions",
  //         label: "Actions",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: true,
  //         editFormatter: "actions",
  //         type: "text",
  //       },
  //       {
  //         id: "4",
  //         value: "code",
  //         // autofillValue: codeValueMetaData,
  //         label: "Department Code",
  //         placeholder: "Enter Department Code",
  //         sort: true,
  //         editRecord: true,
  //         viewRecord: true,
  //         // required: true,
  //         formatter: (cellContent, row) => {
  //           return (
  //             <span style={{ textTransform: "uppercase" }}>
  //               {row.code}
  //             </span>)
  //         },
  //         type: "code",
  //       },
  //       {
  //         id: "5",
  //         value: "name",
  //         label: "Department Name",
  //         placeholder: "Enter Department Name",
  //         sort: true,
  //         editRecord: true,
  //         viewRecord: true,
  //         required: true,
  //         formatter: (cellContent, row) => {
  //           return (
  //             <span style={{ textTransform: "uppercase" }}>
  //               {row.name}
  //             </span>)
  //         },
  //         type: "textOnly",
  //         validations: "textOnly",
  //       },
  //       {
  //         id: "6",
  //         value: "status",
  //         label: "Status",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: true,
  //         formatter: (cellContent, row) =>
  //           row.loading ? (
  //             <p className="card-text placeholder-glow">
  //               <span className="placeholder col-7"></span>
  //             </p>
  //           ) : (
  //             <Badge
  //               className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
  //                 ? "bg-success badge-soft-success"
  //                 : "bg-danger badge-soft-danger"
  //                 }`}
  //               color={row.badgeclass}
  //               pill
  //             >
  //               {row.status && row.status === 1 ? "Active" : "Inactive"}
  //             </Badge>
  //           ),
  //         type: "text",
  //       },
  //       {
  //         id: "7",
  //         value: "branches",
  //         label: "Branches",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //       {
  //         id: "8",
  //         value: "insertedBy",
  //         label: "Inserted By",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //       {
  //         id: "9",
  //         value: "updatedBy",
  //         label: "Updated By",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //       {
  //         id: "10",
  //         value: "createdAt",
  //         label: "Created Date",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //       {
  //         id: "11",
  //         value: "updatedAt",
  //         label: "Updated Date",
  //         sort: false,
  //         editRecord: false,
  //         viewRecord: false,
  //         type: "text",
  //       },
  //     ]
  //   }
  // },
  //followup Feedback Report
  {
    schemaId: "Zm9sbG93dXBGZWVkYmFjaw",
    name: "followupFeedback",
    title: "Followup Feedback",
    path: "/followup-feedback-audit",
    visible: true,
    formTitle: "Followup Feedback",
    page: "FollowupFeedback",
    ...Zm9sbG93dXBGZWVkYmFjaw,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //Event Calendar Repo
  {
    schemaId: "ZXZlbnRDYWxlbmRhcg",
    name: "eventCalendar",
    title: "Event Calendar",
    path: "/lead-event-calendar",
    visible: true,
    formTitle: "Event Calendar",
    page: "EventCalendar",
    ...ZXZlbnRDYWxlbmRhcg,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //Mapped HR Report
  {
    schemaId: "ZXF1aXBtZW50TWFwcGVkSHI",
    name: "equipmentHr",
    title: "Equipment Hr",
    path: "/hr",
    visible: true,
    formTitle: "Equipment Hr",
    page: "Equipment Hr",
    ...ZXF1aXBtZW50TWFwcGVkSHI,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //my works completed
  {
    schemaId: "bXl3b3Jrc3Bob3Rv",
    name: "myWorksCompleted",
    title: "MyWorksComplted",
    path: "/myworks-completed",
    visible: true,
    formTitle: "MyWorksCompleted",
    page: "MyWorksCompleted",
    ...bXl3b3Jrc3Bob3Rv,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //work from home  
{
  schemaId: "d29ya2Zyb21ob21l",
  name: 'workfromhome',
  title: 'workfromhome',
  path: '/work-from-home',
  visible: true,
  formTitle: 'workfromhome',
  page: "Work From Home",
  ...d29ya2Zyb21ob21l, 
  exact: true,
  columns: () => [
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: true,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow" >
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Actions",
      sort: true,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "shiftName",
      label: "Shift Name",
      placeholder: "Enter Shift Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      formatter: (cellContent, row) => {
        return <span style={{textTransform: "uppercase"}}>{row.shiftName} </span>
        },
      type: "text",
    },
    {
      id: "5",
      value: "fromTiming",
      label: "From Timing",
      placeholder: "Enter From Timing",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      type: "time",
    },
  
     {
      id: "6",
      value: "toTiming",
      label: "To Timing",
      placeholder: "Enter To Timing",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      type: "time",
    },
     {
    id: '7',
    value: 'status',
    label: 'Status',
    sort: false,
    editRecord: false,
    viewRecord: true,
    formatter: (cellContent, row) =>
      row.loading ? (
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      ) : (
        <Badge
          className={`font-size-12 badge rounded-pill ${
            row.status === 1
              ? 'bg-success badge-soft-success'
              : 'bg-danger badge-soft-danger'
          }`}
          color={row.badgeclass}
          pill
        >
          {row.status === 1 ? 'Active' : 'Inactive'}
        </Badge>
      ),
    type: 'text',
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ],
},
  {
    schemaId: "cG9zdGFsYnVt",  
    name: "postalbum",
    title: "PostAlbum",
    path: "/post-album",
    visible: true,
    formTitle: "PostAlbum",
    page: "PostAlbum",
    ...cG9zdGFsYnVt,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //post video
  {
    schemaId: "cG9zdHZpZGVv",
    name: "postvideo",
    title: "PostVideo",
    path: "/post-video",
    visible: true,
    formTitle: "PostVideo",
    page: "PostVideo",
    ...cG9zdHZpZGVv,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
    //product category
    {
      schemaId: "cHJvZHVjdF9jYX",
      name: "deliverable_product_category",
      title: "Deliverable Product Category",
      path: "/product-category",
      visible: true,
      formTitle: "Deliverable Product Category",
      page: "ProductCategory",
      ...cHJvZHVjdF9jYX,
      columns: (records = [], metaData) => {
  
        console.log(records, "record from api")
  
        const codeValueMetaData = metaData && metaData.codeOptions
  
        console.log(codeValueMetaData, "codeValueMetaData")
        return [
          {
            id: "1",
            value: "_id",
            label: "Id",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "2",
            value: "sno",
            label: "S.No",
            sort: false,
            editRecord: false,
            viewRecord: true,
            formatter: (cellContent, row, rowIndex) =>
              row.loading ? (
                <p className="card-text placeholder-glow">
                  <span className="placeholder col-7"></span>
                </p>
              ) : (
                rowIndex + 1
              ),
            type: "text",
          },
          {
            id: "3",
            value: "actions",
            label: "Actions",
            sort: false,
            editRecord: false,
            viewRecord: true,
            editFormatter: "actions",
            type: "text",
          },
          {
            id: "4",
            value: "productCategoryCode",
            autofillValue: codeValueMetaData,
            label: "Deliverable Product Category Code",
            placeholder: "Enter Product Category Code",
            sort: true,
            editRecord: true,
            viewRecord: true,
            // required: true,
            type: "code",
          },
          {
            id: "5",
            value: "productCategory",
            label: "Deliverable Product Category Name",
            placeholder: "Enter Product Category Name",
            sort: true,
            editRecord: true,
            viewRecord: true,
            required: true,
            formatter: (cellContent, row) => {
              return <span style={{ textTransform: "uppercase" }}>{row.productCategory} </span>
            },
            type: "text",
          },
          {
            id: "6",
            value: "description",
            label: "Description",
            sort: true,
            required: true,
            placeholder: "Enter Description",
            editRecord: true,
            viewRecord: true,
            type: "text",
            formatter: (cellContent, row) => {
              return <>
                <span style={{ textTransform: "uppercase" }}>{row.description}</span>
              </>
            },
          },
          {
            id: "10",
            value: 'isPrintable',
            label: 'Printable',
            placeholder: 'Select Printable',
            sort: true,
            editRecord: true,
            viewRecord: true,
            type: 'checkbox',
            required:false,
            colProps: {
              lg: "3",
              md: "3",
              style: { paddingRight: '15px', marginTop: "26px" }
            },
            formatter: (cellContent, row) => {
              return (
                <span style={{ textTransform: "uppercase" }}>
                 <Badge
                  style={{
                    padding: "8px",
                    fontSize: "13px"
                  }}
                  color={row.isPrintable === true ? 'success' : "danger"}
                  pill
                >
                  {row.isPrintable === true ? "YES" : "NO"}
                </Badge> 
                </span>)
            },
          },
          {
            id: "7",
            value: "status",
            label: "Status",
            sort: false,
            editRecord: false,
            viewRecord: true,
            formatter: (cellContent, row) =>
              row.loading ? (
                <p className="card-text placeholder-glow">
                  <span className="placeholder col-7"></span>
                </p>
              ) : (
                <Badge
                  className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                    ? "bg-success badge-soft-success"
                    : "bg-danger badge-soft-danger"
                    }`}
                  color={row.badgeclass}
                  pill
                >
                  {row.status && row.status === 1 ? "Active" : "Inactive"}
                </Badge>
              ),
            type: "text",
          },
  
          {
            id: "8",
            value: "insertedBy",
            label: "Inserted By",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "9",
            value: "updatedBy",
            label: "Updated By",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "10",
            value: "createdAt",
            label: "Created Date",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "11",
            value: "updatedAt",
            label: "Updated Date",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
        ]
      },
    },
  //Inventory List Report
  {
    schemaId: "aW52ZW50b3J5TGlzdA",
    name: "inventoryList",
    title: "Inventory List",
    path: "/inventory-list",
    visible: true,
    formTitle: "Inventory List",
    page: "Inventory List",
    ...aW52ZW50b3J5TGlzdA,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //Mapped HR Report
  {
    schemaId: "ZXF1aXBtZW50QWRtaW4",
    name: "equipmentAdmin",
    title: "Equipment Admin",
    path: "/admin",
    visible: true,
    formTitle: "Equipment Admin",
    page: "EquipmentAdmin",
    ...ZXF1aXBtZW50QWRtaW4,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //Mapped HR Report
  {
    schemaId: "ZXF1aXBtZW50UGhvdG9ncm",
    name: "equipmentPhotography",
    title: "Equipment Photography",
    path: "/photography",
    visible: true,
    formTitle: "Equipment Photography",
    page: "EquipmentPhotography",
    ...ZXF1aXBtZW50UGhvdG9ncm,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: "ZXF1aXBtZW50SXQ",
    name: "equipmentIT",
    title: "Equipment IT",
    path: "/inventory-it",
    visible: true,
    formTitle: "Equipment IT",
    page: "EquipmentIT",
    ...ZXF1aXBtZW50SXQ,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
   //my works qc Completed List
   {
    schemaId: "bXlXb3Jrc1FjQ29t",
    name: "myWorksQcCompletedList",
    title: "MyWorks Qc Completed List",
    path: "/qc-completed-list",
    visible: true,
    formTitle: "MyWorks Qc Completed List",
    page: "MyWorksQcCompletedList",
    ...bXlXb3Jrc1FjQ29t,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //my client qc pending

    
 {
  schemaId: "bXlDbGllbnRRY1B",
  name: "myClientQcPending",
  title: "MyClient Qc Pending",
  path: "/client-qc-pending",
  visible: true,
  formTitle:"MyClient Qc Pending",
  page: "MyClient Qc Pending",
  ...bXlDbGllbnRRY1B,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
  {
    schemaId: "emdPcGVyYXRpb25z",
    name: "zgOperations",
    title: "ZG Operations",
    path: "/zg-operations",
    visible: true,
    formTitle: "ZG Operations",
    page: "ZGOperations",
    ...emdPcGVyYXRpb25z,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: "bXlCb29raW5nQ29tcGxldGU",
    name: "myBookingComplete",
    title: "My Booking Complete",
    path: "/my-booking-complete",
    visible: true,
    formTitle: "My Booking Complete",
    page: "MyBookingComplete",
    ...bXlCb29raW5nQ29tcGxldGU,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: "ZXF1aXBtZW50RGl2aW5l",
    name: "equipmentDivine",
    title: "Equipment Divine",
    path: "/divine",
    visible: true,
    formTitle: "Equipment Divine",
    page: "EquipmentDivine",
    ...ZXF1aXBtZW50RGl2aW5l,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  //Obs details
{
  schemaId: "bWFuYWdlLW9icw",
  name: "manageobs",
  title: "Manage Obs",
  formTitle: "Manage Obs",
  path: "/manage-obs",
  visible:  true,
  ...bWFuYWdlLW9icw,
  page: "ManageObs",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},
//My obs
{
  schemaId: "bXlvYnM",
  name: "myobs",
  title: "My Obs",
  formTitle: "My Obs",
  path: "/my-obs",
  visible:  true,
  ...bXlvYnM,
  page: "ManageObs",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},
  {
    schemaId: "ZXF1aXBtZW50U2VydmljZQ",
    name: "equipmentService",
    title: "Equipment Service",
    path: "/equipment-service",
    visible: true,
    formTitle: "Equipment Service",
    page: "EquipmentService",
    ...ZXF1aXBtZW50U2VydmljZQ,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: "ZXF1aXBtZW50VHJhc2g",
    name: "equipmentTrash",
    title: "Equipment Trash",
    path: "/equipment-trash",
    visible: true,
    formTitle: "Equipment Trash",
    page: "EquipmentTrash",
    ...ZXF1aXBtZW50VHJhc2g,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
{
  schemaId: "ZWNDbGllbnRDaGVja2xpc3Q",
  path: "/ec-client-checklist",
  name: "ecClientChecklist",
  title: "EcClientChecklist",
  formTitle: "EcClientChecklist",
  visible:  true,
  ...ZWNDbGllbnRDaGVja2xpc3Q,
  page: "EcClientChecklist",
  exact: true,
  columns: (records = [], metaData) => {
  
    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},
{
  schemaId: "ZWNUZWFtU2NoZWR1bGl",
  path: "/team-scheduling",
  name: "teamScheduling",
  title: "TeamScheduling",
  formTitle: "TeamScheduling",
  visible:  true,
  ...ZWNUZWFtU2NoZWR1bGl,
  page: "teamScheduling",
  exact: true,
  columns: (records = [], metaData) => {
  
    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},
{
  schemaId: "ZWNGb2xsb3d1cA",
  path: "/ec-followup",
  name: "ecFollowup",
  title: "ECFollowup",
  formTitle: "ECFollowup",
  visible:  true,
  ...ZWNGb2xsb3d1cA,
  page: "ECFollowup",
  exact: true,
  columns: (records = [], metaData) => {
  
    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},
{
  schemaId: "ZWNzZXJ2aWNl",
  path: "/ec-service",
  name: "ecservice",
  title: "Ec Service",
  formTitle: "Ec Service",
  visible:  true,
  ...ZWNzZXJ2aWNl,
  page: "EcServiceDetails",
  exact: true,
  columns: (records = [], metaData) => {
  
    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},
  {
    schemaId: "ZXF1aXBtZW50QXVkaXQ",
    name: "equipmentAudit",
    title: "Equipment Audit",
    path: "/equipment-audit",
    visible: true,
    formTitle: "Equipment Audit",
    page: "EquipmentAudit",
    ...ZXF1aXBtZW50QXVkaXQ,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
// Ec Question List
{
  schemaId: "Y2hlY2tsaX",
  name: 'check_list_question',
  title: 'CheckList Question',
  path: '/check-list-question',
  visible: true,
  formTitle: 'CheckList Question',
  page: "CheckListQuestion",
  ...Y2hlY2tsaX,
  columns: (record = {},metaData) => {
    console.log(metaData,"eventoptions")
      return [
          {
              id: "1",
              value: '_id',
              label: 'Id',
              sort: false,
              editRecord: false,
              viewRecord: false,
              type: 'text'
          },
          {
              id: "2",
              value: 'sno',
              label: 'S.No',
              sort: false,
              editRecord: false,
              viewRecord: true,
              formatter: (cellContent, row, rowIndex) => row.loading ? (
                  <p className="card-text placeholder-glow">
                      <span className="placeholder col-7"></span>
                  </p>
              ) : rowIndex + 1,
              type: 'text'
          },
          {
              id: "3",
              value: 'actions',
              label: 'Actions',
              sort: false,
              editRecord: false,
              viewRecord: true,
              editFormatter: 'actions',
              type: 'text'
          },
          {
            id: "4",
            value: 'seqNo',
            label: 'Sequence No',
            sort: true,
            editRecord: true,
            placeholder: "Enter Sequence Number",
            viewRecord: true,
            type: 'text',
            colProps: {
              lg: "12",
              md: "12",
              style: { paddingRight: '15px' }
          },
        },
      
      {
        id: "5",
        value: "eventId",
        label: "Event",
        editRecord: true,
        viewRecord: false,
        validations: "arrayField",
        colProps: {
          lg: "12",
              md: "12",
              style: { paddingRight: '15px' }
        },
        type: "multiSelect",
        options: "eventOptions",
      },
      {
        id: "6",
        value: "eventName",
        label: "Event",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) => {
          return (
          <span style={{ textTransform: "uppercase" }}>{row.eventName?row.eventName&& row.eventName.join(","):'_'}</span>
          )
        },
        required: true,
      },
      {
        id: "7",
        value: "groupNameId",
        label: "Group Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        colProps: {
          style: { paddingRight: '15px' }
        },
        formatter: (cellContent, row) => {
          return (
          <span>{row && row.groupName}</span>
          )
        },
        options: "groupOptions",
        type: "select",
        required: true,
      },
          {
              id: "7",
              value: 'questionType',
              label: 'Type',
              placeholder: 'Select Type',
              sort: true,
              editRecord: true,
              viewRecord: true,
              required: true,
              validationType: 'Question',
              type: 'select',
              colProps: {
                  lg: "12",
                  md: "12",
                  style: { paddingRight: '15px' }
              },
              formatter: (cellContent) => {
                  const options = [
                      {
                          label: 'QUESTION',
                          value: 'description'
                      },
                      {
                          label: 'FILL UP',
                          value: 'fillup'
                      },
                      {
                          label: 'CHOOSE THE BEST',
                          value: 'choose'
                      },
                  ]
                  return cellContent && options.find(_ => _.value.toString() === cellContent.toString()) && 
                  options.find(_ => _.value === cellContent).label || ''
              },
              options: [
                  {
                      label: 'QUESTION',
                      value: 'description'
                  },
                  {
                      label: 'FILL UP',
                      value: 'fillup'
                  },
                  {
                      label: 'CHOOSE THE BEST',
                      value: 'choose'
                  },
              ]
          }, 
          {
              id: "8",
              value: 'question',
              label: 'Question',
              placeholder: 'Enter Question',
              sort: true,
              editRecord: true,
              viewRecord: true,
              required: true,
              type: 'textarea',
              colProps: {
                  lg: "12",
                  md: "12",
                  style: { paddingRight: '15px' }
              },
          },
          {
              id: "9",
              value: 'options',
              label: 'Choose Option',
              placeholder: 'Enter Choose Option',
              sort: true,
              editRecord: record.questionType === 'choose' ? true : false,
              viewRecord: true,
              type: 'chooseOption',
              colProps: {
                  lg: "12",
                  md: "12",
                  style: { paddingRight: '15px' }
              },
            
            formatter: (cellContent,record) => {
              var optionValue = !isEmpty(cellContent)&&cellContent.map(m=>m.option)
              var options = !isEmpty(optionValue)&&optionValue.toString()
             console.log(options,"myoptions")
              return (record.questionType === 'choose' ?
                  <p> <span>{options}</span>
                 </p>
                  :
                  <p>-</p>
              )
          }
          },
          {
              id: "10",
              value: 'isMandatory',
              label: 'Mandatory',
              placeholder: 'Select Mandatory',
               sort: true,
              editRecord: true,
              viewRecord: true,
              // required: true,
              type: 'checkbox',
              colProps: {
                  lg: "3",
                  md: "3",
                  style: { paddingRight: '15px', marginTop: "26px" }
              },
              formatter: (cellContent, row) => {
               return (
                 <span style={{ textTransform: "uppercase" }}>
                   {row.isMandatory === 'true'? "YES" : "NO"}
                 </span>)
             },
          },
          {
            id: "11",
            value: 'description',
            label: 'Description',
            sort: true,
            editRecord: true,
            viewRecord: true,
            type: 'textarea',
            colProps: {
              lg: "12",
              md: "12",
              style: { paddingRight: '15px' }
          },
            formatter: (cellContent, row) => {
              return <span style={{textTransform: "uppercase"}}>{row.description} </span>
              },
            required:true,
          },
        
          {
              id: "12",
              value: 'status',
              label: 'Status',
              sort: false,
              editRecord: false,
              viewRecord: true,
              formatter: (cellContent, row) => row.loading ? (
                  <p className="card-text placeholder-glow">
                      <span className="placeholder col-7"></span>
                  </p>
              ) : (
                  <Badge
                      className={`font-size-12 badge rounded-pill ${row?.status === 1 ? 'bg-success badge-soft-success' : 'bg-danger badge-soft-danger'}`}
                      color={row?.badgeclass}
                      pill>
                      {row.status === 1 ? 'Active' : 'Inactive'}
                  </Badge>
              ),
              type: 'text'
          },
          {
              id: "13",
              value: 'insertedBy',
              label: 'Inserted By',
              sort: false,
              editRecord: false,
              viewRecord: false,
              type: 'text'
          },
          {
              id: "14",
              value: 'updatedBy',
              label: 'Updated By',
              sort: false,
              editRecord: false,
              viewRecord: false,
              type: 'text'
          },
          {
              id: "15",
              value: 'createdAt',
              label: 'Created Date',
              sort: false,
              editRecord: false,
              viewRecord: false,
              type: 'text'
          },
          {
              id: "16",
              value: 'updatedAt',
              label: 'Updated Date',
              sort: false,
              editRecord: false,
              viewRecord: false,
              type: 'text'
          }
      ]
  }
},
  {
    schemaId: "ZXF1aXBtZW50VmVybWlsaW9u",
    name: "equipmentVermilion",
    title: "Equipment Vermilion",
    path: "/vermilion",
    visible: true,
    formTitle: "Equipment Vermilion",
    page: "equipmentVermilion",
    ...ZXF1aXBtZW50VmVybWlsaW9u,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
 //EquipmentBrand
 {
  schemaId: "ZXF1aXBtZW50",
  name: "equipment_brand",
  title: "Equipment Brand List",
  formTitle: "Equipment Brand List",
  path: "/equipment-brand",
  visible: true,
  ...ZXF1aXBtZW50,
  page: "EquipmentBrand",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")

    return [

      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shortCode",
        label: "Short Code",
        autofillValue: codeValueMetaData,
        placeholder: "Enter Short Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "code",
      },
      {
        id: "5",
        value: "equipmentBrand",
        label: "Equipment Brand",
        placeholder: "Enter Equipment Brand",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,

        type: "text",
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.equipmentBrand}</p>
            </>
          )
        },
      },
      {
        id: "6",
        value: "description",
        label: "Description",
        sort: true,
        required: true,
        placeholder: "Enter Description",
        editRecord: true,
        viewRecord: true,
        type: "text",
        formatter: (cellContent, row) => {
          return <>
            <span style={{ textTransform: "uppercase" }}>{row.description}</span>
          </>
        },
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },



    ]
  },
},
//product model
{
  schemaId: "cHJvZHVjdCB2",
  name: "product_version",
  title: "Product Model List",
  formTitle: "Product Model List",
  path: "/product-model",
  visible: true,
  ...cHJvZHVjdCB2,
  page: "ProductModel",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")

    return [

      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shortCode",
        label: "Short Code",
        autofillValue: codeValueMetaData,
        placeholder: "Enter Short Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "code",
      },
      {
        id: "5",
        value: "productVersion",
        label: "Product Version",
        placeholder: "Enter Product Version",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,

        type: "text",
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.productVersion}</p>
            </>
          )
        },
      },
      {
        id: "6",
        value: "description",
        label: "Description",
        sort: true,
        required: true,
        placeholder: "Enter Description",
        editRecord: true,
        viewRecord: true,
        type: "text",
        formatter: (cellContent, row) => {
          return <>
            <span style={{ textTransform: "uppercase" }}>{row.description}</span>
          </>
        },
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },



    ]
  },
},
    // family_details
    {
      schemaId: "ZmFtaWx5",
      name: "family_details",
      title: "Family Details",
      formTitle: "Family Details",
      path: "/familyDetails",
      visible: true,
      ...ZmFtaWx5,
      page: "FamilyDetails",
      exact: true,
  
      actionClassName: "Family-Detail-Popup",
      otpcolumns: () => [
        {
          id: "1",
          value: "otp",
          label: "otp",
          placeholder: "Enter otp",
          sort: true,
          colProps: {
            lg: "4",
            md: "4",
            style: { paddingRight: "15px" },
          },
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
      ],
      columns: (actions) => {
        // console.log(record)
        return [
          {
            id: "1",
            value: "_id",
            label: "Id",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "2",
            value: "sno",
            label: "S.No",
            sort: false,
            editRecord: false,
            viewRecord: true,
            formatter: (cellContent, row, rowIndex) =>
              row.loading ? (
                <p className="card-text placeholder-glow">
                  <span className="placeholder col-7"></span>
                </p>
              ) : (
                rowIndex + 1
              ),
            type: "text",
          },
          {
            id: "3",
            value: "actions",
            label: "Action",
            sort: false,
            editRecord: false,
            viewRecord: true,
            editFormatter: "actions",
  
            type: "text",
          },
          {
            id: "4",
            value: "relationName",
            label: "Name",
            placeholder: "Enter Name",
            sort: true,
            required: true,
            colProps: {
              lg: "4",
              md: "4",
              style: { paddingRight: "15px" },
            },
            editRecord: true,
            viewRecord: true,
            type: "textOnly",
            validations: "textOnly"
          },
          {
            id: "5",
            value: "relationship",
            label: "Relationship",
            placeholder: "Enter Relationship",
            sort: true,
            editRecord: true,
            colProps: {
              lg: "4",
              md: "4",
              style: { paddingRight: "15px" },
            },
            viewRecord: true,
            required: true,
            type: "select",
            options: [
              {
                label: "Father",
                value: "father",
              },
              {
                label: "Mother",
                value: "mother",
              },
              {
                label: "Wife",
                value: "wife",
              },
              {
                label: "Brother",
                value: "brother",
              },
              {
                label: "Children",
                value: "child",
              },
              {
                label: "Others",
                value: "others",
              },
            ],
          },
          {
            id: "5",
            value: "relationMobile",
            label: "Mobile Number",
            placeholder: "Enter Mobile Number",
            sort: true,
            Validate: "number",
            editRecord: true,
            viewRecord: true,
            required: true,
            colProps: {
              lg: "4",
              md: "4",
              style: { paddingRight: "15px" },
              className: "employee-input"
            },
            data: actions,
            type: "mobile",
            validations: "mobile"
          },
          {
            id: "5",
            value: "relationAddress",
            label: "Address",
            placeholder: "Enter Address",
            sort: true,
            editRecord: true,
            viewRecord: true,
            required: true,
            colProps: {
              lg: "4",
              md: "4",
              style: { paddingRight: "15px" },
            },
            type: "textarea",
          },
          //
          {
            id: "6",
            value: "otpmodule",
            label: "Otp Status",
            sort: false,
            editRecord: false,
            viewRecord: true,
            actions: actions,
            formatter: (cellContent, row) =>
              row.loading ? (
                // console.log(row)'
                ""
              ) : (
                <OtpForm
                  key={`key`}
                  title={`Otp`}
                  id={row}
                  actions={actions}
                  funactions={actions}
                >
                  {(openDialog) => (
                    <a onClick={openDialog} className="">
                      Verify{" "}
                    </a>
                  )}
                </OtpForm>
              ),
            type: "text",
          },
          //
          {
            id: "6",
            value: "status",
            label: "Status",
            sort: false,
            editRecord: false,
            viewRecord: true,
            formatter: (cellContent, row) =>
              row.loading ? (
                <p className="card-text placeholder-glow">
                  <span className="placeholder col-7"></span>
                </p>
              ) : (
                <Badge
                  className={`font-size-12 badge rounded-pill ${
                    row.status
                      ? "bg-success badge-soft-success"
                      : "bg-danger badge-soft-danger"
                  }`}
                  color={row.badgeclass}
                  pill
                >
                  {row.status ? "Active" : "Inactive"}
                </Badge>
              ),
            type: "text",
          },
          {
            id: "8",
            value: "insertedBy",
            label: "Inserted By",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "9",
            value: "updatedBy",
            label: "Updated By",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "10",
            value: "createdAt",
            label: "Created Date",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "11",
            value: "updatedAt",
            label: "Updated Date",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
          {
            id: "11",
            value: "emp_id",
            label: "empid",
            sort: false,
            editRecord: false,
            viewRecord: false,
            type: "text",
          },
        ]
      },
    },
   // Work Experience
   {
    schemaId: "d29ya2V4",
    name: "workexp",
    title: "Work Experience",
    formTitle: "Work Experience",
    path: "/workExperience",
    visible: true,
    ...d29ya2V4,
    page: "WorkExperience",
    exact: true,
    actionClassName: "Family-Detail-Popup WorkExp workExperience",
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "companyName",
        label: "Company",
        placeholder: "Enter Company",
        sort: true,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        editRecord: true,
        viewRecord: true,
        type: "textOnly",
        validations: "textOnly"
      },
      {
        id: "5",
        value: "designation",
        label: "Designation",
        placeholder: "Enter Designation",
        sort: true,
        required: true,
        editRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        viewRecord: true,
        type: "textOnly",
        validations: "textOnly"
      },
      {
        id: "5",
        value: "fromDate",
        label: "From Date",
        placeholder: "Enter From Date",
        sort: true,
        editRecord: true,
        viewRecord: true,
        disabled: false,
        type: "date",
        formatter: (cellContent) => {
          return (cellContent && moment(cellContent).format("MM-DD-YYYY")) || ""
          // return metaData && metaData.procesStatusOption && metaData.procesStatusOption.length > 0 && metaData.procesStatusOption.filter(_ => cellContent.includes(_.value.toString())) && metaData.procesStatusOption.filter(_ => cellContent.includes(_.value.toString())).map(_ => _.label).join(',') || ''
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
      },
      {
        id: "5",
        value: "toDate",
        label: "To Date",
        placeholder: "Enter To Date",
        sort: true,
        editRecord: true,
        viewRecord: true,
        disabled: false,
        type: "date",
        formatter: (cellContent) => {
          return (cellContent && moment(cellContent).format("MM-DD-YYYY")) || ""
          // return metaData && metaData.procesStatusOption && metaData.procesStatusOption.length > 0 && metaData.procesStatusOption.filter(_ => cellContent.includes(_.value.toString())) && metaData.procesStatusOption.filter(_ => cellContent.includes(_.value.toString())).map(_ => _.label).join(',') || ''
        },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
      },
      {
        id: "5",
        value: "totalExp",
        label: "Total Exp",
        placeholder: "Enter Total Exp",
        sort: true,
        editRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "employee-input"
        },
        viewRecord: true,
        required: true,
        type: "number",
      },
      {
        id: "12",
        value: "attachments",
        label: "Attachments",
        placeholder: "Upload Attachments",
        editRecord: true,
        required: true,
        viewRecord: false,
        colProps: {
          lg: "4",
          md: "4",
          style: {
            padding: "0px",
          },
          className: "cls-profileimage",
        },
        type: "upload",
      },
      {
        id: "5",
        value: "description",
        label: "Description",
        placeholder: "Enter Description",
        sort: true,
        editRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        viewRecord: true,
        type: "textarea",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${
                row.status
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
              }`}
              color={row.badgeclass}
              pill
            >
              {row.status ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  // Bank Details
  {
    schemaId: "YmFuaw",
    name: "bank",
    title: "Bank Details",
    formTitle: "Bank Details",
    path: "/bankDetail",
    visible: true,
    ...YmFuaw,
    page: "BankDetails",
    exact: true,

    actionClassName: "Family-Detail-Popup bank bankDetail",
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },

      {
        id: "5",
        value: "accountName",
        label: "Account Holder",
        placeholder: "Enter Account Holder",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // formatter: (cellContent,row)=> {
        //     if(row.value < 2) {
        //       toast.error("Input value should be more than 1")
        //     }
        // },
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        required: true,
        type: "textOnly",
        validations: "textOnly"
      },
      {
        id: "4",
        value: "bankName",
        label: "Bank Name",
        placeholder: "Enter Bank Name",
        sort: true,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.bankName} </span>
          },
        type: "textOnly",
        validations: "textOnly"
      },

      {
        id: "5",
        value: "branchName",
        label: "Bank Branch",
        placeholder: "Enter Bank Branch",
        sort: true,
        editRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.branchName} </span>
          },
        type: "textOnly",
        validations: "textOnly"
      },
      {
        id: "5",
        value: "accountNo",
        label: "Account No",
        placeholder: "Enter Account No",
        sort: true,
        editRecord: true,
        Validate: "number",
        viewRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
          className: "employee-input"
        },
        required: true,
        type: "number",
      },
      {
        id: "5",
        value: "ifsc",
        label: "IFSC",
        placeholder: "Enter IFSC",
        sort: true,
        editRecord: true,
        viewRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.ifsc} </span>
          },
        type: "textOnly",
      },
      {
        id: "5",
        value: "type",
        label: "Account Type",
        placeholder: "Enter Account Type",
        sort: true,
        editRecord: true,
        viewRecord: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: "15px" },
        },
        required: true,
        type: "textOnly",
        validations: "textOnly"
      },

      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${
                row.status
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
              }`}
              color={row.badgeclass}
              pill
            >
              {row.status ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
   // kyc
   {
     schemaId: "a3lj",
     name: 'kyc',
     title: 'kyc',
     formTitle: 'kyc',
     path: '/kyc',
     visible: true,
     ...a3lj,
     page: 'Kyc',
     exact: true,
 
     actionClassName: 'Family-Detail-Popup  kyc',
     columns: () => {
       return [
         {
           id: "1",
           value: '_id',
           label: 'Id',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "2",
           value: 'sno',
           label: 'S.No',
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row, rowIndex) => row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : rowIndex + 1,
           type: 'text'
         },
         {
           id: "3",
           value: 'actions',
           label: 'Action',
           sort: false,
           editRecord: false,
           viewRecord: true,
           editFormatter: 'actions',
           type: 'text',
         },
         {
           id: "4",
           value: 'docId',
           label: 'Document Name',
           placeholder: 'Enter Document Name',
           sort: false,
           editRecord: true,
           viewRecord: true,
           required: true,
           colProps: {
             lg: "4",
             md: "4",
             style: { paddingRight: '15px' },
           },
           type: 'select', 
           formatter: (cellContent, row, rowIndex, metaData) => {
             return metaData && metaData.documentOptions && metaData.documentOptions.length > 0 && metaData.documentOptions.filter(_ => cellContent.includes(_.value.toString())) && metaData.documentOptions.filter(_ => cellContent.includes(_.value.toString())).map(_ => _.label).join(',') || ''
           },
           options: 'documentOptions'
         },
         {
          id: "5",
          value: "docNo",
          label: 'Document No',
          placeholder: 'Enter Document No',
          sort: false,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: { paddingRight: "15px" },
            className: "",
          },
          type: "text",
        },
         // upload
         {
           id: "6",
           value: 'filename',
           label: 'File Name',
           placeholder: 'Enter File Name',
           sort: true,
           required: true,
           colProps: {
             lg: "4",
             md: "4",
             style: { paddingRight: '15px' }
           },
           editRecord: true,
           viewRecord: true,
           formatter: (cellContent) => {
             const value = cellContent
 
             return (
               <div className="mb-3" style={{ display: 'flex', fontSize: "32px" }}>
                 <i className="text-muted bx bxs-file" onClick={() => window.open(value, '_blank')} />
 
               </div>
             )
           },
           type: 'upload'
         },
         {
           id: "7",
           value: 'status',
           label: 'Status',
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row) => row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${row.status ? 'bg-success badge-soft-success' : 'bg-danger badge-soft-danger'}`}
               color={row.badgeclass}
               pill>
               {row.status ? 'Active' : 'Inactive'}
             </Badge>
           ),
           type: 'text'
         },
         {
           id: "8",
           value: 'insertedBy',
           label: 'Inserted By',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "9",
           value: 'updatedBy',
           label: 'Updated By',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "10",
           value: 'createdAt',
           label: 'Created Date',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "11",
           value: 'updatedAt',
           label: 'Updated Date',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         }
       ]
     }
   },
   // Received Document
   {
     schemaId: "cmVjZWl2",
     name: 'received_doc',
     title: 'Received Document',
     formTitle: 'Received Document',
     path: '/receivedDocument',
     visible: true,
     ...cmVjZWl2,
     page: 'ReceivedDocument',
     exact: true,
 
     actionClassName: 'Family-Detail-Popup received_doc receivedDocument',
     columns: () => {
       return [
         {
           id: "1",
           value: '_id',
           label: 'Id',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "2",
           value: 'sno',
           label: 'S.No',
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row, rowIndex) => row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : rowIndex + 1,
           type: 'text'
         },
         {
           id: "3",
           value: 'actions',
           label: 'Action',
           sort: false,
           editRecord: false,
           viewRecord: true,
           editFormatter: 'actions',
           type: 'text',
         },
 
         {
           id: "15",
           value: 'docId',
           label: 'Document Name',
           placeholder: 'Enter Document Name',
           sort: false,
           editRecord: true,
           viewRecord: true,
           required: true,
           colProps: {
             lg: "4",
             md: "4",
             style: { paddingRight: '15px' },
           },
           type: 'select',
 
           formatter: (cellContent, row, rowIndex, metaData) => {
 
             return metaData && metaData.documentOptions && metaData.documentOptions.length > 0 && metaData.documentOptions.filter(_ => cellContent.includes(_.value.toString())) && metaData.documentOptions.filter(_ => cellContent.includes(_.value.toString())).map(_ => _.label).join(',') || ''
           },
           options: 'documentOptions'
         },
         {
          id: "5",
          value: "docNo",
          label: 'Document No',
          placeholder: 'Enter Document No',
          sort: false,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: { paddingRight: "15px" },
            className: "",
          },
          type: "text",
        },
         {
           id: "4",
           value: 'filename',
           label: 'File Name',
           placeholder: 'Enter File Name',
           sort: true,
           required: true,
           colProps: {
             lg: "4",
             md: "4",
             style: { paddingRight: '15px' }
           },
           editRecord: true,
           formatter: (cellContent) => {
             const value = cellContent
 
             return (
               <div className="mb-3" style={{ display: 'flex', fontSize: "32px" }}>
                 <i className="text-muted bx bxs-file" onClick={() => window.open(value, '_blank')} />
 
               </div>
             )
           },
           viewRecord: true,
           type: 'upload'
         },
         {
           id: "6",
           value: 'status',
           label: 'Status',
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row) => row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${row.status ? 'bg-success badge-soft-success' : 'bg-danger badge-soft-danger'}`}
               color={row.badgeclass}
               pill>
               {row.status ? 'Active' : 'Inactive'}
             </Badge>
           ),
           type: 'text'
         },
         {
           id: "8",
           value: 'insertedBy',
           label: 'Inserted By',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "9",
           value: 'updatedBy',
           label: 'Updated By',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "10",
           value: 'createdAt',
           label: 'Created Date',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "11",
           value: 'updatedAt',
           label: 'Updated Date',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         }
       ]
     }
   },
   // Reporting To
   {
     schemaId: "cmVwb3J0",
     name: 'reportingto',
     title: 'Reporting To',
     formTitle: 'Reporting To',
     path: '/reportingTo',
     visible: true,
     ...cmVwb3J0,
     page: 'ReportingTo',
     exact: true,
 
     actionClassName: 'Family-Detail-Popup received_doc ReportingTo',
     columns: () => [
       {
         id: "1",
         value: '_id',
         label: 'Id',
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: 'text'
       },
       {
         id: "2",
         value: 'sno',
         label: 'S.No',
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) => row.loading ? (
           <p className="card-text placeholder-glow">
             <span className="placeholder col-7"></span>
           </p>
         ) : rowIndex + 1,
         type: 'text'
       },
       {
         id: "3",
         value: 'actions',
         label: 'Action',
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: 'actions',
         type: 'text',
       },
       // {
       //     id: "4",
       //     value: 'reportingTo',
       //     label: 'Reporting To',
       //     placeholder: 'Reporting To',
       //     sort: true,
       //     colProps: {
       //         lg: "4",
       //         md: "4",
       //         style: { paddingRight: '15px' }
       //     },
       //     editRecord: true,
       //     viewRecord: true,
       //     type: 'select',
       //     formatter: (cellContent, row, rowIndex, metaData) => {
       //         return metaData && metaData.EmployeeCode && metaData.EmployeeCode.length > 0 && metaData.EmployeeCode.filter(_ => cellContent.includes(_.value.toString())) && metaData.EmployeeCode.filter(_ => cellContent.includes(_.value.toString())).map(_ => _.label).join(',') || ''
       //     },
       //     options: 'EmployeeCode'
       // },
       {
         id: "4",
         value: 'reportingTo',
         label: 'Reporting To',
         placeholder: 'Enter Reporting To',
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         colProps: {
           lg: "4",
           md: "4",
           style: { paddingRight: '15px' }
         },
         customLabel: ({ name, required, label }) => {
           return (<Label htmlFor={name}>{label} {required ? <span style={{ color: 'red' }}>*</span> : null} <span style={{ color: 'red' }}>(Auto Fill)</span></Label>)
         },
        //  formatter: (cellContent, row, rowIndex, metaData) => {
        //   const agentDetails =
        //     row &&
        //     row.leadAssign &&
        //     Array.isArray(row.leadAssign) &&
        //     row.leadAssign.length > 0 &&
        //     metaData &&
        //     metaData.employeeListOptions &&
        //     metaData.employeeListOptions.length > 0
        //       ? metaData.employeeListOptions.find(
        //           (k) =>
        //             row.leadAssign[row.leadAssign.length - 1] &&
        //             row.leadAssign[row.leadAssign.length - 1].assignedTo &&
        //             k.value.toString() ===
        //               row.leadAssign[
        //                 row.leadAssign.length - 1
        //               ].assignedTo.toString()
        //         )
        //       : false
        //   return <div>{(agentDetails && agentDetails.name) || ""}</div>
        // },
         formatter: (cellContent, row) => {
          console.log(row)
          return row.reportingToName
         },
         type: 'autocomplete',
         fuseOptions: { keys: ['empCode', 'name'] },
         options: 'employeeListOptions'
       },
       {
         id: "4",
         value: 'sequence',
         label: 'Sequence',
         placeholder: 'Enter Sequence',
         sort: true,
         colProps: {
           lg: "4",
           md: "4",
           style: { paddingRight: '15px' },
           className: "employee-input"
         },
         editRecord: true,
         viewRecord: true,
         required: true,
         type: 'number',
       },
       {
         id: "6",
         value: 'status',
         label: 'Status',
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) => row.loading ? (
           <p className="card-text placeholder-glow">
             <span className="placeholder col-7"></span>
           </p>
         ) : (
           <Badge
             className={`font-size-12 badge rounded-pill ${row.status === 1 ? 'bg-success badge-soft-success' : 'bg-danger badge-soft-danger'}`}
             color={row.badgeclass}
             pill>
             {row.status === 1 ? 'Active' : 'Inactive'}
           </Badge>
         ),
         type: 'text'
       },
       {
         id: "8",
         value: 'insertedBy',
         label: 'Inserted By',
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: 'text'
       },
       {
         id: "9",
         value: 'updatedBy',
         label: 'Updated By',
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: 'text'
       },
       {
         id: "10",
         value: 'createdAt',
         label: 'Created Date',
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: 'text'
       },
       {
         id: "11",
         value: 'updatedAt',
         label: 'Updated Date',
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: 'text'
       }
     ]
   },
 
 
   // reference_details
   {
     schemaId: "cmVmZXJl",
     name: 'reference_details',
     title: 'Reference Details',
     formTitle: 'Reference Details',
     path: '/referenceDetail',
     visible: true,
     ...cmVmZXJl,
     page: 'ReferenceDetail',
     exact: true,
 
     actionClassName: 'Family-Detail-Popup reference_details',
     columns: (actions) => {
       // console.log(actions)
       return [
         {
           id: "1",
           value: '_id',
           label: 'Id',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "2",
           value: 'sno',
           label: 'S.No',
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row, rowIndex) => row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : rowIndex + 1,
           type: 'text'
         },
         {
           id: "3",
           value: 'actions',
           label: 'Action',
           sort: false,
           editRecord: false,
           viewRecord: true,
           editFormatter: 'actions',
           type: 'text',
         },
 
         {
           id: "4",
           value: 'referenceName',
           label: 'Reference Name',
           placeholder: 'Enter Reference Name',
           sort: true,
           required: true,
           colProps: {
             lg: "4",
             md: "4",
             style: { paddingRight: '15px' }
           },
           editRecord: true,
           viewRecord: true,
           type: 'text',
           validations:"textOnly"
         },
         {
           id: "4",
           value: 'referenceMobile',
           label: 'Reference Mobile',
           placeholder: 'Enter Reference Mobile',
           sort: true,
           required: true,
           colProps: {
             lg: "4",
             md: "4",
             style: { paddingRight: '15px' }
           },
           editRecord: true,
           viewRecord: true,
           type: 'text',
           validations:"mobile"
         },
         {
           id: "4",
           value: 'referenceAddress',
           label: 'Reference Address',
           placeholder: 'Enter Reference Address',
           sort: true,
           required: true,
           colProps: {
             lg: "4",
             md: "4",
             style: { paddingRight: '15px' }
           },
           editRecord: true,
           viewRecord: true,
           type: 'textarea'
         },
         {
           id: "6",
           value: 'otpmodule',
           label: 'Status',
           sort: false,
           editRecord: false,
           viewRecord: true,
           actions: actions,
           formatter: (cellContent, row) => row.loading ?
             // console.log(row)'
             ''
             : (
               <OtpForm
                 key={`key`}
                 title={`Otp`}
                 id={row}
                 actions={actions}
                 funactions={actions}
               >
                 {(openDialog) => (
                   <a
                     onClick={
                       openDialog
                     }
                     className="">
                     Verify </a>)}
               </OtpForm>
             ),
           type: 'text'
         },
         {
           id: "6",
           value: 'status',
           label: 'Status',
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row) => row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${row.status ? 'bg-success badge-soft-success' : 'bg-danger badge-soft-danger'}`}
               color={row.badgeclass}
               pill>
               {row.status ? 'Active' : 'Inactive'}
             </Badge>
           ),
           type: 'text'
         },
         {
           id: "8",
           value: 'insertedBy',
           label: 'Inserted By',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "9",
           value: 'updatedBy',
           label: 'Updated By',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "10",
           value: 'createdAt',
           label: 'Created Date',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         },
         {
           id: "11",
           value: 'updatedAt',
           label: 'Updated Date',
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: 'text'
         }
       ]
     }
   },
   //manage obs lead
{
  schemaId: "bWFuYWdlb2JzbGVhZA",
  name: "manageobslead",
  title: "Manage Obs Lead",
  formTitle: "Manage Obs Lead",
  path: "/manage-obs-lead",
  visible:  true,
  ...bWFuYWdlb2JzbGVhZA,
  page: "ManageObsLead",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},
//my obs lead
{
  schemaId: "bXlvYnNsZWFk",
  name: "myobslead",
  title: "My Obs Lead",
  formTitle: "My Obs Lead",
  path: "/my-obs-lead",
  visible:  true,
  ...bXlvYnNsZWFk,
  page: "MyObsLead",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},
   // Employee equipment
   {
    schemaId: "ZW1wbG95ZWVFcXVpcG1lbnQ",
    name: 'Mapping_Equipment',
    title: 'Employee Equipment',
    formTitle: 'Employee Equipment',
    path: '/employee-equipment',
    visible: true,
    ...ZW1wbG95ZWVFcXVpcG1lbnQ,
    page: 'EmployeeEquipment',
    exact: true,

    actionClassName: 'Family-Detail-Popup employee-equipment',
    columns: () => [
      {
        id: "1",
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "2",
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) => row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : rowIndex + 1,
        type: 'text'
      },
      {
        id: "3",
        value: 'actions',
        label: 'Action',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      // {
      //     id: "4",
      //     value: 'reportingTo',
      //     label: 'Reporting To',
      //     placeholder: 'Reporting To',
      //     sort: true,
      //     colProps: {
      //         lg: "4",
      //         md: "4",
      //         style: { paddingRight: '15px' }
      //     },
      //     editRecord: true,
      //     viewRecord: true,
      //     type: 'select',
      //     formatter: (cellContent, row, rowIndex, metaData) => {
      //         return metaData && metaData.EmployeeCode && metaData.EmployeeCode.length > 0 && metaData.EmployeeCode.filter(_ => cellContent.includes(_.value.toString())) && metaData.EmployeeCode.filter(_ => cellContent.includes(_.value.toString())).map(_ => _.label).join(',') || ''
      //     },
      //     options: 'EmployeeCode'
      // },
      {
        id: "4",
        value: 'equipmentId',
        label: 'Equipment Name',
        placeholder: 'Enter Equipment Name',
        sort: true,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' }
        },
        customLabel: ({ name, required, label }) => {
          return (<Label htmlFor={name}>{label} {required ? <span style={{ color: 'red' }}>*</span> : null} <span style={{ color: 'red' }}>(Auto Fill)</span></Label>)
        },
        formatter: (cellContent, row) => {
         console.log(row)
         const equipmentName = row && row.equipmentId ? row.equipmentId.equipmentTypeName : []
         return equipmentName && equipmentName
        },
        type: 'autocomplete',
        fuseOptions: { keys: ['serialNumber', 'equipmentTypeName'] },
        options: 'equipmentListOptions'
      },
      {
        id: "5",
        value: 'equipmentCode',
        label: 'Equipment Code',
        placeholder: 'Enter Equipment Code',
        sort: true,
        editRecord: false,
        viewRecord: true,
        required: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' }
        },
        formatter: (cellContent, row) => {
          console.log(row)
          const equipmentCode = row && row.equipmentId ? row.equipmentId.equipmentCode : []
          return equipmentCode && equipmentCode
         },
        type: 'text',
      },
      {
        id: "6",
        value: 'serialNumber',
        label: 'Serial No',
        placeholder: 'Enter Serial No',
        sort: true,
        editRecord: false,
        viewRecord: true,
        required: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' }
        },
        formatter: (cellContent, row) => {
          console.log(row)
          const serialNumber = row && row.equipmentId ? row.equipmentId.serialNumber : []
          return serialNumber && serialNumber
         },
        type: 'text',
      },
      {
        id: "6",
        value: 'equipmentType',
        label: 'Equipment Type',
        placeholder: 'Enter Equipment Type',
        sort: true,
        editRecord: false,
        viewRecord: true,
        required: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' }
        },
        formatter: (cellContent, row) => {
          console.log(row)
          const equipmentTypeName = row && row.equipmentId ? row.equipmentId.equipmentTypeName : []
          return equipmentTypeName && equipmentTypeName
         },
        type: 'text',
      },
      {
        id: "7",
        value: 'productVersionName',
        label: 'Product Version',
        placeholder: 'Enter Product Version',
        sort: true,
        editRecord: false,
        viewRecord: true,
        required: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' }
        },
        formatter: (cellContent, row) => {
          console.log(row)
          const productVersionName = row && row.equipmentId ? row.equipmentId.productVersionName : []
          return productVersionName && productVersionName
         },
        type: 'text',
      },
      {
        id: "8",
        value: 'brandName',
        label: 'Brand Name',
        placeholder: 'Enter Brand Name',
        sort: true,
        editRecord: false,
        viewRecord: true,
        required: false,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' }
        },
        formatter: (cellContent, row) => {
          console.log(row)
          const equipmentBrandName = row && row.equipmentId ? row.equipmentId.equipmentBrandName : []
          return equipmentBrandName && equipmentBrandName
         },
        type: 'text',
      },
      {
        id: "4",
        value: 'notes',
        label: 'Notes',
        placeholder: 'Enter Notes',
        sort: true,
        colProps: {
          lg: "8",
          md: "8",
          style: { paddingRight: '15px', marginBottom: "10px" },
          className: "employee-input"
        },
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'textarea',
      },
      {
        id: "6",
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) => row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1 ? 'bg-success badge-soft-success' : 'bg-danger badge-soft-danger'}`}
            color={row.badgeclass}
            pill>
            {row.status === 1 ? 'Active' : 'Inactive'}
          </Badge>
        ),
        type: 'text'
      },
      {
        id: "8",
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "9",
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "10",
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "11",
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      }
    ]
  },
 // hike
 {
  schemaId: "aGlrZQ",
  name: 'hike',
  title: 'Hike',
  formTitle: 'Hike',
  path: '/hike',
  visible: true,
  ...aGlrZQ,
  page: 'Hike',
  exact: true,

  actionClassName: 'Family-Detail-Popup hike',
  // editButton: ({ record = {}, access }) => {
  //     const history = useHistory()

  //     return (<button
  //         type="button"
  //         onClick={() => { history.push({ pathname: '/create-employee', state: { detail: record, access } }) }}
  //         style={{ marginRight: '8px' }}
  //         className="btn btn-success edit-table-btn">
  //         <i className="mdi mdi-pencil d-block font-size-16"></i>
  //     </button>)
  // },
  columns: (record ={}, metaData, records, formRecord) => {
console.log(record, metaData, "records" )
console.log(records, formRecord, "records" )

const hikeDate = new Date()
console.log(hikeDate, "hikeDate from Api")
      return [
          {
              id: "1",
              value: '_id',
              label: 'Id',
              sort: false,
              editRecord: false,
              viewRecord: false,
              type: 'text'
          },
          {
              id: "2",
              value: 'sno',
              label: 'S.No',
              sort: false,
              editRecord: false,
              viewRecord: true,
              formatter: (cellContent, row, rowIndex) => row.loading ? (
                  <p className="card-text placeholder-glow">
                      <span className="placeholder col-7"></span>
                  </p>
              ) : rowIndex + 1,
              type: 'text'
          },
          {
              id: "3",
              value: 'actions',
              label: 'Action',
              sort: false,
              editRecord: false,
              viewRecord: true,
              editFormatter: 'hike',
              type: 'text',
          },

          {
              id: "4",
              value: "hikeDate",
              label: 'Hike Date',
              placeholder: 'Enter Hike Date',
              sort: true,
              required: true,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: { paddingRight: '15px' }
              },
              editRecord: true,
              viewRecord: true,
              type: 'date',
              formatter: (cellContent) => {
                  return cellContent && moment(cellContent).format('MM-DD-YYYY') || ''
              },
          },
          {
              id: "4",
              value: 'hikeAmount',
              label: 'Hike Amount',
              placeholder: 'Enter Hike Amount',
              sort: true,
              required: true,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: { paddingRight: '15px' },
                  className: "employee-input"
              },
              editRecord: true,
              viewRecord: true,
              type: "number",
          },
          {
              id: "4",
              value: 'hikePer',
              label: 'Hike Percentage',
              placeholder: 'Enter Hike Percentage',
              sort: true,
              required: true,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: { paddingRight: "15px" },
                  className: "employee-input"
                },
                editRecord: true,
                viewRecord: true,
                formatter: (cellContent, row) => {
                  const per = row && Math.round(row.hikePer)
                  console.log(per, "per")
                  return per
              },
                type: "number",
          },
          // "currentSalary":"30000",

          {
              id: "4",
              value: 'currentSalary',
              label: 'Current Salary',
              placeholder: 'Enter Current Salary',
              sort: true,
              disabled: true,
              required: true,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: {paddingRight: "15px"},
                  className: "employee-input"
                },
                editRecord: true,
                viewRecord: true,
                type: "number",
          },
          // "hikedSalary":"33000",

          {
              id: "4",
              value: 'hikedSalary',
              label: 'New Hike Salary',
              placeholder: 'Enter New Hike Salary',
              sort: true,
              disabled: true,
              required: true,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: {paddingRight: "15px"},
                  className: "employee-input"
                },
                editRecord: true,
                viewRecord: true,
                type: "number",
          },
          // "notes":"test",

          {
              id: "4",
              value: 'notes',
              label: 'Note',
              placeholder: 'Enter Note',
              sort: true,
              required: true,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: { paddingRight: '15px' }
              },
              editRecord: true,
              viewRecord: true,
              type: 'textarea'
          },
          // "nhikeTenure":"12 months",
          {
              id: "4",
              value: 'nhikeTenure',
              label: 'Hike Tenure',
              placeholder: 'Enter Hike Tenure',
              sort: true,
              // disabled: true,
              required: true,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: { paddingRight: '15px' }
              },
              editRecord: true,
              viewRecord: true,
              type: "select",
              options: [
                {
                  label: "3 Month",
                  value: "3",
                },
                {
                  label: "6 Month",
                  value: "6",
                },
                {
                  label: "12 Month",
                  value: "12",
                },
              ],
          },
          // "nhikeDate":"2022-01-01",
          {
              id: "4",
              value: 'nhikeDate',
              label: 'Next Hike Date',
              placeholder: 'Enter Next Hike Date',
              sort: true,
              required: true,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: { paddingRight: '15px' }
              },
              editRecord: true,
              viewRecord: true,
              type: 'date',
              formatter: (cellContent) => {
                  return cellContent && moment(cellContent).format('MM-DD-YYYY') || ''
              },
          },
          // "nhikeAmount":"4000",
          {
              id: "4",
              value: 'nhikeAmount',
              label: 'Next Hike Amount',
              placeholder: 'Enter Next Hike Amount',
              sort: true,
              required: false,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: { paddingRight: "15px" },
                  className: "employee-input"
                },
                editRecord: true,
                viewRecord: true,
                type: "number",
          },
          // "nhikePer":"15"

          {
              id: "4",
              value: 'nhikePer',
              label: 'Next Hike Percentage',
              placeholder: 'Enter Next Hike Percentege',
              sort: true,
              required: false,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: { paddingRight: "15px" },
                  className: "employee-input"
                },
                editRecord: true,
                viewRecord: true,
                type: "number",
          },
          {
              id: "4",
              value: 'nhikeRemarks',
              label: 'Next Hike Remarks',
              placeholder: 'Enter Hike Remark',
              sort: true,
              required: true,
              colProps: {
                  lg: "4",
                  md: "4",
                  style: { paddingRight: '15px' }
              },
              editRecord: true,
              viewRecord: true,
              type: 'textarea'
          },
          {
              id: "6",
              value: 'status',
              label: 'Status',
              sort: false,
              editRecord: false,
              viewRecord: true,
              formatter: (cellContent, row) => row.loading ? (
                  <p className="card-text placeholder-glow">
                      <span className="placeholder col-7"></span>
                  </p>
              ) : (
                  <Badge
                      className={`font-size-12 badge rounded-pill ${row.status ? 'bg-success badge-soft-success' : 'bg-danger badge-soft-danger'}`}
                      color={row.badgeclass}
                      pill>
                      {row.status ? 'Active' : 'Inactive'}
                  </Badge>
              ),
              type: 'text'
          },
          {
              id: "8",
              value: 'insertedBy',
              label: 'Inserted By',
              sort: false,
              editRecord: false,
              viewRecord: false,
              type: 'text'
          },
          {
              id: "9",
              value: 'updatedBy',
              label: 'Updated By',
              sort: false,
              editRecord: false,
              viewRecord: false,
              type: 'text'
          },
          {
              id: "10",
              value: 'createdAt',
              label: 'Created Date',
              sort: false,
              editRecord: false,
              viewRecord: false,
              type: 'text'
          },
          {
              id: "11",
              value: 'updatedAt',
              label: 'Updated Date',
              sort: false,
              editRecord: false,
              viewRecord: false,
              type: 'text'
          }
      ]
  }
},
 // other_details
 {
  schemaId: "b3RoZXJf",
  name: 'other_details',
  title: 'Other Details',
  formTitle: 'Other Details',
  path: '/otherDetails',
  visible: true,
  ...b3RoZXJf,
  page: 'OtherDetails',
  exact: true,

  actionClassName: 'Family-Detail-Popup otherdetail',

  columns: (record = {}) => {
    const radioOption = [
      {
        label: 'Yes',
        value: '1'
      },
      {
        label: 'No',
        value: '2'
      }
    ]
    const bondTypeOption = [
      {
        label: 'One time',
        value: '1'
      },
      {
        label: 'renewable',
        value: '2'
      }
    ]
    const officeAccommodationOptions = [
      {
        label: 'Temporary',
        value: '1'
      },
      {
        label: 'Permenant',
        value: '2'
      }
    ]

    const commutationOption = [
      {
        label: 'Public',
        value: 'Public'
      },
      {
        label: 'Private',
        value: 'Private'
      }
    ]


    return [
      {
        id: "1",
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "2",
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,

        formatter: (cellContent, row, rowIndex) => row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : rowIndex + 1,
        type: 'text'
      },
      {
        id: "3",
        value: 'actions',
        label: 'Action',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },

      {
        id: "0",
        value: 'bond',
        label: 'Bond',
        placeholder: 'Enter Bond',
        sort: true,
        required: true,
        updateRecords: true,
        colProps: {
          lg: record.bond != '1' ? "12" : "4",
          md: record.bond != '1' ? "12" : "4",
          style: { paddingRight: '15px' },

        },
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent) => {
          return radioOption.find(_ => _.value === cellContent).label
        },
        type: 'radio',
        options: radioOption,
      },

      {
        id: "1",
        value: "noOfYears",
        label: 'No of Years',
        placeholder: 'Enter No of Years',
        sort: false,
        row: true,
        updateRecords: true,
        editRecord: record.bond === '1' ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: "employee-input"
        },
        type: 'number',
      },
      {
        id: "2",
        value: "cashTenureMonth",
        label: 'Cash Tenure(Months)',
        updateRecords: true,
        placeholder: 'Enter Cash Tenure(Months)',
        sort: false,
        editRecord: record.bond === '1' ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' }
        },
        type: 'text',
        rowEnd: true
      },
      {
        id: "3",
        value: "cashValue",
        label: 'Cash Value',
        updateRecords: true,
        placeholder: 'Enter Cash Value',
        sort: false,
        editRecord: record.bond === '1' ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: "employee-input"
        },
        type: 'number',
      },
      {
        id: "4",
        value: "BondType",
        label: 'Bond Type',
        updateRecords: true,
        placeholder: 'Enter Bond Type',
        sort: false,
        editRecord: record.bond === '1' ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' }
        },
        options: bondTypeOption,
        type: 'select',
        formatter: (cellContent) => {
          return bondTypeOption.find(_ => _.value === cellContent).label
        },
      },
      {
        id: "5",
        value: "advanceForm",
        label: 'Advance Form',
        updateRecords: true,
        placeholder: 'Select Advance Form',
        sort: false,
        editRecord: record.bond === '1' ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' }
        },
        options: radioOption,
        type: 'select',
        formatter: (cellContent) => {
          return radioOption.find(_ => _.value === cellContent).label
        },
      },
      {
        id: "6",
        value: "bondNotice",
        label: 'Bond Notice',
        updateRecords: true,
        placeholder: 'Enter Bond Notice',
        sort: false,
        editRecord: record.bond === '1' ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: record.bond != '1' ? "" : "Right-2"
        },
        type: 'text',
      },

      // COMMUTATION
      {
        id: "7",
        value: 'commutation',
        label: 'Commutation',
        placeholder: 'Enter Commutation',
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        updateRecords: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: record.commutation ? 'cls-commutation-title  cls-clr-wt' : 'cls-commutation-title  Right-2 cls-clr-wt'
        },
        options: commutationOption,
        type: 'radio',
        formatter: (cellContent) => {
          return commutationOption.find(_ => _.value === cellContent).label
        },
      },

      {
        id: "8",
        value: 'modeOfTransportPublic',
        label: 'Mode of Transport',
        placeholder: 'Enter Mode of Transport',
        sort: false,
        editRecord: record.commutation === 'Public' ? true : false,
        viewRecord: false,
        updateRecords: true,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px', marginRight: "1px" },
          className: 'cls-clr-wt'
        },
        type: 'text',

      },
      // add btn multi vehical

      {
        id: "9",
        value: 'modeOfTransport',
        label: '',
        placeholder: '',
        updateRecords: true,
        sort: false,
        editRecord: record.commutation === 'Private' ? true : false,
        viewRecord: false,
        required: false,
        colProps: {
          lg: "12",
          md: "12",
          style: { paddingRight: '15px', marginRight: "1px", height: "unset !important" },
          className: ''
        },
        type: 'transportDetail',
      },
      // Accommodation
      {
        id: "10",
        value: 'officeAccommodation',
        label: 'Office Accommodation',
        placeholder: 'Enter Office Accommodation',
        sort: false,
        editRecord: true,
        viewRecord: true,
        updateRecords: true,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: record.officeAccommodation === '1' ? 'cls-officeAccommodation-title  cls-clr-wt' : 'cls-officeAccommodation-title  Right-2 cls-clr-wt'
        },
        type: 'radio',
        options: radioOption,
        formatter: (cellContent) => {
          return radioOption.find(_ => _.value === cellContent).label
        },
      },
      {
        id: "11",
        value: 'officeAccommodationType',
        label: 'Job Type',
        placeholder: 'Enter Job Type',
        sort: false,
        updateRecords: true,
        editRecord: record.officeAccommodation === '1' ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: record.officeAccommodation === '1' && record.officeAccommodationType != '1' && record.officeAccommodationType != '2' ? 'Right-1 cls-clr-wt' : 'cls-clr-wt'
        },
        type: 'radio',
        options: officeAccommodationOptions,
        formatter: (cellContent) => {
          return officeAccommodationOptions.find(_ => _.value === cellContent).label
        },
      },
      {
        id: "12",
        value: 'Tenure',
        label: 'Tenure',
        updateRecords: true,
        placeholder: 'Enter Tenure',
        sort: false,
        editRecord: (record.officeAccommodation === '1' && record.officeAccommodationType === '1') ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: 'cls-clr-wt'
        },
        type: 'text',
      },
      {
        id: "13",
        value: 'Rent',
        label: 'Rent ',
        placeholder: 'Enter Rent ',
        sort: false,
        updateRecords: true,
        editRecord: (record.officeAccommodation === '1' && record.officeAccommodationType === '1') ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: record.Rent === undefined || record.Rent === '2' ? 'Right-2' : ''
        },
        type: 'radio',
        options: radioOption,
        formatter: (cellContent) => {
          return radioOption.find(_ => _.value === cellContent).label
        },
      },

      {
        id: "14",
        value: 'rentAmount',
        label: 'Rent Amount',
        placeholder: 'Enter Rent Amount',
        sort: false,
        updateRecords: true,
        editRecord: (record.officeAccommodation === '1' && record.officeAccommodationType === '1' && record.Rent === '1') ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: 'Right-1 employee-input'
        },
        type: 'number',
      },
      {
        id: "15",
        value: 'permanentRent',
        label: 'Rent ',
        placeholder: 'Enter Rent ',
        sort: false,
        updateRecords: true,
        editRecord: (record.officeAccommodation === '1' && record.officeAccommodationType === '2') ? true : false,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: 'cls-clr-wt'
        },
        type: 'radio',
        options: radioOption,
        formatter: (cellContent) => {

          return radioOption.find(_ => _.value === cellContent).label
        },
      },

      {
        id: "16",
        value: 'PermanentRentrentAmount',
        label: 'Rent Amount',
        placeholder: 'Enter Rent Amount',
        sort: false,
        editRecord: (record.officeAccommodation === '1' && record.officeAccommodationType === '2' && record.permanentRent === '1') ? true : false,
        viewRecord: false,
        required: true,
        updateRecords: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: 'Right-2 employee-input'
        },
        type: 'number',
        formatter: () => { },
      },

      {
        id: "17",
        value: 'inventory',
        label: 'Inventory ',
        placeholder: 'Enter Inventory ',
        sort: false,
        editRecord: true,
        updateRecords: true,
        viewRecord: true,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: 'cls-inventory-title cls-clr-wt'
        },
        type: 'radio',
        options: radioOption,
        formatter: (cellContent) => {
          return radioOption.find(_ => _.value === cellContent).label
        },
      },

      {
        id: "18",
        value: 'inventoryDetails',
        label: 'Add Details',
        placeholder: 'Enter Add Details',
        sort: false,
        editRecord: record.inventory === '1' ? true : false,
        viewRecord: false,
        updateRecords: true,
        required: true,
        colProps: {
          lg: "4",
          md: "4",
          style: { paddingRight: '15px' },
          className: 'cls-clr-wt'
        },
        type: 'multiSelect',
        validations: "arrayField",
        formatter: (cellContent, row, rowIndex, metaData) => {
          return metaData && metaData.inventoryDetailsOption && metaData.inventoryDetailsOption.length > 0 && metaData.inventoryDetailsOption.filter(_ => cellContent.includes(_.value.toString())) && metaData.inventoryDetailsOption.filter(_ => cellContent.includes(_.value.toString())).map(_ => _.label).join(',') || ''
        },
        options: [
          { label: 'Keyboard', value: 'Keyboard' },
          { label: 'laptop', value: 'laptop' },
          { label: 'laptopcharger', value: 'laptop Charger' },
          { label: 'mobile', value: 'Mobile ' },
          { label: 'mobilecharger', value: 'Mobile Charger' },
          { label: 'mobilesim', value: 'MobileSim' },
          { label: 'Mouse', value: 'Mouse' },
          { label: 'WirelessDongle', value: 'Wireless Dongle' },
          { label: 'others', value: 'others' },
        ]
      },
      {
        id: "19",
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) => row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status ? 'bg-success badge-soft-danger' : 'bg-danger badge-soft-success'}`}
            color={row.badgeclass}
            pill
          >
            {row.status ? "Inactive" : "Active"}
          </Badge>
        ),
        type: 'text'
      },
      {
        id: "20",
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "9",
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "10",
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "11",
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      }
    ]
  }
},
   // EmployeeQuestion
   {
     schemaId: "RW1wbG95",
     name: 'EmployeeQuestion',
     title: 'Questions',
     formTitle: 'Questions',
     path: '/employee-question',
     visible: true,
     ...RW1wbG95,
     page: 'EmployeeQuestions',
     exact: true,
 
     actionClassName: 'Family-Detail-Popup  employeeQuestions',
     columns: () => {
         // console.log(records)
         return [
             {
                 editRecord: true,
                 colProps: {
                     lg: "12",
                     md: "12",
                 },
                 
             },
         ]
     }
 },
 {
  schemaId: "c3BlY2lhbGlu",
  path: "/special_instruction",
  name: "special_instruction",
  title: "Special Instruction",
  formTitle: "Special Instruction",
  visible:  true,
  ...c3BlY2lhbGlu,
  page: "EcSpecialInstruction",
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
//equipment scheduling
 //freelancer

   {
    schemaId: "c3ViZnJlZWxhbmNlcg",
    name: 'subfreelancer',
    title: 'managesubfreelancer',
    path: '/manage-subfreelancer',
    visible: true,
    formTitle: 'Sub Freelancer',
    page: "ManageSubFrelancer",
    ...c3ViZnJlZWxhbmNlcg, 
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow" >
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: true,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shiftName",
        label: "Shift Name",
        placeholder: "Enter Shift Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.shiftName} </span>
          },
        type: "text",
      },
      {
        id: "5",
        value: "fromTiming",
        label: "From Timing",
        placeholder: "Enter From Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
    
       {
        id: "6",
        value: "toTiming",
        label: "To Timing",
        placeholder: "Enter To Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
       {
      id: '7',
      value: 'status',
      label: 'Status',
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${
              row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
            }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? 'Active' : 'Inactive'}
          </Badge>
        ),
      type: 'text',
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
{
  schemaId: "ZXF1aXBtZW50X",
  name: "equipment_scheduling",
  title: "Equipment Scheduling",
  formTitle: "Equipment Scheduling",
  path:'/equipment-scheduling',
  visible:  true,
  ...ZXF1aXBtZW50X,
  page: "EquipmentScheduling",
  exact: true,
  columns: (records = [], metaData) => {
  
    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
    return[
  
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Action",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "code",
      label: "Source Code",
      autofillValue: codeValueMetaData,
      placeholder: "Enter Source Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      type: "code",
    },
    {
      id: "5",
      value: "sourceName",
      label: "Source Name",
      placeholder: "Enter Source Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      
      type: "text",
      formatter: (cellContent, row) => {
        console.log(row, "row from api")
        return (
          <>
            <p style={{ textTransform: "uppercase" }}>{row.sourceName}</p>
          </>
        )},},
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status === 1
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]},
},

//post crm frame
{
  schemaId: "cG9zdGNybWZyYW1l",
  name: "postcrmframe",
  title: "Frame",
  path: "/post-frame",
  visible: true,
  formTitle: "Post Crm Frame",
  page: "PostCrmMagazine",
  ...cG9zdGNybWZyYW1l,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
//post crm magazine
{
  schemaId: "cG9zdGNybW1hZ2F6aW5l",
  name: "postcrmmagazine",
  title: "Magazine",
  path: "/post-magazine",
  visible: true,
  formTitle: "Post Crm Magazine",
  page: "PostCrmMagazine",
  ...cG9zdGNybW1hZ2F6aW5l,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
 {
  schemaId: "ZXF1aXBtZW50X2",
  name: "equipment_master",
  title: "Equipment",
  path: "/equipment-master",
  visible: true,
  formTitle: "Equipment",
  page: "Equipment Master",
  ...ZXF1aXBtZW50X2,
  columns: (record= {}, metaData) => {
    // console.log(records, "record from api")
    
    const codeValueMetaData = record && record.codeOptions
    
//  console.log(codeValueMetaData, "codeValueMetaData")
 console.log(metaData, "metaData")
  return[
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      csvExport: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Actions",
      sort: false,
      csvExport: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "6",
      value: "companyName",
      label: "Company",
      sort: true,
      editRecord: false,
      viewRecord: true,
      required: false,
      validation: false,
      formatter: (cellContent, row) => {
        const company = row && !isEmpty(row.companyName) ? row.companyName : "--"
        return (<p style={{textTransform:"uppercase"}}>{company}</p>
        )
      },
      type: "select",
    },
    {
      id: "6",
      value: "branchName",
      label: "Branch",
      sort: true,
      editRecord: false,
      viewRecord: true,
      required: false,
      validation: false,
      formatter: (cellContent, row) => {
        const branch = row && !isEmpty(row.branchName) ? row.branchName : "--"

        return (<p style={{textTransform:"uppercase"}}>{branch}</p>
        )
      },
      type: "select",
    },
    {
      id: "4",
      value: "mode",
      label: "Mode",
      placeholder: "Select Mode",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      validation: true,
      formatter: (cellContent, row) => {
        return (<p style={{textTransform:"uppercase"}}>{row.mode}</p>
        )
      },
      type: "select",
      options: [
        {
          label: "ADMIN",
          value: "ADMIN"
        },
        {
          label: "HR",
          value: "HR"
        },
        {
          label: "PHOTOGRAPHY",
          value: "PHOTOGRAPHY"
        },
        {
          label: "IT",
          value: "IT"
        },
        {
          label: "VERMILION",
          value: "VERMILION"
        },
        {
          label: "DIVINE",
          value: "DIVINE"
        },
        {
          label: "ZG OPERATIONS",
          value: "ZG OPERATIONS",
        }
      ],
    },
    {
      id: "6",
      value: "equipmentTypeId",
      label: "Equipment Type",
      placeholder: "Select Equipment Type",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      validation: true,
      formatter: (cellContent, row) => {
        return (<p style={{textTransform:"uppercase"}}>{row.equipmentTypeName}</p>
        )
      },
      type: "select",
      options: "equipmentOptions",
    },
    {
      id: "7",
      value: "equipmentBrandId",
      label: "Equipment Brand",
      placeholder: "Select Equipment Brand",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      validation: true,
      formatter: (cellContent, row) => {
        return (<p style={{textTransform:"uppercase"}}>{row.equipmentBrandName}</p>
        )
      },
      type: "select",
      options: "equipmentBrandOptions",
    },
    {
      id: "8",
      value: "productVersionId",
      label: "Product Version",
      placeholder: "Select Product Version",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      validation: true,
      formatter: (cellContent, row) => {
        return (<p style={{textTransform:"uppercase"}}>{row.productVersionName}</p>
        )
      },
      type: "select",
      options: "productOptions",
    },
    
 
    {
      id: "9",
      value: "equipmentCode",
      autofillValue: codeValueMetaData,
      label: "Equipment Code",
      placeholder: "Enter Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      // required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.equipmentCode}
          </span> )
        },
      type: "code",
    },
    {
      id: "10",
      value: "supplierName",
      label: "Supplier Name",
      placeholder: "Enter Supplier Name",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
         {row.supplierName}
          </span> )
      },
      type: "textOnly",
      validations: "textOnly",
    },
    {
      id: "12",
      value: "serialNumber",
      label: "Serial Number",
      placeholder: "Enter Serial Number",
      sort: true,
      editRecord: true,
      Validate: "number",
      viewRecord:true,
      required: true,
      type: "text",
      validations: "text"
    },
    {
      id: "13",
      value: "dateOfEntry",
      label: "Date of Entry",
      placeholder: "Enter Date",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
     //  disabled: false,
      type: "date",
      formatter: (cellContent, row)=> {
      const date= moment(row.dateOfEntry).format("DD-MM-YYYY")
      // {console.log(row.dateOfEntry, "dateee")}
      return(<>{date}</>)
      }
     
    },
    {
      id: "14",
      value: "dateOfPurchase",
      label: "Date of Purchase",
      placeholder: "Enter Date",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
     //  disabled: false,
      type: "date",
      formatter: (cellContent, row)=> {
       const date = moment(row.dateOfPurchase).format("DD-MM-YYYY")
       return (<>
           <span style={{textTransform: "uppercase"}}>{date}</span>
       </>)
      }
     
    },
    // {
    //   id: "15",
    //   value: "vendorId",
    //   label: "Vendor",
    //   placeholder: "Select Vendor",
    //   sort: true,
    //   editRecord: true,
    //   viewRecord: true,
    //   required: true,
    //   validation: true,
    //   formatter: (cellContent, row)=> {
       
    //     return (<>
    //         <span style={{textTransform: "uppercase"}}>{row.vendorName}</span>
    //     </>)
    //    },
    //   options: "vendorOptions",
    // },
    {
      id: "16",
      value: "warrantyType",
      label: "Warranty Duration",
      placeholder: "Enter Warranty Duration",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.warrantyType}
          </span> )
      },
      type: "text",
      validations: "text",
    },
    {
      id: "16",
      value: "warrantyEndDate",
      label: "Warranty End Date",
      placeholder: "Enter Warranty End Date",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: false,
      formatter: (cellContent, row)=> {
        // console.log(row)
        const date = moment(row.warrantyEndDate).format("DD-MM-YYYY")
        return (<>
            <span style={{textTransform: "uppercase"}}>{date}</span>
        </>)
       },
      type: "date",
      // validations: "text",
    },
    {
      id: "16",
      value: "isService",
      label: "Is Service",
      placeholder: "Enter Service",
      sort: true,
      editRecord: false,
      viewRecord: true,
      editFormatter: "toggleAccess",
      required: false,
      labelStyle: {
        fontSize: "12px",
      },
      customActiveToggleBtn: ({openModal, record = {} })=> {
        const access = record &&
        record.isService

        // console.log(record, access, "record, access")
        if(access === true){
        return (
          <button
            onClick={openModal}
            disabled={access && access === true ? true : false }
            type="button"
            className="btn btn-success"
            style={{padding: "4px 7.5px"}}
          >
             {/* <i className="fa fa-globe font-size-14"></i> */}
         Yes
          </button>
          
        )
      } else {
        return ""
      }
      },
      customToggleBtn: ({openModal, record = {} })=> {
        const access = record &&
        record.isService

        // console.log(record, access, "record, access")
        if(access === false){
        return (
          <button
            onClick={openModal}
            // disabled={access && access === true ? false : true }
            type="button"
            className="btn btn-danger"
            style={{padding: "4px 10.5px"}}
          >
             {/* <i className="fa fa-globe font-size-14"></i> */}
           No
          </button>
          
        )
      } else {
        return ""
      }
      },
      customServiceHistoryBtn: ({openModal, record = {} })=> {
        const access = record &&
        record.isService

        console.log(access, "record, access")

        return (
          <div
            onClick={openModal}
            // disabled={access && access === true ? false : true }
            // type="button"
            style={{
              textTransform: "capitalize",
              textDecoration: "underline",
              fontSize: "12px",
              color: "#50a5f1",
              marginLeft: "8px",
              marginTop: "4px",
            }}
          >
             {/* <i className="fa fa-globe font-size-14"></i> */}
             History
          </div>
          
        )
      },
      // formatter: (cellContent, row)=> {
      //   console.log(row)
      //   // const date = moment(row.warrantyEndDate).format("DD-MM-YYYY")
      //   return (<>
      //       <span style={{textTransform: "uppercase"}}>{"date"}</span>
      //   </>)
      //  },
      type: "text",
      // validations: "text",
    },
    {
      id: "16",
      value: "isTrash",
      label: "Is Trash",
      placeholder: "Enter Service",
      sort: true,
      editRecord: false,
      viewRecord: true,
      editFormatter: "toggleTrash",
      required: false,
      labelStyle: {
        fontSize: "12px",
      },
      customActiveTrashBtn: ({ record = {} })=> {
        const access = record &&
        record.isTrash

        // console.log(, access, "record, access")
        if(access === true){
        return (
          <button
            // onClick={openModal}
            disabled={access && access === true ? true : false }
            type="button"
            className="btn btn-success"
            style={{padding: "4px 7.5px"}}
          >
             {/* <i className="fa fa-globe font-size-14"></i> */}
         Yes
          </button>
          
        )
      } else {
        return ""
      }
      },
      customTrashBtn: ({ record = {} })=> {
        const access = record &&
        record.isTrash

        // console.log(record, access, "record, access")
        if(access === false){
        return (
          <button
            // onClick={openModal}
            // disabled={access && access === true ? false : true }
            type="button"
            className="btn btn-danger"
            style={{padding: "4px 10.5px"}}
          >
             {/* <i className="fa fa-globe font-size-14"></i> */}
           No
          </button>
          
        )
      } else {
        return ""
      }
      },
      customTrashHistoryBtn: ({openModal, record = {} })=> {
        const access = record &&
        record.isTrash

        console.log( access, "record, access")

        return (
          <div
            onClick={openModal}
            // disabled={access && access === true ? false : true }
            // type="button"
            style={{
              textTransform: "capitalize",
              textDecoration: "underline",
              fontSize: "12px",
              color: "#50a5f1",
              marginLeft: "8px",
              marginTop: "4px",
            }}
          >
             {/* <i className="fa fa-globe font-size-14"></i> */}
             History
          </div>
          
        )
      },
      // formatter: (cellContent, row)=> {
      //   console.log(row)
      //   // const date = moment(row.warrantyEndDate).format("DD-MM-YYYY")
      //   return (<>
      //       <span style={{textTransform: "uppercase"}}>{"date"}</span>
      //   </>)
      //  },
      type: "text",
      // validations: "text",
    },
    {
      id: "16",
      value: "downloadHistory",
      label: "Download History",
      sort: true,
      editRecord: false,
      viewRecord: true,
      csvExport: false,
      editFormatter: "downloadQR",
      required: false,
      labelStyle: {
        fontSize: "12px",
      },
      customDownloadHistoryBtn: ({openModal, record = {} })=> {
        const access = record &&
        record.isTrash

        console.log(access, "record, access")

        return (
          <div
            onClick={openModal}
            // disabled={access && access === true ? false : true }
            // type="button"
            style={{
              textTransform: "capitalize",
              textDecoration: "underline",
              fontSize: "12px",
              color: "#50a5f1",
              marginLeft: "8px",
              marginTop: "4px",
            }}
          >
             {/* <i className="fa fa-globe font-size-14"></i> */}
             History
          </div>
          
        )
      },
      // formatter: (cellContent, row)=> {
      //   console.log(row)
      //   // const date = moment(row.warrantyEndDate).format("DD-MM-YYYY")
      //   return (<>
      //       <span style={{textTransform: "uppercase"}}>{"date"}</span>
      //   </>)
      //  },
      type: "text",
      // validations: "text",
    },
    {
      id: "17",
      value: "invoiceAttachment",
      label: "Invoice Attachment",
      placeholder: "Upload Attachment",
      editRecord: true,
      required: false,
      viewRecord: false,
      colProps: {
        lg: "7",
        md: "7",
        xl: "7",
        style: {
          marginTop: "-8px",
          marginBottom: "8px"
        },
        className: "cls-profileimage",
      },
      type: "upload",
    },
    
    {
      id: "17",
      value: "notes",
      label: "Notes",
      placeholder: "Enter Description",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: false,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
         {row.notes}
          </span> )
      },
      type: "textOnly",
      validations: "textOnly",
    },
    {
      id: "18",
      value: "attachment",
      label: "Product",
      placeholder: "Upload Attachment",
      editRecord: true,
      required: false,
      viewRecord: false,
      colProps: {
        lg: "6",
        md: "6",
        // style: {
        //   padding: "0px",
        // },
        className: "cls-profileimage",
      },
      type: "upload",
    },
    {
      id: "20",
      value: "equipmentQR",
      label: "QR Code",
      placeholder: "Upload Attachment",
      editRecord: false,
      editFormatter: "qrCode",
      sort: true,
      csvExport: false,
      required: false,
      viewRecord: true,
      colProps: {
        lg: "12",
        md: "12",
        // style: {
        //   padding: "0px",
        // },
        className: "cls-profileimage",
      },
      type: "text",
    },
    {
      id: "19",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${
              row.status && row.status === 1 
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
            }`}
            color={row.badgeclass}
            pill
          >
            {row.status && row.status === 1  ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    
  ]}
},
//post crm color corrected

{
  schemaId: "cG9zdENybUNvbG9",
  name: "postCrmColorCorrected",
  title: "Post CRM Color Corrected",
  path: "/post-color-corrected",
  visible: true,
  formTitle: "Post Crm Color Corrected",
  page: "PostCrmColorCorrected",
  ...cG9zdENybUNvbG9,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},

//post crm og photos

{
  schemaId: "cG9zdENybU9",
  name: "postCrmOgPhotos",
  title: "Post CRM OG Photos",
  path: "/post-og-photos",
  visible: true,
  formTitle: "Post Crm OG Photos",
  page: "PostCrmOgPhotos",
  ...cG9zdENybU9,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},

{
  schemaId: "c21zVGVtcGxhdGUK",
  name: 'sms_template',
  title: "Sms Template",
  formTitle: "Sms Template",
  path:  "/sms-template",
  visible: true,
  ...c21zVGVtcGxhdGUK,
  page: 'SmsTemplateDetails',
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
 return[
  {
    id: "1",
    value: "_id",
    label: "Id",
    sort: false,
    editRecord: false,
    viewRecord: false,
    type: "text",
  },
  {
    id: "2",
    value: "sno",
    label: "S.No",
    sort: false,
    csvExport: false,
    editRecord: false,
    viewRecord: true,
    formatter: (cellContent, row, rowIndex) =>
      row.loading ? (
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      ) : (
        rowIndex + 1
      ),
    type: "text",
  },
  {
    id: "3",
    value: "actions",
    label: "Actions",
    sort: false,
    csvExport: false,
    editRecord: false,
    viewRecord: true,
    editFormatter: "actions",
    type: "text",
  },
  {
    id: "6",
    value: "title",
    label: "Title",
    sort: true,
    editRecord: true,
    viewRecord: true,
    placeholder: "Enter Title",
    required: true,
    // validation: false,
    
    type: "textOnly",
    validations: "textOnly",
  },
  {
    id: "6",
    value: "textMessage",
    label: "Message",
    placeholder: "Enter Text Message",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: true,
    // validation: false,
   
    type: "textarea",
    // validations: "textOnly",
  },
  {
    id: "4",
    value: "smsStatus",
    label: "SMS Status",
    placeholder: "Select Status",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: true,
    validation: true,
    
    type: "select",
    options: [
      {
        label: "PENDING",
        value: "PENDING"
      },
      
      {
        label: "APPROVED",
        value: "APPROVED"
      },
      {
        label: "REJECTED",
        value: "REJECTED",
      }
    ],
  },
  {
    id: "6",
    value: "entityId",
    label: "Entity Id",
    placeholder: "Enter Entity Id",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: false,
    colProps: {
      className: "employee-input",
      style: {
        marginTop: "4px"
      }
    },
    type: "number",
  },
  {
    id: "7",
    value: "templateId",
    label: "Template Id",
    placeholder: "Enter Template Id",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: false,
    colProps: {
      className: "employee-input",
      style: {
        marginTop: "10px"
      }
    },
    type: "number",
  },

  {
    id: "19",
    value: "status",
    label: "Status",
    sort: false,
    editRecord: false,
    viewRecord: true,
    formatter: (cellContent, row) =>
      row.loading ? (
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      ) : (
        <Badge
          className={`font-size-12 badge rounded-pill ${
            row.status && row.status === 1 
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
          }`}
          color={row.badgeclass}
          pill
        >
          {row.status && row.status === 1  ? "Active" : "Inactive"}
        </Badge>
      ),
    type: "text",
  },
  
]

},
},

//pre changes inprogress
{
  schemaId: "cHJlQ2hhbmdlc0l",
  name: "preChangesInProgress",
  title: "Changes InProgress",
  path: "/pre-changes-inprogress",
  visible: true,
  formTitle: "Changes InProgress",
  page: "PreChangesInProgress",
  ... cHJlQ2hhbmdlc0l,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
 //pre qc pending
  {
    schemaId: "cHJlUWNQZW5kaW5n",
    name: "preQcPending",
    title: "Qc Pending",
    path: "/pre-qc-pending",
    visible: true,
    formTitle: "Qc Pending",
    page: "PreQcPending",
    ... cHJlUWNQZW5kaW5n,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
 //pre rework inprogress
  {
    schemaId: "cHJlUmV3b3JrSW5Q",
    name: "preReworkInProgress",
    title: "Rework InProgress",
    path: "/pre-rework-inprogress",
    visible: true,
    formTitle: "Rework InProgress",
    page: "PreReworkInProgress",
    ... cHJlUmV3b3JrSW5Q,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
//Raise Ticket
{
  schemaId: "cmFpc2VUaWNrZXQ",
  name: 'raiseTicket',
  title: "Raise Ticket",
  formTitle: "Raise Ticket",
  path:  "/raise-ticket",
  visible: true,
  ...cmFpc2VUaWNrZXQ,
  page: 'RaiseTicket',
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
 return[
  {
    id: "1",
    value: "_id",
    label: "Id",
    sort: false,
    editRecord: false,
    viewRecord: false,
    type: "text",
  },
  {
    id: "2",
    value: "sno",
    label: "S.No",
    sort: false,
    csvExport: false,
    editRecord: false,
    viewRecord: true,
    formatter: (cellContent, row, rowIndex) =>
      row.loading ? (
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      ) : (
        rowIndex + 1
      ),
    type: "text",
  },
  {
    id: "3",
    value: "actions",
    label: "Actions",
    sort: false,
    csvExport: false,
    editRecord: false,
    viewRecord: true,
    editFormatter: "actions",
    type: "text",
  },
  {
    id: "6",
    value: "title",
    label: "Title",
    sort: true,
    editRecord: true,
    viewRecord: true,
    placeholder: "Enter Title",
    required: true,
    // validation: false,
    
    type: "textOnly",
    validations: "textOnly",
  },
  {
    id: "6",
    value: "textMessage",
    label: "Message",
    placeholder: "Enter Text Message",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: true,
    // validation: false,
   
    type: "textarea",
    // validations: "textOnly",
  },
  {
    id: "4",
    value: "smsStatus",
    label: "SMS Status",
    placeholder: "Select Status",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: true,
    validation: true,
    
    type: "select",
    options: [
      {
        label: "PENDING",
        value: "PENDING"
      },
      
      {
        label: "APPROVED",
        value: "APPROVED"
      },
      {
        label: "REJECTED",
        value: "REJECTED",
      }
    ],
  },
  {
    id: "6",
    value: "entityId",
    label: "Entity",
    placeholder: "Enter Entity",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: false,
    type: "textOnly",
    validations: "textOnly",
  },
  {
    id: "7",
    value: "templateId",
    label: "Template",
    placeholder: "Enter Template",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: false,
    type: "textOnly",
    validations: "textOnly",
  },

  {
    id: "19",
    value: "status",
    label: "Status",
    sort: false,
    editRecord: false,
    viewRecord: true,
    formatter: (cellContent, row) =>
      row.loading ? (
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      ) : (
        <Badge
          className={`font-size-12 badge rounded-pill ${
            row.status && row.status === 1 
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
          }`}
          color={row.badgeclass}
          pill
        >
          {row.status && row.status === 1  ? "Active" : "Inactive"}
        </Badge>
      ),
    type: "text",
  },
  
]

},
},
//Manage Inprogress
{
  schemaId: "bWFuYWdlSW5wcm9ncmVzcw",
  name: 'manageInprogress',
  title: "Manage Inprogress",
  formTitle: "Manage Inprogress",
  path:  "/manage-inprogress",
  visible: true,
  ...bWFuYWdlSW5wcm9ncmVzcw,
  page: 'ManageInprogress',
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
 return[
  {
    id: "1",
    value: "_id",
    label: "Id",
    sort: false,
    editRecord: false,
    viewRecord: false,
    type: "text",
  },
  {
    id: "2",
    value: "sno",
    label: "S.No",
    sort: false,
    csvExport: false,
    editRecord: false,
    viewRecord: true,
    formatter: (cellContent, row, rowIndex) =>
      row.loading ? (
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      ) : (
        rowIndex + 1
      ),
    type: "text",
  },
  {
    id: "3",
    value: "actions",
    label: "Actions",
    sort: false,
    csvExport: false,
    editRecord: false,
    viewRecord: true,
    editFormatter: "actions",
    type: "text",
  },
  {
    id: "6",
    value: "title",
    label: "Title",
    sort: true,
    editRecord: true,
    viewRecord: true,
    placeholder: "Enter Title",
    required: true,
    // validation: false,
    
    type: "textOnly",
    validations: "textOnly",
  },
  {
    id: "6",
    value: "textMessage",
    label: "Message",
    placeholder: "Enter Text Message",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: true,
    // validation: false,
   
    type: "textarea",
    // validations: "textOnly",
  },
  {
    id: "4",
    value: "smsStatus",
    label: "SMS Status",
    placeholder: "Select Status",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: true,
    validation: true,
    
    type: "select",
    options: [
      {
        label: "PENDING",
        value: "PENDING"
      },
      
      {
        label: "APPROVED",
        value: "APPROVED"
      },
      {
        label: "REJECTED",
        value: "REJECTED",
      }
    ],
  },
  {
    id: "6",
    value: "entityId",
    label: "Entity",
    placeholder: "Enter Entity",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: false,
    type: "textOnly",
    validations: "textOnly",
  },
  {
    id: "7",
    value: "templateId",
    label: "Template",
    placeholder: "Enter Template",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: false,
    type: "textOnly",
    validations: "textOnly",
  },

  {
    id: "19",
    value: "status",
    label: "Status",
    sort: false,
    editRecord: false,
    viewRecord: true,
    formatter: (cellContent, row) =>
      row.loading ? (
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      ) : (
        <Badge
          className={`font-size-12 badge rounded-pill ${
            row.status && row.status === 1 
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
          }`}
          color={row.badgeclass}
          pill
        >
          {row.status && row.status === 1  ? "Active" : "Inactive"}
        </Badge>
      ),
    type: "text",
  },
  
]

},
},
{
  schemaId: "ZW1haWxfdGVtcGxhdghj",
  name: 'email',
  title: "Email Template",
  formTitle: "Email Template",
  path:  "/email-template",
  visible: true,
  ...ZW1haWxfdGVtcGxhdghj,
  page: 'EmailTemplate',
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  
 return[
  {
    id: "1",
    value: "_id",
    label: "Id",
    sort: false,
    editRecord: false,
    viewRecord: false,
    type: "text",
  },
  {
    id: "2",
    value: "sno",
    label: "S.No",
    sort: false,
    csvExport: false,
    editRecord: false,
    viewRecord: true,
    formatter: (cellContent, row, rowIndex) =>
      row.loading ? (
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      ) : (
        rowIndex + 1
      ),
    type: "text",
  },
  {
    id: "3",
    value: "actions",
    label: "Actions",
    sort: false,
    csvExport: false,
    editRecord: false,
    viewRecord: true,
    editFormatter: "actions",
    type: "text",
  },
  {
    id: "6",
    value: "title",
    label: "Title",
    sort: true,
    editRecord: true,
    viewRecord: true,
    placeholder: "Enter Title",
    required: true,
    // validation: false,
    
    type: "textOnly",
    validations: "textOnly",
  },
  {
    id: "6",
    value: "textMessage",
    label: "Message",
    placeholder: "Enter Text Message",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: true,
    // validation: false,
   
    type: "textarea",
    // validations: "textOnly",
  },
  {
    id: "4",
    value: "smsStatus",
    label: "SMS Status",
    placeholder: "Select Status",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: true,
    validation: true,
    
    type: "select",
    options: [
      {
        label: "PENDING",
        value: "PENDING"
      },
      
      {
        label: "APPROVED",
        value: "APPROVED"
      },
      {
        label: "REJECTED",
        value: "REJECTED",
      }
    ],
  },
  {
    id: "6",
    value: "entityId",
    label: "Entity",
    placeholder: "Enter Entity",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: false,
    type: "textOnly",
    validations: "textOnly",
  },
  {
    id: "7",
    value: "templateId",
    label: "Template",
    placeholder: "Enter Template",
    sort: true,
    editRecord: true,
    viewRecord: true,
    required: false,
    type: "textOnly",
    validations: "textOnly",
  },

  {
    id: "19",
    value: "status",
    label: "Status",
    sort: false,
    editRecord: false,
    viewRecord: true,
    formatter: (cellContent, row) =>
      row.loading ? (
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      ) : (
        <Badge
          className={`font-size-12 badge rounded-pill ${
            row.status && row.status === 1 
              ? "bg-success badge-soft-success"
              : "bg-danger badge-soft-danger"
          }`}
          color={row.badgeclass}
          pill
        >
          {row.status && row.status === 1  ? "Active" : "Inactive"}
        </Badge>
      ),
    type: "text",
  },
  
]

},
},
//crm manage client

{
  schemaId: "Y3JtTWFuYWdlQ2xpZW50 ",  
  name: "crmManageClient",
  title: "Crm Manage Client",
  path: "/crm-manage-client",
  visible: true,
  formTitle: "Crm Manage Client",
  page: "Crm Manage Client",
  ...Y3JtTWFuYWdlQ2xpZW50 ,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},

{
  schemaId: "Y3JtTXlDbGllbnQ", 
  name: "crmMyClient",
  title: "Crm My Client",
  path: "/crm-my-client",
  visible: true,
  formTitle: "Crm My Client",
  page: "Crm My Client",
  ...Y3JtTXlDbGllbnQ ,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
//crm unassigned

{
  schemaId: "Y3JtVW5Bc3NpZ25lZA",
  name: "crmUnAssigned",
  title: "Crm UnAssigned",
  path: "/crm-unassigned",
  visible: true,
  formTitle: "Crm UnAssigned",
  page: "CrmUnAssigned",
  ...Y3JtVW5Bc3NpZ25lZA,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
 {
    schemaId: "c2F2ZXRoZXBvc3Q",
    name: "savethepost",
    title: "SaveThePost",
    path: "/post-retouch",
    visible: true,
    formTitle: "SaveThePost",
    page: "SaveThePost",
    ...c2F2ZXRoZXBvc3Q,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
 //save video
   {
    schemaId: "c2F2ZXRoZXZpZGVv",
    name: "savethevideo",
    title: "SaveTheVideo",
    path: "/save-video",
    visible: true,
    formTitle: "SaveTheVideo",
    page: "SaveTheVideo",
    ...c2F2ZXRoZXZpZGVv,
    columns: (records = [], metaData) => {
  
      console.log(records, "record from api")
  
      const codeValueMetaData = metaData && metaData.codeOptions
  
      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
 //save photo
{
  schemaId: "c2F2ZXRoZXBob3Rv",
  name: "savethephoto",
  title: "SaveThePhoto",
  path: "/save-photo",
  visible: true,
  formTitle: "SaveThePhoto",
  page: "SaveThePhoto",
  ...c2F2ZXRoZXBob3Rv,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")

    const codeValueMetaData = metaData && metaData.codeOptions

    console.log(codeValueMetaData, "codeValueMetaData")
    return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.code}
            </span>)
        },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  }
},
 {
  schemaId: "ZXF1aXBtZ",
  name: "equipment_type",
  title: "Equipment Type",
  path: "/equipment-type",
  visible: true,
  formTitle: "Equipment Type",
  page: "EquipmentType",
  ...ZXF1aXBtZ,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  return[
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Actions",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "shortCode",
      autofillValue: codeValueMetaData,
      label: "Code",
      placeholder: "Enter Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      // required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.shortCode}
          </span> )
        },
      type: "code",
    },
    {
      id: "5",
      value: "equipmentType",
      label: "Equipment Type",
      placeholder: "Enter Equipment Type ",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.equipmentType}
          </span> )
      },
      type: "text",
      // validations: "textOnly",
    },
     {
      id: "5",
      value: "description",
      label: "Description",
      placeholder: "Enter Description",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.description}
          </span> )
      },
      type: "text",
      // validations: "textOnly",
    },
     {
      id: "6",
      value: "forEC",
      label: "For Ec",
      placeholder: "Enter EC",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: false,
      formatter: (cellContent, row) => {
        return (
          <span style={{ textTransform: "uppercase" }}>
            {row.forEC === true ? "YES" : "NO"}
          </span>)
      },
      type: "checkbox",
      // validations: "textOnly",
    },
    {
      id: "7",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${
              row.status && row.status === 1 
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
            }`}
            color={row.badgeclass}
            pill
          >
            {row.status && row.status === 1  ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]}
},
//Clearance Level 1
{
  schemaId: "Y2xlYXJhbmNlTGV2ZWwx",
  name: "clearanceLevel1",
  title: "Clearance Level 1",
  path: "/clearance-level-1",
  visible: true,
  formTitle: "Clearance Level 1",
  page: "EquipmentType",
  ...Y2xlYXJhbmNlTGV2ZWwx,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  return[
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Actions",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "shortCode",
      autofillValue: codeValueMetaData,
      label: "Code",
      placeholder: "Enter Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      // required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.shortCode}
          </span> )
        },
      type: "code",
    },
    {
      id: "5",
      value: "equipmentType",
      label: "Equipment Type",
      placeholder: "Enter Equipment Type ",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.equipmentType}
          </span> )
      },
      type: "textOnly",
      validations: "textOnly",
    },
     {
      id: "5",
      value: "description",
      label: "Description",
      placeholder: "Enter Description",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.description}
          </span> )
      },
      type: "textOnly",
      validations: "textOnly",
    },
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${
              row.status && row.status === 1 
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
            }`}
            color={row.badgeclass}
            pill
          >
            {row.status && row.status === 1  ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]}
},
{
  schemaId: "Y2xlYXJhbmNl",
  name: 'clearanceLevel2',
  title: 'Clearance Level 2',
  formTitle: 'Clearance Level 2',
  path: '/clearance-level-2',
  visible: true,
  ...Y2xlYXJhbmNl,
  page: 'ClearanceLevel2',
  exact: true,
  columns: (records = [], metaData) => {

    console.log(records, "record from api")
    
    const codeValueMetaData = metaData && metaData.codeOptions
    
 console.log(codeValueMetaData, "codeValueMetaData")
  return[
    {
      id: "1",
      value: "_id",
      label: "Id",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "2",
      value: "sno",
      label: "S.No",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: "text",
    },
    {
      id: "3",
      value: "actions",
      label: "Actions",
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: "actions",
      type: "text",
    },
    {
      id: "4",
      value: "shortCode",
      autofillValue: codeValueMetaData,
      label: "Code",
      placeholder: "Enter Code",
      sort: true,
      editRecord: true,
      viewRecord: true,
      // required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.shortCode}
          </span> )
        },
      type: "code",
    },
    {
      id: "5",
      value: "equipmentType",
      label: "Equipment Type",
      placeholder: "Enter Equipment Type ",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.equipmentType}
          </span> )
      },
      type: "textOnly",
      validations: "textOnly",
    },
     {
      id: "5",
      value: "description",
      label: "Description",
      placeholder: "Enter Description",
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      formatter: (cellContent, row)=> {
        return (
          <span style={{textTransform: "uppercase"}}>
          {row.description}
          </span> )
      },
      type: "textOnly",
      validations: "textOnly",
    },
    {
      id: "6",
      value: "status",
      label: "Status",
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${
              row.status && row.status === 1 
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
            }`}
            color={row.badgeclass}
            pill
          >
            {row.status && row.status === 1  ? "Active" : "Inactive"}
          </Badge>
        ),
      type: "text",
    },
    {
      id: "7",
      value: "branches",
      label: "Branches",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "8",
      value: "insertedBy",
      label: "Inserted By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "9",
      value: "updatedBy",
      label: "Updated By",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "10",
      value: "createdAt",
      label: "Created Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
    {
      id: "11",
      value: "updatedAt",
      label: "Updated Date",
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: "text",
    },
  ]}
},

 ]
 
 export default schemaExt
 